var mi = Object.defineProperty;
var vi = (e, t, r) => t in e ? mi(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var ne = (e, t, r) => vi(e, typeof t != "symbol" ? t + "" : t, r);
import { jsx as s, Fragment as K, jsxs as L } from "react/jsx-runtime";
import * as p from "react";
import pe, { useState as A, createContext as rr, useContext as Je, useMemo as Ze, forwardRef as sa, createElement as Ir, useRef as ar, useCallback as _, useEffect as Re, useLayoutEffect as bi } from "react";
import { tealium as q } from "@rcg/ui-analytics";
import * as ca from "react-dom";
import xi from "react-dom";
var Ci = /* @__PURE__ */ ((e) => (e.INTERIOR = "INTERIOR", e.OUTSIDE = "OUTSIDE", e.BALCONY = "BALCONY", e.DELUXE = "DELUXE", e.AQUA = "AQUA", e.CONCIERGE = "CONCIERGE", e))(Ci || {});
class Ce extends Error {
  constructor(r, a, n) {
    super(r);
    ne(this, "statusCode");
    ne(this, "statusText");
    this.statusCode = a, this.statusText = n;
  }
}
var da = /* @__PURE__ */ ((e) => (e.TEST = "test", e.STAGE = "stage", e.PRODUCTION = "production", e))(da || {}), B = /* @__PURE__ */ ((e) => (e.LEGACY = "legacy", e.REDESIGN = "redesign", e))(B || {});
class xe {
  static getCookieByName(t) {
    if (typeof document > "u")
      return null;
    const a = document.cookie.split(";");
    for (const n of a) {
      const [i, o] = n.split("=");
      if (i.trim() === t)
        return o ? o.trim() : null;
    }
    return null;
  }
  static setCookie(t, r, a) {
    const n = [`${t}=${r}`];
    if (a) {
      const { path: i, secure: o, expires: l } = a;
      if (i && n.push(`path=${i}`), o && n.push("secure"), l) {
        const c = /* @__PURE__ */ new Date();
        c.setTime(c.getTime() + l * 24 * 60 * 60 * 1e3), n.push(`expires=${c.toUTCString()}`);
      }
    }
    document.cookie = n.join("; ");
  }
}
var X;
(function(e) {
  e.RCL = "R", e.CEL = "C";
})(X || (X = {}));
const Ut = {
  R: "royal",
  C: "celebrity"
};
class _e {
}
ne(_e, "isRoyal", (t) => t === X.RCL);
class pa {
  constructor(t) {
    ne(this, "brand");
    ne(this, "locale");
    this.locale = t.locale, this.brand = t.brand;
  }
  getRequestHeaders() {
    return {
      "x-rwd-id": xe.getCookieByName("rwd_id") ?? "",
      "x-vds-id": xe.getCookieByName("VDS_ID") ?? "",
      "x-exp-cart-id": xe.getCookieByName("expCartId") ?? "",
      "x-mcm-id": xe.getCookieByName("MCMID") ?? "",
      "x-consumer-id": (_e.isRoyal(this.brand) ? xe.getCookieByName("consumerID") : xe.getCookieByName("Persist_ConsumerID")) ?? "",
      "x-country": this.locale.country,
      "x-currency": this.locale.currency,
      "x-language": this.locale.code.split("_")[0],
      "x-market": this.locale.market.toString(),
      "x-office": this.locale.office,
      "x-locale": this.locale.code
    };
  }
}
class ga extends pa {
  // TODO: Remove after A/B test
  constructor(r) {
    super(r);
    ne(this, "favorites", {});
    ne(this, "favoritesPromise", null);
    ne(this, "isNew");
  }
  async getFavorites(r = !1) {
    try {
      return (!this.favoritesPromise || r) && (this.favoritesPromise = this.makeApiRequest("/favorites/api/v1/itinerary", {
        method: "GET"
      }).then((a) => (this.isNew = !!a.isNew, this.favorites = this.mapItineraryListResponseToKeyValue(a.itineraries), this.favorites))), await this.favoritesPromise;
    } catch (a) {
      return console.error("Failed to get favorites", { error: a }), this.favoritesPromise = null, {};
    }
  }
  // TODO: Remove after A/B test
  async getExperience() {
    return this.isNew == null && await this.getFavorites(), this.isNew ? B.REDESIGN : B.LEGACY;
  }
  async addFavoriteItinerary(r) {
    try {
      const a = {
        itineraryId: r,
        sailings: []
      };
      await this.makeApiRequest("/favorites/api/v1/itinerary", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify(a)
      }), this.favorites[r.toLowerCase()] = r;
    } catch (a) {
      throw console.error("Failed to add itinerary", { error: a }), a instanceof Ce ? a : new Ce("Unexpected error adding itinerary", 500, "Internal Server Error");
    }
  }
  async removeFavoriteItinerary(r) {
    try {
      await this.makeApiRequest(`/favorites/api/v1/itinerary/${r}`, {
        method: "DELETE"
      }), this.removeFromFavorites(r.toLowerCase());
    } catch (a) {
      throw console.error("Failed to delete itinerary", { error: a }), new Error();
    }
  }
  async addFavoriteStateroom(r, a, n) {
    if (!(n.price === null || n.price === void 0))
      try {
        const i = {
          itineraryId: r,
          price: n.price,
          children: n.children,
          adults: n.adults,
          type: n.type,
          quantity: 1
        }, o = await this.makeApiRequest(
          `/favorites/api/v1/sailings/${a}/staterooms`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(i)
          }
        ), l = this.getStateroomKey(a, n.type);
        this.favorites[l] = o.id;
      } catch (i) {
        throw console.error("Failed to add stateroom", { error: i }), i instanceof Ce ? i : new Ce("Unexpected error adding stateroom", 500, "Internal Server Error");
      }
  }
  async removeFavoriteStateroom(r, a) {
    try {
      const n = this.favorites[a];
      n && (await this.makeApiRequest(`/favorites/api/v1/sailings/${r}/staterooms/${n}`, {
        method: "DELETE"
      }), this.removeFromFavorites(a));
    } catch (n) {
      throw console.error("Failed to delete stateroom", { error: n }), new Error();
    }
  }
  async userMerge() {
    try {
      await this.makeApiRequest("/favorites/api/v1/user/merge", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: "{}"
      });
    } catch (r) {
      console.error("Failed to merge user", { error: r });
    }
  }
  getStateroomKey(r, a) {
    return `${r}_${a}`.toLowerCase();
  }
  async makeApiRequest(r, { body: a, ...n }) {
    const i = this.getRequestHeaders(), o = await fetch(r, {
      method: n.method,
      headers: {
        ...i,
        ...n.headers
      },
      credentials: "include",
      body: a
    });
    if (!o.ok)
      throw new Ce("Failed to make API request", o.status, o.statusText);
    return await o.json();
  }
  removeFromFavorites(r) {
    this.favorites && delete this.favorites[r];
  }
  mapItineraryListResponseToKeyValue(r) {
    return r.reduce((a, n) => {
      const i = n.itineraryId.toLowerCase();
      return a[i] = i, n.sailings.forEach((o) => {
        o.staterooms.forEach((l) => {
          a[this.getStateroomKey(o.sailingId, l.type)] = l.id;
        });
      }), a;
    }, {});
  }
}
const nr = {
  actionGoToDashboard: "Go to Favorites",
  actionContinueBrowsing: "Continue browsing",
  actionSignInAccount: "Sign in to your account",
  actionCreateAnAccount: "Create an account",
  actionFavorites: "Favorites",
  actionResendCode: "Resend code",
  actionContinue: "Continue",
  actionSignInWithEmail: "Sign in with your email",
  actionStartAgain: "Start again",
  actionSignInWithAccount: "Sign in with your account",
  errorEmailAddressVerification: "Invalid email format",
  errorEmailValidationRequest: "There was a problem validating your email. Please try again. If you continue to get this message, try again later.",
  errorOtpVerificationCode: "Incorrect code. Please try again.",
  errorResendOtpCode: "There was a problem resending the code. Please try again.",
  errorValidationCodeRequest: "There was a problem verifying the code. Please try to verify again. If you continue to get this message, try again later.",
  labelEnhancedAuthenticationDefaultTitle: "Sign in or sign up to keep your Favorites",
  labelEnhancedAuthenticationDashboardTitle: "Retrieve your Favorites with your email address or account",
  labelEmailAddress: "Email address",
  labelEmailAddressPlaceholder: "Enter your email address",
  labelOr: "Or",
  labelOtpCodeExpirationTime: "30",
  labelSignedIn: "You’re signed in!",
  labelHello: "Hello",
  labelHowToContinueExploringTheFeature: "You can now check out your Favorites.",
  labelEmailOnlyHowToContinue: "You can now continue browsing, or go directly to your Favorites.",
  labelVerifyEmailAddress: "2-Step Verification",
  labelCodeResent: "Code resent!",
  labelEnsureOwnershipOfTheListOfItems: "Let’s make sure these Favorites are yours.",
  labelEnterTheCode: "Enter the code that we sent to your email.",
  labelExpCodeWarning: "The code expires in 10 minutes.",
  labelGetAnotherCodeIn: "You can get another code in",
  labelHaventReceivedACode: "Haven’t received a code?",
  labelInvalidEmail: "Please enter a valid email",
  labelLimitReachedSubtitle: "Keep saving more of your faves with your email address or sign in to your account.",
  labelLimitReachedTitle: "You’ve reached your Favorites limit",
  labelCleanUpFavorites: "Clean up your Favorites to save more.",
  labelPlaceholderVerificationCode: "Enter your verification code",
  labelVerificationCode: "Verification code",
  labelUnsavedStateroomText: "Save cruise",
  labelUnsavedStateroomTooltip: "Add this stateroom",
  labelHaventReceivedEmail: "If you still haven’t received it, make sure you’re using the right email address and/or check your spam or junk folder.",
  labelTimeIsUp: "Time’s up",
  labelUnsavedItineraryTooltip: "Save this itinerary",
  labelVerificationCodeExpired: "Sorry, the time you had to enter your verification code has expired.",
  labelPrivacyPolicy: 'Also sign up to receive information about our special offers and deals. You can unsubscribe at any time. For more details about how we use your information, view our <a href="https://www.royalcaribbean.com/resources/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.',
  labelSavedFavoritesTooltip: "Saved to",
  labelSavedStateroomHoverText: "Unsave",
  labelSavedStateroomText: "Saved",
  labelSeconds: "seconds.",
  labelOkay: "Okay",
  // TODO: Remove after A/B test
  labelSavedStateroomHoverTextLegacy: "Unwatch",
  labelSavedStateroomTextLegacy: "Watching",
  labelUnsavedStateroomTextLegacy: "Add to Watchlist",
  labelUnsavedStateroomTooltipLegacy: "Watch this sail date",
  actionWatchlistLegacy: "Watchlist",
  labelEnhancedAuthenticationDefaultWatchlistTitle: "Sign in or sign up to keep your Watchlist",
  actionGoToDashboardWatchlist: "Go to Watchlist",
  labelEmailOnlyHowToContinueWatchlist: "You can now continue browsing, or go directly to your Watchlist.",
  labelLimitReachedSTitleWatchlist: "You’ve reached your Watchlist limit",
  labelCleanUpFavoritesWatchlist: "Clean up your Watchlist to save more.",
  labelEnsureOwnershipOfTheListOfItemsWatchlist: "Let’s make sure these Watchlist items are yours."
}, Si = {
  ...nr,
  labelPrivacyPolicy: 'Also sign up to receive information about our special offers and deals. You can unsubscribe at any time. For more information about how we use your information, view our <a href="https://www.celebritycruises.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.'
};
class Vt {
  static isValidEmail(t) {
    return !!String(t).toLowerCase().match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
  }
  static maskEmail(t) {
    if (!this.isValidEmail(t))
      return;
    const [r, a] = t.split("@");
    return (r.length <= 1 ? "*****" : `${r[0]}*****${r.at(-1)}`) + "@" + a;
  }
}
var V = /* @__PURE__ */ ((e) => (e.Interaction = "interaction", e))(V || {}), z = /* @__PURE__ */ ((e) => (e.EmailOnly = "emailOnly", e.Favorite = "favorites", e.FavoriteAbbreviation = "fv", e.GuestAccount = "guestAccount", e))(z || {}), $ = /* @__PURE__ */ ((e) => (e.Browse = "Browse", e.Continue = "Continue", e.CreateAccountModal = "createAccountModal", e.EmailAddress = "EmailAddress", e.GoToFavorites = "GoToFavorites", e.ResendCode = "resendCode", e.SignIn = "SignIn", e.SignInPanelDisplayed = "signInPanelDisplayed", e.SignUp = "SignUp", e.VerificationCode = "VerificationCode", e))($ || {}), ve = /* @__PURE__ */ ((e) => (e.Error = "error", e.Incorrect = "incorrect", e.InvalidEmail = "invalidEmail", e.Success = "success", e.TimesUp = "timesUp", e))(ve || {}), Zt = /* @__PURE__ */ ((e) => (e.SalesforceMarketingCampaign = "sfmc", e))(Zt || {}), Gt = /* @__PURE__ */ ((e) => (e.EmCapPromoRejected = "emCapPromoRejected", e.EmCapPromoSubmit = "emCapPromoSubmit", e))(Gt || {}), fa = /* @__PURE__ */ ((e) => (e.Anonymous = "Anonymous", e))(fa || {}), Ge = /* @__PURE__ */ ((e) => (e.Cruises = "cruises", e.FindACruise = "findacruise", e.FavoritesDashboard = "favorites:dashboard", e))(Ge || {}), je = /* @__PURE__ */ ((e) => (e.CruiseSearch = "cruise-search", e.OneCart = "one-cart", e))(je || {}), ir = /* @__PURE__ */ ((e) => (e.GoToDashboard = "goToDashboard", e.FavoritesLimitReached = "favoritesReachedLimit", e))(ir || {}), jt = /* @__PURE__ */ ((e) => (e.EmailOnly = "email-only", e.GuestAccount = "guest-account", e))(jt || {});
function wi({
  authenticationMethod: e,
  expCartEmail: t,
  interactionEmailOnly: r,
  interactionGuestAccount: a = void 0,
  productFeatureInteraction: n
}) {
  const i = {
    eventType: V.Interaction
  };
  return e === "email-only" && (i.emailAddress = t || "", i.interaction = `${n}:${z.EmailOnly}:${r}`), e === "guest-account" && (i.interaction = `${n}:${z.GuestAccount}:${a ?? r}`), i;
}
class W {
  static getDefaultConfig(t) {
    return {
      country: t.country,
      currency: t.currency,
      language: t.code.split("_")[0]
    };
  }
  static continueOnClick({ email: t, locale: r }) {
    q.trackEvent({
      ...this.getDefaultConfig(r),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.EmailAddress}`,
      emailArea: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.EmailAddress}`,
      emailAddress: t
    });
  }
  static signInOnClick(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignIn}`,
      emailArea: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignIn}`
    });
  }
  static signUpOnClick(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignUp}`,
      emailArea: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignUp}`
    });
  }
  static createAccountModalLoad({
    brand: t,
    locale: r,
    variation: a
  }) {
    q.trackEvent({
      ...this.getDefaultConfig(r),
      appName: a === "dashboard" ? je.OneCart : je.CruiseSearch,
      brand: t,
      loginStatus: "Anonymous",
      pageName: "guestaccount:create-account modal",
      platform: "web",
      siteSection: a === "dashboard" ? Ge.FavoritesDashboard : Ge.FindACruise,
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignUp}:${$.CreateAccountModal}`
    });
  }
  static successfulLogin({
    authenticationMethod: t,
    locale: r,
    expCartEmail: a
  }) {
    q.trackEvent({
      ...this.getDefaultConfig(r),
      ...wi({
        authenticationMethod: t,
        expCartEmail: a,
        interactionEmailOnly: `${$.VerificationCode}:${ve.Success}`,
        interactionGuestAccount: ve.Success,
        productFeatureInteraction: z.FavoriteAbbreviation
      })
    });
  }
  static loginRequestSuccessful({
    locale: t,
    maskedEmail: r
  }) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      emailArea: `${Zt.SalesforceMarketingCampaign}:${Gt.EmCapPromoSubmit}:${z.FavoriteAbbreviation}:${z.EmailOnly}`,
      eventType: V.Interaction,
      interaction: `${Zt.SalesforceMarketingCampaign}:${Gt.EmCapPromoSubmit}:${z.FavoriteAbbreviation}:${z.EmailOnly}`,
      emailAddress: r
    });
  }
  static resendOtpCodeRequestSuccessful(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.ResendCode}`
    });
  }
  static resendOtpCodeRequestFailed(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.VerificationCode}:${ve.Error}`
    });
  }
  static otpCodeRequestFailed(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.VerificationCode}:${ve.Error}`
    });
  }
  static invalidOtpCode(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.VerificationCode}:${ve.Incorrect}`
    });
  }
  static otpCodeExpired(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.VerificationCode}:${ve.TimesUp}`
    });
  }
  static emailFormError(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.EmailAddress}:${ve.InvalidEmail}`
    });
  }
  // TODO: Remove after A/B test
  static favoritesReachedLimit(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${ir.FavoritesLimitReached}`
    });
  }
  static signInPanelDisplayed(t) {
    q.trackEvent({
      ...this.getDefaultConfig(t),
      eventType: V.Interaction,
      interaction: `${z.FavoriteAbbreviation}:${z.EmailOnly}:${$.SignInPanelDisplayed}`
    });
  }
}
class Ei {
  static tooltipFavoritesDashboardLink(t) {
    q.trackEvent({
      country: t.country,
      currency: t.currency,
      language: t.language,
      eventType: V.Interaction,
      interaction: `${z.Favorite}:${ir.GoToDashboard}`
    });
  }
}
class Li extends Error {
  constructor(t) {
    super(t), this.name = "ConnectionError";
  }
}
class ua extends Error {
  constructor(t) {
    super(t), this.name = "OtpExpired";
  }
}
class ha extends Error {
  constructor(t) {
    super(t), this.name = "InvalidEmailOrCode";
  }
}
var yt = /* @__PURE__ */ ((e) => (e.SUCCESS = "SUCCESS", e.OTP_CODE_REQUIRED = "OTP_CODE_REQUIRED", e))(yt || {});
class ya extends pa {
  constructor(r) {
    super(r);
    ne(this, "_email", "");
    ne(this, "_optInData", null);
  }
  get maskedEmail() {
    return Vt.maskEmail(this._email);
  }
  async login(r, a) {
    this._optInData = a, this._email = r;
    const n = await this.request("/favorites/api/v1/identity/login", {
      method: "POST",
      headers: {
        "x-email": r,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(a)
    });
    return W.loginRequestSuccessful({
      locale: this.locale,
      maskedEmail: this.maskedEmail
    }), n.expCartId ? (W.successfulLogin({
      authenticationMethod: jt.EmailOnly,
      locale: this.locale,
      expCartEmail: this.maskedEmail
    }), {
      loginState: yt.SUCCESS,
      // TODO: Remove after A/B test
      variation: n.isNew ? B.REDESIGN : B.LEGACY
    }) : { loginState: yt.OTP_CODE_REQUIRED };
  }
  async resendCode() {
    await this.request("/favorites/api/v1/identity/login", {
      method: "POST",
      headers: {
        "x-email": this._email,
        "Content-Type": "application/json"
      },
      body: JSON.stringify(this._optInData)
    });
  }
  async validateOtpCode(r) {
    const a = { code: r }, n = await this.request(
      "/favorites/api/v1/identity/validate",
      {
        method: "POST",
        headers: {
          "x-email": this._email,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(a)
      }
    );
    return W.continueOnClick({
      email: this._email,
      locale: this.locale
    }), n.expCartId && W.successfulLogin({
      authenticationMethod: jt.EmailOnly,
      locale: this.locale,
      expCartEmail: this.maskedEmail
    }), n.isNew ? B.REDESIGN : B.LEGACY;
  }
  async request(r, a) {
    const n = this.getRequestHeaders(), i = await fetch(r, {
      method: a.method,
      headers: {
        ...n,
        ...a.headers
      },
      body: a.body
    });
    return i.ok || this.handleErrors(i.status), await i.json();
  }
  handleErrors(r) {
    throw r === 400 ? new ha("Invalid email or code") : r === 409 ? new ua("OTP Expired!") : new Li("Failed to make API request");
  }
}
var R = { palette: { surface: { primary: "var(--palette-bg-primary)", secondary: "var(--palette-bg-secondary)", footer: "var(--palette-bg-footer)" }, stepper: { surface: { current: "var(--palette-stepper-surface-current)", completed: "var(--palette-stepper-surface-completed)", disabled: "var(--palette-stepper-surface-disabled)" }, text: { current: "var(--palette-stepper-text-current)", disabled: "var(--palette-stepper-text-disabled)" } }, container: { primary: "var(--palette-container-primary)", primaryAlphaDark: "var(--palette-container-primary-alpha-dark)", secondary: "var(--palette-container-secondary)", secondaryAlphaDark: "var(--palette-container-secondary-alpha-dark)", brand: "var(--palette-container-brand)", accent: "var(--palette-container-accent)", error: "var(--palette-container-error)", success: "var(--palette-container-success)", warning: "var(--palette-container-warning)" }, subtle: { primary: "var(--palette-subtle-primary)", accent: "var(--palette-subtle-accent)", brand: "var(--palette-subtle-brand)", positive: "var(--palette-subtle-positive)", negative: "var(--palette-subtle-negative)" }, text: { dark: { body: "var(--palette-text-dark-body)", weaker: "var(--palette-text-dark-weaker)", brand: "var(--palette-text-dark-brand)" }, light: { reversed: "var(--palette-text-light-reversed)", weaker: "var(--palette-text-light-weaker)" }, action: { accent: "var(--palette-text-action-accent)", hover: "var(--palette-text-action-hover)", visited: "var(--palette-text-action-visited)", fontFamily: "var(--palette-text-action-font-family)", textDecoration: "var(--palette-text-action-text-decoration)" }, status: { disabled: "var(--palette-text-status-disabled)", error: "var(--palette-text-status-error)", success: "var(--palette-text-status-success)", promo: "var(--palette-text-status-promo)", warning: "var(--palette-text-status-warning)", info: "var(--palette-text-status-info)" } }, icon: { body: "var(--palette-icon-body)", brand: "var(--palette-icon-brand)", brandLogo: "var(--palette-icon-brand-logo)", reversed: "var(--palette-icon-reversed)", accent: "var(--palette-icon-accent)", accentHover: "var(--palette-icon-accent-hover)", disabled: "var(--palette-icon-disabled)", error: "var(--palette-icon-error)", success: "var(--palette-icon-success)", info: "var(--palette-icon-info)", warning: "var(--palette-icon-warning)", promo: "var(--palette-icon-promo)" }, border: { divider: "var(--palette-border-divider)", dividerRaised: "var(--palette-border-divider-raised)", dividerFooter: "var(--palette-border-divider-footer)", accent: "var(--palette-border-accent)", brand: "var(--palette-border-brand)", special: "var(--palette-border-special)", focus: "var(--palette-border-focus)", error: "var(--palette-border-error)", errorDark: "var(--palette-border-error-dark)", success: "var(--palette-border-success)", successDark: "var(--palette-border-success-dark)", info: "var(--palette-border-info)", infoDark: "var(--palette-border-info-dark)", warning: "var(--palette-border-warning)", warningDark: "var(--palette-border-warning-dark)", promo: "var(--palette-border-promo)" }, button: { outline: "var(--palette-button-outline)", primary: { default: "var(--palette-button-primary-default)", hover: "var(--palette-button-primary-hover)", pressed: "var(--palette-button-primary-pressed)", disabled: "var(--palette-button-primary-disabled)", border: "var(--palette-button-primary-border)", text: "var(--palette-button-primary-text)", disabledText: "var(--palette-button-primary-disabled-text)", disabledBorder: "var(--palette-button-primary-disabled-border)" }, secondary: { default: "var(--palette-button-secondary-default)", hover: "var(--palette-button-secondary-hover)", pressed: "var(--palette-button-secondary-pressed)", disabled: "var(--palette-button-secondary-disabled)", border: "var(--palette-button-secondary-border)", text: "var(--palette-button-secondary-text)", disabledText: "var(--palette-button-secondary-disabled-text)", disabledBorder: "var(--palette-button-secondary-disabled-border)" }, ghost: { default: "var(--palette-button-ghost-default)", hover: "var(--palette-button-ghost-hover)", pressed: "var(--palette-button-ghost-pressed)", disabled: "var(--palette-button-ghost-disabled)", border: "var(--palette-button-ghost-border)", text: "var(--palette-button-ghost-text)", disabledText: "var(--palette-button-ghost-disabled-text)", disabledBorder: "var(--palette-button-ghost-disabled-border)" }, special: { default: "var(--palette-button-special-default)", hover: "var(--palette-button-special-hover)", pressed: "var(--palette-button-special-pressed)", disabled: "var(--palette-button-special-disabled)", border: "var(--palette-button-special-border)", text: "var(--palette-button-special-text)", disabledText: "var(--palette-button-special-disabled-text)", disabledBorder: "var(--palette-button-special-disabled-border)" } }, form: { surface: { default: "var(--palette-form-bg-default)", disabled: "var(--palette-form-bg-disabled)" }, text: { label: "var(--palette-form-text-label)", placeholder: "var(--palette-form-text-placeholder)", active: "var(--palette-form-text-active)", error: "var(--palette-form-text-error)" }, icon: { default: "var(--palette-form-icon-default)", accent: "var(--palette-form-icon-accent)", error: "var(--palette-form-icon-error)", disabled: "var(--palette-form-icon-disabled)" }, border: { default: "var(--palette-form-border-default)", active: "var(--palette-form-border-active)", error: "var(--palette-form-border-error)" } }, selector: { surface: { default: "var(--palette-selector-surface-default)", subtle: "var(--palette-selector-surface-subtle)", subtleHover: "var(--palette-selector-surface-subtile-hover)", hover: "var(--palette-selector-surface-hover)", active: "var(--palette-selector-surface-active)", selected: "var(--palette-selector-surface-selected)", disabled: "var(--palette-selector-surface-disabled)", disabledSelected: "var(--palette-selector-surface-disabled-selected)" }, text: { accent: "var(--palette-selector-text-accent)", default: "var(--palette-selector-text-default)", disabled: "var(--palette-selector-text-disabled)", disabledSecondary: "var(--palette-selector-text-disabled-secondary)", reversed: "var(--palette-selector-text-reversed)" }, icon: { accent: "var(--palette-selector-icon-accent)", default: "var(--palette-selector-icon-default)", disabled: "var(--palette-selector-icon-disabled)", disabledSecondary: "var(--palette-selector-icon-disabled-secondary)", reversed: "var(--palette-selector-icon-reversed)" }, border: { default: "var(--palette-selector-border-default)", accent: "var(--palette-selector-border-accent)", disabled: "var(--palette-selector-border-disabled)" } }, badge: { surface: { promotion: "var(--palette-badge-surface-promotion)", highlight: "var(--palette-badge-surface-highlight)", feature: "var(--palette-badge-surface-feature)", casinoRoyale: "var(--palette-badge-surface-casino-royale)" }, border: { promotion: "var(--palette-badge-border-promotion)", hightlight: "var(--palette-badge-border-highlight)", feature: "var(--palette-badge-border-feature)", casinoRoyale: "var(--palette-badge-border-casino-royale)" }, text: { promotion: "var(--palette-badge-text-promotion)", highlight: "var(--palette-badge-text-highlight)", feature: "var(--palette-badge-text-feature)", casinoRoyale: "var(--palette-badge-text-casino-royale)" } } }, button: { textTransform: "var(--button-text-transform)", borderRadius: "var(--button-border-radius)", size: { lg: { padding: "var(--button-size-lg-padding)", iconSize: "var(--button-size-lg-icon-size)", gap: "var(--button-size-lg-gap)" }, md: { padding: "var(--button-size-md-padding)", iconSize: "var(--button-size-md-icon-size)", gap: "var(--button-size-md-gap)" }, sm: { padding: "var(--button-size-sm-padding)", iconSize: "var(--button-size-sm-icon-size)", gap: "var(--button-size-sm-gap)" } }, sizeGhost: { lg: { padding: "var(--button-size-ghost-lg-padding)", iconSize: "var(--button-size-ghost-lg-icon-size)", gap: "var(--button-size-ghost-lg-gap)" }, md: { padding: "var(--button-size-ghost-md-padding)", iconSize: "var(--button-size-ghost-md-icon-size)", gap: "var(--button-size-ghost-md-gap)" }, sm: { padding: "var(--button-size-ghost-sm-padding)", iconSize: "var(--button-size-ghost-sm-icon-size)", gap: "var(--button-size-ghost-sm-gap)" } } }, shadow: { box: "var(--shadow-box)", tooltip: "var(--shadow-tooltip)", stickyFooter: "var(--shadow-sticky-footer)", raised: { small: "var(--shadow-raised-small)", medium: "var(--shadow-raised-medium)", large: "var(--shadow-raised-large)", xlarge: "var(--shadow-raised-xlarge)" }, surface: { upper: { small: "var(--shadow-surface-upper-small)", medium: "var(--shadow-surface-upper-medium)", large: "var(--shadow-surface-upper-large)" }, bottom: { small: "var(--shadow-surface-bottom-small)", medium: "var(--shadow-surface-bottom-medium)", large: "var(--shadow-surface-bottom-large)" }, left: { small: "var(--shadow-surface-left-small)", medium: "var(--shadow-surface-left-medium)", large: "var(--shadow-surface-left-large)" }, right: { small: "var(--shadow-surface-right-small)", medium: "var(--shadow-surface-right-medium)", large: "var(--shadow-surface-right-large)" } } }, gradiants: { linear: "var(--gradiants-linear)" }, borderRadius: { xs: "var(--border-radius-xs)", small: "var(--border-radius-small)", medium: "var(--border-radius-medium)", large: "var(--border-radius-large)", xlarge: "var(--border-radius-xlarge)" }, spacing: { 0: "var(--spacing-0)", 1: "var(--spacing-1)", 2: "var(--spacing-2)", 3: "var(--spacing-3)", 4: "var(--spacing-4)", 5: "var(--spacing-5)", 6: "var(--spacing-6)", 7: "var(--spacing-7)", 8: "var(--spacing-8)", 9: "var(--spacing-9)", 10: "var(--spacing-10)", 11: "var(--spacing-11)", 12: "var(--spacing-12)", 13: "var(--spacing-13)", 14: "var(--spacing-14)", 15: "var(--spacing-15)", 16: "var(--spacing-16)" }, typography: { xs: { headline: { 1: { fontFamily: "var(--typography-xs-headline-1-font-family)", fontSize: "var(--typography-xs-headline-1-font-size)", lineHeight: "var(--typography-xs-headline-1-line-height)", letterSpacing: "var(--typography-xs-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-xs-heading-1-font-family)", fontSize: "var(--typography-xs-heading-1-font-size)", lineHeight: "var(--typography-xs-heading-1-line-height)", letterSpacing: "var(--typography-xs-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-xs-heading-2-font-family)", fontSize: "var(--typography-xs-heading-2-font-size)", lineHeight: "var(--typography-xs-heading-2-line-height)", letterSpacing: "var(--typography-xs-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-xs-heading-3-font-family)", fontSize: "var(--typography-xs-heading-3-font-size)", lineHeight: "var(--typography-xs-heading-3-line-height)", letterSpacing: "var(--typography-xs-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-xs-heading-4-font-family)", fontSize: "var(--typography-xs-heading-4-font-size)", lineHeight: "var(--typography-xs-heading-4-line-height)", letterSpacing: "var(--typography-xs-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-xs-display-big-semi-font-family)", fontSize: "var(--typography-xs-display-big-semi-font-size)", lineHeight: "var(--typography-xs-display-big-semi-line-height)", letterSpacing: "var(--typography-xs-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-xs-display-med-semi-font-family)", fontSize: "var(--typography-xs-display-med-semi-font-size)", lineHeight: "var(--typography-xs-display-med-semi-line-height)", letterSpacing: "var(--typography-xs-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-xs-display-med-reg-font-family)", fontSize: "var(--typography-xs-display-med-reg-font-size)", lineHeight: "var(--typography-xs-display-med-reg-line-height)", letterSpacing: "var(--typography-xs-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-display-small-semi-font-family)", fontSize: "var(--typography-xs-display-small-semi-font-size)", lineHeight: "var(--typography-xs-display-small-semi-line-height)", letterSpacing: "var(--typography-xs-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-xs-display-small-reg-font-family)", fontSize: "var(--typography-xs-display-small-reg-font-size)", lineHeight: "var(--typography-xs-display-small-reg-line-height)", letterSpacing: "var(--typography-xs-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-xs-body-big-bold-font-family)", fontSize: "var(--typography-xs-body-big-bold-font-size)", lineHeight: "var(--typography-xs-body-big-bold-line-height)", letterSpacing: "var(--typography-xs-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-xs-body-bold-font-family)", fontSize: "var(--typography-xs-body-bold-font-size)", lineHeight: "var(--typography-xs-body-bold-line-height)", letterSpacing: "var(--typography-xs-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-xs-body-semi-font-family)", fontSize: "var(--typography-xs-body-semi-font-size)", lineHeight: "var(--typography-xs-body-semi-line-height)", letterSpacing: "var(--typography-xs-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-body-reg-font-family)", fontSize: "var(--typography-xs-body-reg-font-size)", lineHeight: "var(--typography-xs-body-reg-line-height)", letterSpacing: "var(--typography-xs-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-xs-body-link-font-family)", fontSize: "var(--typography-xs-body-link-font-size)", lineHeight: "var(--typography-xs-body-link-line-height)", letterSpacing: "var(--typography-xs-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-xs-subtext-semi-font-family)", fontSize: "var(--typography-xs-subtext-semi-font-size)", lineHeight: "var(--typography-xs-subtext-semi-line-height)", letterSpacing: "var(--typography-xs-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-subtext-reg-font-family)", fontSize: "var(--typography-xs-subtext-reg-font-size)", lineHeight: "var(--typography-xs-subtext-reg-line-height)", letterSpacing: "var(--typography-xs-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-xs-subtext-link-font-family)", fontSize: "var(--typography-xs-subtext-link-font-size)", lineHeight: "var(--typography-xs-subtext-link-line-height)", letterSpacing: "var(--typography-xs-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-xs-button-semi-font-family)", fontSize: "var(--typography-xs-button-semi-font-size)", lineHeight: "var(--typography-xs-button-semi-line-height)", letterSpacing: "var(--typography-xs-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-button-small-semi-font-family)", fontSize: "var(--typography-xs-button-small-semi-font-size)", lineHeight: "var(--typography-xs-button-small-semi-line-height)", letterSpacing: "var(--typography-xs-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-xs-standlink-big-semi-font-family)", fontSize: "var(--typography-xs-standlink-big-semi-font-size)", lineHeight: "var(--typography-xs-standlink-big-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-xs-standlink-med-semi-font-family)", fontSize: "var(--typography-xs-standlink-med-semi-font-size)", lineHeight: "var(--typography-xs-standlink-med-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-standlink-small-semi-font-family)", fontSize: "var(--typography-xs-standlink-small-semi-font-size)", lineHeight: "var(--typography-xs-standlink-small-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-xs-label-semi-font-family)", fontSize: "var(--typography-xs-label-semi-font-size)", lineHeight: "var(--typography-xs-label-semi-line-height)", letterSpacing: "var(--typography-xs-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-label-small-semi-font-family)", fontSize: "var(--typography-xs-label-small-semi-font-size)", lineHeight: "var(--typography-xs-label-small-semi-line-height)", letterSpacing: "var(--typography-xs-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-xs-label-small-reg-font-family)", fontSize: "var(--typography-xs-label-small-reg-font-size)", lineHeight: "var(--typography-xs-label-small-reg-line-height)", letterSpacing: "var(--typography-xs-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-xs-placeholder-reg-font-family)", fontSize: "var(--typography-xs-placeholder-reg-font-size)", lineHeight: "var(--typography-xs-placeholder-reg-line-height)", letterSpacing: "var(--typography-xs-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-xs-caption-bold-font-family)", fontSize: "var(--typography-xs-caption-bold-font-size)", lineHeight: "var(--typography-xs-caption-bold-line-height)", letterSpacing: "var(--typography-xs-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-caption-reg-font-family)", fontSize: "var(--typography-xs-caption-reg-font-size)", lineHeight: "var(--typography-xs-caption-reg-line-height)", letterSpacing: "var(--typography-xs-caption-reg-letter-spacing)" } } }, md: { headline: { 1: { fontFamily: "var(--typography-md-headline-1-font-family)", fontSize: "var(--typography-md-headline-1-font-size)", lineHeight: "var(--typography-md-headline-1-line-height)", letterSpacing: "var(--typography-md-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-md-heading-1-font-family)", fontSize: "var(--typography-md-heading-1-font-size)", lineHeight: "var(--typography-md-heading-1-line-height)", letterSpacing: "var(--typography-md-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-md-heading-2-font-family)", fontSize: "var(--typography-md-heading-2-font-size)", lineHeight: "var(--typography-md-heading-2-line-height)", letterSpacing: "var(--typography-md-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-md-heading-3-font-family)", fontSize: "var(--typography-md-heading-3-font-size)", lineHeight: "var(--typography-md-heading-3-line-height)", letterSpacing: "var(--typography-md-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-md-heading-4-font-family)", fontSize: "var(--typography-md-heading-4-font-size)", lineHeight: "var(--typography-md-heading-4-line-height)", letterSpacing: "var(--typography-md-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-md-display-big-semi-font-family)", fontSize: "var(--typography-md-display-big-semi-font-size)", lineHeight: "var(--typography-md-display-big-semi-line-height)", letterSpacing: "var(--typography-md-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-md-display-med-semi-font-family)", fontSize: "var(--typography-md-display-med-semi-font-size)", lineHeight: "var(--typography-md-display-med-semi-line-height)", letterSpacing: "var(--typography-md-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-md-display-med-reg-font-family)", fontSize: "var(--typography-md-display-med-reg-font-size)", lineHeight: "var(--typography-md-display-med-reg-line-height)", letterSpacing: "var(--typography-md-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-display-small-semi-font-family)", fontSize: "var(--typography-md-display-small-semi-font-size)", lineHeight: "var(--typography-md-display-small-semi-line-height)", letterSpacing: "var(--typography-md-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-md-display-small-reg-font-family)", fontSize: "var(--typography-md-display-small-reg-font-size)", lineHeight: "var(--typography-md-display-small-reg-line-height)", letterSpacing: "var(--typography-md-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-md-body-big-bold-font-family)", fontSize: "var(--typography-md-body-big-bold-font-size)", lineHeight: "var(--typography-md-body-big-bold-line-height)", letterSpacing: "var(--typography-md-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-md-body-bold-font-family)", fontSize: "var(--typography-md-body-bold-font-size)", lineHeight: "var(--typography-md-body-bold-line-height)", letterSpacing: "var(--typography-md-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-md-body-semi-font-family)", fontSize: "var(--typography-md-body-semi-font-size)", lineHeight: "var(--typography-md-body-semi-line-height)", letterSpacing: "var(--typography-md-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-body-reg-font-family)", fontSize: "var(--typography-md-body-reg-font-size)", lineHeight: "var(--typography-md-body-reg-line-height)", letterSpacing: "var(--typography-md-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-md-body-link-font-family)", fontSize: "var(--typography-md-body-link-font-size)", lineHeight: "var(--typography-md-body-link-line-height)", letterSpacing: "var(--typography-md-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-md-subtext-semi-font-family)", fontSize: "var(--typography-md-subtext-semi-font-size)", lineHeight: "var(--typography-md-subtext-semi-line-height)", letterSpacing: "var(--typography-md-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-subtext-reg-font-family)", fontSize: "var(--typography-md-subtext-reg-font-size)", lineHeight: "var(--typography-md-subtext-reg-line-height)", letterSpacing: "var(--typography-md-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-md-subtext-link-font-family)", fontSize: "var(--typography-md-subtext-link-font-size)", lineHeight: "var(--typography-md-subtext-link-line-height)", letterSpacing: "var(--typography-md-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-md-button-semi-font-family)", fontSize: "var(--typography-md-button-semi-font-size)", lineHeight: "var(--typography-md-button-semi-line-height)", letterSpacing: "var(--typography-md-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-button-small-semi-font-family)", fontSize: "var(--typography-md-button-small-semi-font-size)", lineHeight: "var(--typography-md-button-small-semi-line-height)", letterSpacing: "var(--typography-md-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-md-standlink-big-semi-font-family)", fontSize: "var(--typography-md-standlink-big-semi-font-size)", lineHeight: "var(--typography-md-standlink-big-semi-line-height)", letterSpacing: "var(--typography-md-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-md-standlink-med-semi-font-family)", fontSize: "var(--typography-md-standlink-med-semi-font-size)", lineHeight: "var(--typography-md-standlink-med-semi-line-height)", letterSpacing: "var(--typography-md-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-standlink-small-semi-font-family)", fontSize: "var(--typography-md-standlink-small-semi-font-size)", lineHeight: "var(--typography-md-standlink-small-semi-line-height)", letterSpacing: "var(--typography-md-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-md-label-semi-font-family)", fontSize: "var(--typography-md-label-semi-font-size)", lineHeight: "var(--typography-md-label-semi-line-height)", letterSpacing: "var(--typography-md-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-label-small-semi-font-family)", fontSize: "var(--typography-md-label-small-semi-font-size)", lineHeight: "var(--typography-md-label-small-semi-line-height)", letterSpacing: "var(--typography-md-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-md-label-small-reg-font-family)", fontSize: "var(--typography-md-label-small-reg-font-size)", lineHeight: "var(--typography-md-label-small-reg-line-height)", letterSpacing: "var(--typography-md-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-md-placeholder-reg-font-family)", fontSize: "var(--typography-md-placeholder-reg-font-size)", lineHeight: "var(--typography-md-placeholder-reg-line-height)", letterSpacing: "var(--typography-md-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-md-caption-bold-font-family)", fontSize: "var(--typography-md-caption-bold-font-size)", lineHeight: "var(--typography-md-caption-bold-line-height)", letterSpacing: "var(--typography-md-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-caption-reg-font-family)", fontSize: "var(--typography-md-caption-reg-font-size)", lineHeight: "var(--typography-md-caption-reg-line-height)", letterSpacing: "var(--typography-md-caption-reg-letter-spacing)" } } }, lg: { headline: { 1: { fontFamily: "var(--typography-lg-headline-1-font-family)", fontSize: "var(--typography-lg-headline-1-font-size)", lineHeight: "var(--typography-lg-headline-1-line-height)", letterSpacing: "var(--typography-lg-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-lg-heading-1-font-family)", fontSize: "var(--typography-lg-heading-1-font-size)", lineHeight: "var(--typography-lg-heading-1-line-height)", letterSpacing: "var(--typography-lg-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-lg-heading-2-font-family)", fontSize: "var(--typography-lg-heading-2-font-size)", lineHeight: "var(--typography-lg-heading-2-line-height)", letterSpacing: "var(--typography-lg-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-lg-heading-3-font-family)", fontSize: "var(--typography-lg-heading-3-font-size)", lineHeight: "var(--typography-lg-heading-3-line-height)", letterSpacing: "var(--typography-lg-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-lg-heading-4-font-family)", fontSize: "var(--typography-lg-heading-4-font-size)", lineHeight: "var(--typography-lg-heading-4-line-height)", letterSpacing: "var(--typography-lg-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-lg-display-big-semi-font-family)", fontSize: "var(--typography-lg-display-big-semi-font-size)", lineHeight: "var(--typography-lg-display-big-semi-line-height)", letterSpacing: "var(--typography-lg-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-lg-display-med-semi-font-family)", fontSize: "var(--typography-lg-display-med-semi-font-size)", lineHeight: "var(--typography-lg-display-med-semi-line-height)", letterSpacing: "var(--typography-lg-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-lg-display-med-reg-font-family)", fontSize: "var(--typography-lg-display-med-reg-font-size)", lineHeight: "var(--typography-lg-display-med-reg-line-height)", letterSpacing: "var(--typography-lg-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-display-small-semi-font-family)", fontSize: "var(--typography-lg-display-small-semi-font-size)", lineHeight: "var(--typography-lg-display-small-semi-line-height)", letterSpacing: "var(--typography-lg-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-lg-display-small-reg-font-family)", fontSize: "var(--typography-lg-display-small-reg-font-size)", lineHeight: "var(--typography-lg-display-small-reg-line-height)", letterSpacing: "var(--typography-lg-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-lg-body-big-bold-font-family)", fontSize: "var(--typography-lg-body-big-bold-font-size)", lineHeight: "var(--typography-lg-body-big-bold-line-height)", letterSpacing: "var(--typography-lg-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-lg-body-bold-font-family)", fontSize: "var(--typography-lg-body-bold-font-size)", lineHeight: "var(--typography-lg-body-bold-line-height)", letterSpacing: "var(--typography-lg-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-lg-body-semi-font-family)", fontSize: "var(--typography-lg-body-semi-font-size)", lineHeight: "var(--typography-lg-body-semi-line-height)", letterSpacing: "var(--typography-lg-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-body-reg-font-family)", fontSize: "var(--typography-lg-body-reg-font-size)", lineHeight: "var(--typography-lg-body-reg-line-height)", letterSpacing: "var(--typography-lg-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-lg-body-link-font-family)", fontSize: "var(--typography-lg-body-link-font-size)", lineHeight: "var(--typography-lg-body-link-line-height)", letterSpacing: "var(--typography-lg-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-lg-subtext-semi-font-family)", fontSize: "var(--typography-lg-subtext-semi-font-size)", lineHeight: "var(--typography-lg-subtext-semi-line-height)", letterSpacing: "var(--typography-lg-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-subtext-reg-font-family)", fontSize: "var(--typography-lg-subtext-reg-font-size)", lineHeight: "var(--typography-lg-subtext-reg-line-height)", letterSpacing: "var(--typography-lg-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-lg-subtext-link-font-family)", fontSize: "var(--typography-lg-subtext-link-font-size)", lineHeight: "var(--typography-lg-subtext-link-line-height)", letterSpacing: "var(--typography-lg-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-lg-button-semi-font-family)", fontSize: "var(--typography-lg-button-semi-font-size)", lineHeight: "var(--typography-lg-button-semi-line-height)", letterSpacing: "var(--typography-lg-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-button-small-semi-font-family)", fontSize: "var(--typography-lg-button-small-semi-font-size)", lineHeight: "var(--typography-lg-button-small-semi-line-height)", letterSpacing: "var(--typography-lg-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-lg-standlink-big-semi-font-family)", fontSize: "var(--typography-lg-standlink-big-semi-font-size)", lineHeight: "var(--typography-lg-standlink-big-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-lg-standlink-med-semi-font-family)", fontSize: "var(--typography-lg-standlink-med-semi-font-size)", lineHeight: "var(--typography-lg-standlink-med-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-standlink-small-semi-font-family)", fontSize: "var(--typography-lg-standlink-small-semi-font-size)", lineHeight: "var(--typography-lg-standlink-small-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-lg-label-semi-font-family)", fontSize: "var(--typography-lg-label-semi-font-size)", lineHeight: "var(--typography-lg-label-semi-line-height)", letterSpacing: "var(--typography-lg-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-label-small-semi-font-family)", fontSize: "var(--typography-lg-label-small-semi-font-size)", lineHeight: "var(--typography-lg-label-small-semi-line-height)", letterSpacing: "var(--typography-lg-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-lg-label-small-reg-font-family)", fontSize: "var(--typography-lg-label-small-reg-font-size)", lineHeight: "var(--typography-lg-label-small-reg-line-height)", letterSpacing: "var(--typography-lg-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-lg-placeholder-reg-font-family)", fontSize: "var(--typography-lg-placeholder-reg-font-size)", lineHeight: "var(--typography-lg-placeholder-reg-line-height)", letterSpacing: "var(--typography-lg-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-lg-caption-bold-font-family)", fontSize: "var(--typography-lg-caption-bold-font-size)", lineHeight: "var(--typography-lg-caption-bold-line-height)", letterSpacing: "var(--typography-lg-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-caption-reg-font-family)", fontSize: "var(--typography-lg-caption-reg-font-size)", lineHeight: "var(--typography-lg-caption-reg-line-height)", letterSpacing: "var(--typography-lg-caption-reg-letter-spacing)" } } }, size: { 0: "var(--typography-size-0)", 1: "var(--typography-size-1)", 2: "var(--typography-size-2)", 3: "var(--typography-size-3)", 4: "var(--typography-size-4)", 5: "var(--typography-size-5)", 6: "var(--typography-size-6)", 7: "var(--typography-size-7)", 8: "var(--typography-size-8)", 9: "var(--typography-size-9)", 10: "var(--typography-size-10)", 11: "var(--typography-size-11)", 12: "var(--typography-size-12)", 13: "var(--typography-size-13)" }, font: { regular: "var(--typography-font-regular)", semiBold: "var(--typography-font-semi-bold)", bold: "var(--typography-font-bold)", secondary: "var(--typography-font-secondary)" }, fontFeatureSettings: "var(--typography-font-feature-settings)", fontWeight: { light: "var(--typography-font-weight-light)", normal: "var(--typography-font-weight-normal)", semiBold: "var(--typography-font-weight-semiBold)", bold: "var(--typography-font-weight-bold)" } } };
const ki = ({ brand: e, size: t, fill: r = R.palette.icon.accent, className: a, ...n }) => {
  const i = s("svg", { role: "icon", "data-testid": "close-rcl-stroke", className: a, width: t, height: t, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: s("path", { d: "M7.6826 5.46026C7.06892 4.84658 6.07394 4.84658 5.46026 5.46026C4.84658 6.07394 4.84658 7.06892 5.46026 7.6826L13.7777 16L5.46026 24.3174C4.84658 24.9311 4.84658 25.9261 5.46026 26.5397C6.07394 27.1534 7.06892 27.1534 7.6826 26.5397L16 18.2223L24.3174 26.5397C24.9311 27.1534 25.9261 27.1534 26.5397 26.5397C27.1534 25.9261 27.1534 24.9311 26.5397 24.3174L18.2223 16L26.5397 7.6826C27.1534 7.06892 27.1534 6.07394 26.5397 5.46026C25.9261 4.84658 24.9311 4.84658 24.3174 5.46026L16 13.7777L7.6826 5.46026Z", fill: r }) }), o = s("svg", { role: "icon", "data-testid": "close-cel-stroke", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...n, children: s("path", { d: "M26.7928 5.74064L25.8451 4.79291L15.7928 14.8452L5.74058 4.79291L4.79285 5.74064L14.8451 15.7929L4.79285 25.8452L5.74058 26.7929L15.7928 16.7406L25.8451 26.7929L26.7928 25.8452L16.7406 15.7929L26.7928 5.74064Z", fill: r }) });
  return e === X.CEL ? o : i;
};
function Z(e, t, { checkForDefaultPrevented: r = !0 } = {}) {
  return function(n) {
    if (e == null || e(n), r === !1 || !n.defaultPrevented)
      return t == null ? void 0 : t(n);
  };
}
function Ri(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function ma(...e) {
  return (t) => e.forEach((r) => Ri(r, t));
}
function ae(...e) {
  return p.useCallback(ma(...e), e);
}
function zi(e, t) {
  const r = p.createContext(t), a = (i) => {
    const { children: o, ...l } = i, c = p.useMemo(() => l, Object.values(l));
    return /* @__PURE__ */ s(r.Provider, { value: c, children: o });
  };
  a.displayName = e + "Provider";
  function n(i) {
    const o = p.useContext(r);
    if (o) return o;
    if (t !== void 0) return t;
    throw new Error(`\`${i}\` must be used within \`${e}\``);
  }
  return [a, n];
}
function or(e, t = []) {
  let r = [];
  function a(i, o) {
    const l = p.createContext(o), c = r.length;
    r = [...r, o];
    const d = (f) => {
      var b;
      const { scope: u, children: y, ...m } = f, h = ((b = u == null ? void 0 : u[e]) == null ? void 0 : b[c]) || l, v = p.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ s(h.Provider, { value: v, children: y });
    };
    d.displayName = i + "Provider";
    function g(f, u) {
      var h;
      const y = ((h = u == null ? void 0 : u[e]) == null ? void 0 : h[c]) || l, m = p.useContext(y);
      if (m) return m;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return [d, g];
  }
  const n = () => {
    const i = r.map((o) => p.createContext(o));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return n.scopeName = e, [a, Fi(n, ...t)];
}
function Fi(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const a = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(i) {
      const o = a.reduce((l, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var ze = globalThis != null && globalThis.document ? p.useLayoutEffect : () => {
}, Ti = p.useId || (() => {
}), Ai = 0;
function pt(e) {
  const [t, r] = p.useState(Ti());
  return ze(() => {
    e || r((a) => a ?? String(Ai++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
function we(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...r) => {
    var a;
    return (a = t.current) == null ? void 0 : a.call(t, ...r);
  }, []);
}
function lr({
  prop: e,
  defaultProp: t,
  onChange: r = () => {
  }
}) {
  const [a, n] = Pi({ defaultProp: t, onChange: r }), i = e !== void 0, o = i ? e : a, l = we(r), c = p.useCallback(
    (d) => {
      if (i) {
        const f = typeof d == "function" ? d(e) : d;
        f !== e && l(f);
      } else
        n(d);
    },
    [i, e, n, l]
  );
  return [o, c];
}
function Pi({
  defaultProp: e,
  onChange: t
}) {
  const r = p.useState(e), [a] = r, n = p.useRef(a), i = we(t);
  return p.useEffect(() => {
    n.current !== a && (i(a), n.current = a);
  }, [a, n, i]), r;
}
var sr = p.forwardRef((e, t) => {
  const { children: r, ...a } = e, n = p.Children.toArray(r), i = n.find(Oi);
  if (i) {
    const o = i.props.children, l = n.map((c) => c === i ? p.Children.count(o) > 1 ? p.Children.only(null) : p.isValidElement(o) ? o.props.children : null : c);
    return /* @__PURE__ */ s(Yt, { ...a, ref: t, children: p.isValidElement(o) ? p.cloneElement(o, void 0, l) : null });
  }
  return /* @__PURE__ */ s(Yt, { ...a, ref: t, children: r });
});
sr.displayName = "Slot";
var Yt = p.forwardRef((e, t) => {
  const { children: r, ...a } = e;
  if (p.isValidElement(r)) {
    const n = Hi(r);
    return p.cloneElement(r, {
      ...Ni(a, r.props),
      // @ts-ignore
      ref: t ? ma(t, n) : n
    });
  }
  return p.Children.count(r) > 1 ? p.Children.only(null) : null;
});
Yt.displayName = "SlotClone";
var va = ({ children: e }) => /* @__PURE__ */ s(K, { children: e });
function Oi(e) {
  return p.isValidElement(e) && e.type === va;
}
function Ni(e, t) {
  const r = { ...t };
  for (const a in t) {
    const n = e[a], i = t[a];
    /^on[A-Z]/.test(a) ? n && i ? r[a] = (...l) => {
      i(...l), n(...l);
    } : n && (r[a] = n) : a === "style" ? r[a] = { ...n, ...i } : a === "className" && (r[a] = [n, i].filter(Boolean).join(" "));
  }
  return { ...e, ...r };
}
function Hi(e) {
  var a, n;
  let t = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Ii = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], G = Ii.reduce((e, t) => {
  const r = p.forwardRef((a, n) => {
    const { asChild: i, ...o } = a, l = i ? sr : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ s(l, { ...o, ref: n });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Di(e, t) {
  e && ca.flushSync(() => e.dispatchEvent(t));
}
function Mi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e);
  p.useEffect(() => {
    const a = (n) => {
      n.key === "Escape" && r(n);
    };
    return t.addEventListener("keydown", a, { capture: !0 }), () => t.removeEventListener("keydown", a, { capture: !0 });
  }, [r, t]);
}
var _i = "DismissableLayer", qt = "dismissableLayer.update", $i = "dismissableLayer.pointerDownOutside", Bi = "dismissableLayer.focusOutside", Dr, ba = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), cr = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: r = !1,
      onEscapeKeyDown: a,
      onPointerDownOutside: n,
      onFocusOutside: i,
      onInteractOutside: o,
      onDismiss: l,
      ...c
    } = e, d = p.useContext(ba), [g, f] = p.useState(null), u = (g == null ? void 0 : g.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, y] = p.useState({}), m = ae(t, (E) => f(E)), h = Array.from(d.layers), [v] = [...d.layersWithOutsidePointerEventsDisabled].slice(-1), b = h.indexOf(v), C = g ? h.indexOf(g) : -1, S = d.layersWithOutsidePointerEventsDisabled.size > 0, x = C >= b, w = Vi((E) => {
      const T = E.target, H = [...d.branches].some((P) => P.contains(T));
      !x || H || (n == null || n(E), o == null || o(E), E.defaultPrevented || l == null || l());
    }, u), k = Zi((E) => {
      const T = E.target;
      [...d.branches].some((P) => P.contains(T)) || (i == null || i(E), o == null || o(E), E.defaultPrevented || l == null || l());
    }, u);
    return Mi((E) => {
      C === d.layers.size - 1 && (a == null || a(E), !E.defaultPrevented && l && (E.preventDefault(), l()));
    }, u), p.useEffect(() => {
      if (g)
        return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (Dr = u.body.style.pointerEvents, u.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(g)), d.layers.add(g), Mr(), () => {
          r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (u.body.style.pointerEvents = Dr);
        };
    }, [g, u, r, d]), p.useEffect(() => () => {
      g && (d.layers.delete(g), d.layersWithOutsidePointerEventsDisabled.delete(g), Mr());
    }, [g, d]), p.useEffect(() => {
      const E = () => y({});
      return document.addEventListener(qt, E), () => document.removeEventListener(qt, E);
    }, []), /* @__PURE__ */ s(
      G.div,
      {
        ...c,
        ref: m,
        style: {
          pointerEvents: S ? x ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: Z(e.onFocusCapture, k.onFocusCapture),
        onBlurCapture: Z(e.onBlurCapture, k.onBlurCapture),
        onPointerDownCapture: Z(
          e.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
cr.displayName = _i;
var Wi = "DismissableLayerBranch", Ui = p.forwardRef((e, t) => {
  const r = p.useContext(ba), a = p.useRef(null), n = ae(t, a);
  return p.useEffect(() => {
    const i = a.current;
    if (i)
      return r.branches.add(i), () => {
        r.branches.delete(i);
      };
  }, [r.branches]), /* @__PURE__ */ s(G.div, { ...e, ref: n });
});
Ui.displayName = Wi;
function Vi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e), a = p.useRef(!1), n = p.useRef(() => {
  });
  return p.useEffect(() => {
    const i = (l) => {
      if (l.target && !a.current) {
        let c = function() {
          xa(
            $i,
            r,
            d,
            { discrete: !0 }
          );
        };
        const d = { originalEvent: l };
        l.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = c, t.addEventListener("click", n.current, { once: !0 })) : c();
      } else
        t.removeEventListener("click", n.current);
      a.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", n.current);
    };
  }, [t, r]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => a.current = !0
  };
}
function Zi(e, t = globalThis == null ? void 0 : globalThis.document) {
  const r = we(e), a = p.useRef(!1);
  return p.useEffect(() => {
    const n = (i) => {
      i.target && !a.current && xa(Bi, r, { originalEvent: i }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, r]), {
    onFocusCapture: () => a.current = !0,
    onBlurCapture: () => a.current = !1
  };
}
function Mr() {
  const e = new CustomEvent(qt);
  document.dispatchEvent(e);
}
function xa(e, t, r, { discrete: a }) {
  const n = r.originalEvent.target, i = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: r });
  t && n.addEventListener(e, t, { once: !0 }), a ? Di(n, i) : n.dispatchEvent(i);
}
var Ot = "focusScope.autoFocusOnMount", Nt = "focusScope.autoFocusOnUnmount", _r = { bubbles: !1, cancelable: !0 }, Gi = "FocusScope", Ca = p.forwardRef((e, t) => {
  const {
    loop: r = !1,
    trapped: a = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: i,
    ...o
  } = e, [l, c] = p.useState(null), d = we(n), g = we(i), f = p.useRef(null), u = ae(t, (h) => c(h)), y = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (a) {
      let h = function(S) {
        if (y.paused || !l) return;
        const x = S.target;
        l.contains(x) ? f.current = x : be(f.current, { select: !0 });
      }, v = function(S) {
        if (y.paused || !l) return;
        const x = S.relatedTarget;
        x !== null && (l.contains(x) || be(f.current, { select: !0 }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const w of S)
            w.removedNodes.length > 0 && be(l);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", v);
      const C = new MutationObserver(b);
      return l && C.observe(l, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", v), C.disconnect();
      };
    }
  }, [a, l, y.paused]), p.useEffect(() => {
    if (l) {
      Br.add(y);
      const h = document.activeElement;
      if (!l.contains(h)) {
        const b = new CustomEvent(Ot, _r);
        l.addEventListener(Ot, d), l.dispatchEvent(b), b.defaultPrevented || (ji(Qi(Sa(l)), { select: !0 }), document.activeElement === h && be(l));
      }
      return () => {
        l.removeEventListener(Ot, d), setTimeout(() => {
          const b = new CustomEvent(Nt, _r);
          l.addEventListener(Nt, g), l.dispatchEvent(b), b.defaultPrevented || be(h ?? document.body, { select: !0 }), l.removeEventListener(Nt, g), Br.remove(y);
        }, 0);
      };
    }
  }, [l, d, g, y]);
  const m = p.useCallback(
    (h) => {
      if (!r && !a || y.paused) return;
      const v = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, b = document.activeElement;
      if (v && b) {
        const C = h.currentTarget, [S, x] = Yi(C);
        S && x ? !h.shiftKey && b === x ? (h.preventDefault(), r && be(S, { select: !0 })) : h.shiftKey && b === S && (h.preventDefault(), r && be(x, { select: !0 })) : b === C && h.preventDefault();
      }
    },
    [r, a, y.paused]
  );
  return /* @__PURE__ */ s(G.div, { tabIndex: -1, ...o, ref: u, onKeyDown: m });
});
Ca.displayName = Gi;
function ji(e, { select: t = !1 } = {}) {
  const r = document.activeElement;
  for (const a of e)
    if (be(a, { select: t }), document.activeElement !== r) return;
}
function Yi(e) {
  const t = Sa(e), r = $r(t, e), a = $r(t.reverse(), e);
  return [r, a];
}
function Sa(e) {
  const t = [], r = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (a) => {
      const n = a.tagName === "INPUT" && a.type === "hidden";
      return a.disabled || a.hidden || n ? NodeFilter.FILTER_SKIP : a.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; r.nextNode(); ) t.push(r.currentNode);
  return t;
}
function $r(e, t) {
  for (const r of e)
    if (!qi(r, { upTo: t })) return r;
}
function qi(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Ki(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function be(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const r = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== r && Ki(e) && t && e.select();
  }
}
var Br = Xi();
function Xi() {
  let e = [];
  return {
    add(t) {
      const r = e[0];
      t !== r && (r == null || r.pause()), e = Wr(e, t), e.unshift(t);
    },
    remove(t) {
      var r;
      e = Wr(e, t), (r = e[0]) == null || r.resume();
    }
  };
}
function Wr(e, t) {
  const r = [...e], a = r.indexOf(t);
  return a !== -1 && r.splice(a, 1), r;
}
function Qi(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Ji = "Portal", wa = p.forwardRef((e, t) => {
  var l;
  const { container: r, ...a } = e, [n, i] = p.useState(!1);
  ze(() => i(!0), []);
  const o = r || n && ((l = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : l.body);
  return o ? xi.createPortal(/* @__PURE__ */ s(G.div, { ...a, ref: t }), o) : null;
});
wa.displayName = Ji;
function eo(e, t) {
  return p.useReducer((r, a) => t[r][a] ?? r, e);
}
var $e = (e) => {
  const { present: t, children: r } = e, a = to(t), n = typeof r == "function" ? r({ present: a.isPresent }) : p.Children.only(r), i = ae(a.ref, ro(n));
  return typeof r == "function" || a.isPresent ? p.cloneElement(n, { ref: i }) : null;
};
$e.displayName = "Presence";
function to(e) {
  const [t, r] = p.useState(), a = p.useRef({}), n = p.useRef(e), i = p.useRef("none"), o = e ? "mounted" : "unmounted", [l, c] = eo(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const d = it(a.current);
    i.current = l === "mounted" ? d : "none";
  }, [l]), ze(() => {
    const d = a.current, g = n.current;
    if (g !== e) {
      const u = i.current, y = it(d);
      e ? c("MOUNT") : y === "none" || (d == null ? void 0 : d.display) === "none" ? c("UNMOUNT") : c(g && u !== y ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, c]), ze(() => {
    if (t) {
      let d;
      const g = t.ownerDocument.defaultView ?? window, f = (y) => {
        const h = it(a.current).includes(y.animationName);
        if (y.target === t && h && (c("ANIMATION_END"), !n.current)) {
          const v = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", d = g.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = v);
          });
        }
      }, u = (y) => {
        y.target === t && (i.current = it(a.current));
      };
      return t.addEventListener("animationstart", u), t.addEventListener("animationcancel", f), t.addEventListener("animationend", f), () => {
        g.clearTimeout(d), t.removeEventListener("animationstart", u), t.removeEventListener("animationcancel", f), t.removeEventListener("animationend", f);
      };
    } else
      c("ANIMATION_END");
  }, [t, c]), {
    isPresent: ["mounted", "unmountSuspended"].includes(l),
    ref: p.useCallback((d) => {
      d && (a.current = getComputedStyle(d)), r(d);
    }, [])
  };
}
function it(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function ro(e) {
  var a, n;
  let t = (a = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : a.get, r = t && "isReactWarning" in t && t.isReactWarning;
  return r ? e.ref : (t = (n = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : n.get, r = t && "isReactWarning" in t && t.isReactWarning, r ? e.props.ref : e.props.ref || e.ref);
}
var Ht = 0;
function ao() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ur()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ur()), Ht++, () => {
      Ht === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Ht--;
    };
  }, []);
}
function Ur() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var se = function() {
  return se = Object.assign || function(t) {
    for (var r, a = 1, n = arguments.length; a < n; a++) {
      r = arguments[a];
      for (var i in r) Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, se.apply(this, arguments);
};
function Ea(e, t) {
  var r = {};
  for (var a in e) Object.prototype.hasOwnProperty.call(e, a) && t.indexOf(a) < 0 && (r[a] = e[a]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, a = Object.getOwnPropertySymbols(e); n < a.length; n++)
      t.indexOf(a[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, a[n]) && (r[a[n]] = e[a[n]]);
  return r;
}
function no(e, t, r) {
  if (r || arguments.length === 2) for (var a = 0, n = t.length, i; a < n; a++)
    (i || !(a in t)) && (i || (i = Array.prototype.slice.call(t, 0, a)), i[a] = t[a]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var gt = "right-scroll-bar-position", ft = "width-before-scroll-bar", io = "with-scroll-bars-hidden", oo = "--removed-body-scroll-bar-size";
function It(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function lo(e, t) {
  var r = A(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return r.value;
        },
        set current(a) {
          var n = r.value;
          n !== a && (r.value = a, r.callback(a, n));
        }
      }
    };
  })[0];
  return r.callback = t, r.facade;
}
var so = typeof window < "u" ? p.useLayoutEffect : p.useEffect, Vr = /* @__PURE__ */ new WeakMap();
function co(e, t) {
  var r = lo(null, function(a) {
    return e.forEach(function(n) {
      return It(n, a);
    });
  });
  return so(function() {
    var a = Vr.get(r);
    if (a) {
      var n = new Set(a), i = new Set(e), o = r.current;
      n.forEach(function(l) {
        i.has(l) || It(l, null);
      }), i.forEach(function(l) {
        n.has(l) || It(l, o);
      });
    }
    Vr.set(r, e);
  }, [e]), r;
}
function po(e) {
  return e;
}
function go(e, t) {
  t === void 0 && (t = po);
  var r = [], a = !1, n = {
    read: function() {
      if (a)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return r.length ? r[r.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, a);
      return r.push(o), function() {
        r = r.filter(function(l) {
          return l !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (a = !0; r.length; ) {
        var o = r;
        r = [], o.forEach(i);
      }
      r = {
        push: function(l) {
          return i(l);
        },
        filter: function() {
          return r;
        }
      };
    },
    assignMedium: function(i) {
      a = !0;
      var o = [];
      if (r.length) {
        var l = r;
        r = [], l.forEach(i), o = r;
      }
      var c = function() {
        var g = o;
        o = [], g.forEach(i);
      }, d = function() {
        return Promise.resolve().then(c);
      };
      d(), r = {
        push: function(g) {
          o.push(g), d();
        },
        filter: function(g) {
          return o = o.filter(g), r;
        }
      };
    }
  };
  return n;
}
function fo(e) {
  e === void 0 && (e = {});
  var t = go(null);
  return t.options = se({ async: !0, ssr: !1 }, e), t;
}
var La = function(e) {
  var t = e.sideCar, r = Ea(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var a = t.read();
  if (!a)
    throw new Error("Sidecar medium not found");
  return p.createElement(a, se({}, r));
};
La.isSideCarExport = !0;
function uo(e, t) {
  return e.useMedium(t), La;
}
var ka = fo(), Dt = function() {
}, Lt = p.forwardRef(function(e, t) {
  var r = p.useRef(null), a = p.useState({
    onScrollCapture: Dt,
    onWheelCapture: Dt,
    onTouchMoveCapture: Dt
  }), n = a[0], i = a[1], o = e.forwardProps, l = e.children, c = e.className, d = e.removeScrollBar, g = e.enabled, f = e.shards, u = e.sideCar, y = e.noIsolation, m = e.inert, h = e.allowPinchZoom, v = e.as, b = v === void 0 ? "div" : v, C = e.gapMode, S = Ea(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), x = u, w = co([r, t]), k = se(se({}, S), n);
  return p.createElement(
    p.Fragment,
    null,
    g && p.createElement(x, { sideCar: ka, removeScrollBar: d, shards: f, noIsolation: y, inert: m, setCallbacks: i, allowPinchZoom: !!h, lockRef: r, gapMode: C }),
    o ? p.cloneElement(p.Children.only(l), se(se({}, k), { ref: w })) : p.createElement(b, se({}, k, { className: c, ref: w }), l)
  );
});
Lt.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Lt.classNames = {
  fullWidth: ft,
  zeroRight: gt
};
var ho = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function yo() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = ho();
  return t && e.setAttribute("nonce", t), e;
}
function mo(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function vo(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var bo = function() {
  var e = 0, t = null;
  return {
    add: function(r) {
      e == 0 && (t = yo()) && (mo(t, r), vo(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, xo = function() {
  var e = bo();
  return function(t, r) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && r]);
  };
}, Ra = function() {
  var e = xo(), t = function(r) {
    var a = r.styles, n = r.dynamic;
    return e(a, n), null;
  };
  return t;
}, Co = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Mt = function(e) {
  return parseInt(e || "", 10) || 0;
}, So = function(e) {
  var t = window.getComputedStyle(document.body), r = t[e === "padding" ? "paddingLeft" : "marginLeft"], a = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Mt(r), Mt(a), Mt(n)];
}, wo = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Co;
  var t = So(e), r = document.documentElement.clientWidth, a = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, a - r + t[2] - t[0])
  };
}, Eo = Ra(), Ne = "data-scroll-locked", Lo = function(e, t, r, a) {
  var n = e.left, i = e.top, o = e.right, l = e.gap;
  return r === void 0 && (r = "margin"), `
  .`.concat(io, ` {
   overflow: hidden `).concat(a, `;
   padding-right: `).concat(l, "px ").concat(a, `;
  }
  body[`).concat(Ne, `] {
    overflow: hidden `).concat(a, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(a, ";"),
    r === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(a, `;
    `),
    r === "padding" && "padding-right: ".concat(l, "px ").concat(a, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(gt, ` {
    right: `).concat(l, "px ").concat(a, `;
  }
  
  .`).concat(ft, ` {
    margin-right: `).concat(l, "px ").concat(a, `;
  }
  
  .`).concat(gt, " .").concat(gt, ` {
    right: 0 `).concat(a, `;
  }
  
  .`).concat(ft, " .").concat(ft, ` {
    margin-right: 0 `).concat(a, `;
  }
  
  body[`).concat(Ne, `] {
    `).concat(oo, ": ").concat(l, `px;
  }
`);
}, Zr = function() {
  var e = parseInt(document.body.getAttribute(Ne) || "0", 10);
  return isFinite(e) ? e : 0;
}, ko = function() {
  p.useEffect(function() {
    return document.body.setAttribute(Ne, (Zr() + 1).toString()), function() {
      var e = Zr() - 1;
      e <= 0 ? document.body.removeAttribute(Ne) : document.body.setAttribute(Ne, e.toString());
    };
  }, []);
}, Ro = function(e) {
  var t = e.noRelative, r = e.noImportant, a = e.gapMode, n = a === void 0 ? "margin" : a;
  ko();
  var i = p.useMemo(function() {
    return wo(n);
  }, [n]);
  return p.createElement(Eo, { styles: Lo(i, !t, n, r ? "" : "!important") });
}, Kt = !1;
if (typeof window < "u")
  try {
    var ot = Object.defineProperty({}, "passive", {
      get: function() {
        return Kt = !0, !0;
      }
    });
    window.addEventListener("test", ot, ot), window.removeEventListener("test", ot, ot);
  } catch {
    Kt = !1;
  }
var Ae = Kt ? { passive: !1 } : !1, zo = function(e) {
  return e.tagName === "TEXTAREA";
}, za = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var r = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    r[t] !== "hidden" && // contains scroll inside self
    !(r.overflowY === r.overflowX && !zo(e) && r[t] === "visible")
  );
}, Fo = function(e) {
  return za(e, "overflowY");
}, To = function(e) {
  return za(e, "overflowX");
}, Gr = function(e, t) {
  var r = t.ownerDocument, a = t;
  do {
    typeof ShadowRoot < "u" && a instanceof ShadowRoot && (a = a.host);
    var n = Fa(e, a);
    if (n) {
      var i = Ta(e, a), o = i[1], l = i[2];
      if (o > l)
        return !0;
    }
    a = a.parentNode;
  } while (a && a !== r.body);
  return !1;
}, Ao = function(e) {
  var t = e.scrollTop, r = e.scrollHeight, a = e.clientHeight;
  return [
    t,
    r,
    a
  ];
}, Po = function(e) {
  var t = e.scrollLeft, r = e.scrollWidth, a = e.clientWidth;
  return [
    t,
    r,
    a
  ];
}, Fa = function(e, t) {
  return e === "v" ? Fo(t) : To(t);
}, Ta = function(e, t) {
  return e === "v" ? Ao(t) : Po(t);
}, Oo = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, No = function(e, t, r, a, n) {
  var i = Oo(e, window.getComputedStyle(t).direction), o = i * a, l = r.target, c = t.contains(l), d = !1, g = o > 0, f = 0, u = 0;
  do {
    var y = Ta(e, l), m = y[0], h = y[1], v = y[2], b = h - v - i * m;
    (m || b) && Fa(e, l) && (f += b, u += m), l instanceof ShadowRoot ? l = l.host : l = l.parentNode;
  } while (
    // portaled content
    !c && l !== document.body || // self content
    c && (t.contains(l) || t === l)
  );
  return (g && (Math.abs(f) < 1 || !n) || !g && (Math.abs(u) < 1 || !n)) && (d = !0), d;
}, lt = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, jr = function(e) {
  return [e.deltaX, e.deltaY];
}, Yr = function(e) {
  return e && "current" in e ? e.current : e;
}, Ho = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Io = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Do = 0, Pe = [];
function Mo(e) {
  var t = p.useRef([]), r = p.useRef([0, 0]), a = p.useRef(), n = p.useState(Do++)[0], i = p.useState(Ra)[0], o = p.useRef(e);
  p.useEffect(function() {
    o.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var h = no([e.lockRef.current], (e.shards || []).map(Yr), !0).filter(Boolean);
      return h.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), h.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = p.useCallback(function(h, v) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !o.current.allowPinchZoom;
    var b = lt(h), C = r.current, S = "deltaX" in h ? h.deltaX : C[0] - b[0], x = "deltaY" in h ? h.deltaY : C[1] - b[1], w, k = h.target, E = Math.abs(S) > Math.abs(x) ? "h" : "v";
    if ("touches" in h && E === "h" && k.type === "range")
      return !1;
    var T = Gr(E, k);
    if (!T)
      return !0;
    if (T ? w = E : (w = E === "v" ? "h" : "v", T = Gr(E, k)), !T)
      return !1;
    if (!a.current && "changedTouches" in h && (S || x) && (a.current = w), !w)
      return !0;
    var H = a.current || w;
    return No(H, v, h, H === "h" ? S : x, !0);
  }, []), c = p.useCallback(function(h) {
    var v = h;
    if (!(!Pe.length || Pe[Pe.length - 1] !== i)) {
      var b = "deltaY" in v ? jr(v) : lt(v), C = t.current.filter(function(w) {
        return w.name === v.type && (w.target === v.target || v.target === w.shadowParent) && Ho(w.delta, b);
      })[0];
      if (C && C.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!C) {
        var S = (o.current.shards || []).map(Yr).filter(Boolean).filter(function(w) {
          return w.contains(v.target);
        }), x = S.length > 0 ? l(v, S[0]) : !o.current.noIsolation;
        x && v.cancelable && v.preventDefault();
      }
    }
  }, []), d = p.useCallback(function(h, v, b, C) {
    var S = { name: h, delta: v, target: b, should: C, shadowParent: _o(b) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(x) {
        return x !== S;
      });
    }, 1);
  }, []), g = p.useCallback(function(h) {
    r.current = lt(h), a.current = void 0;
  }, []), f = p.useCallback(function(h) {
    d(h.type, jr(h), h.target, l(h, e.lockRef.current));
  }, []), u = p.useCallback(function(h) {
    d(h.type, lt(h), h.target, l(h, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return Pe.push(i), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: u
    }), document.addEventListener("wheel", c, Ae), document.addEventListener("touchmove", c, Ae), document.addEventListener("touchstart", g, Ae), function() {
      Pe = Pe.filter(function(h) {
        return h !== i;
      }), document.removeEventListener("wheel", c, Ae), document.removeEventListener("touchmove", c, Ae), document.removeEventListener("touchstart", g, Ae);
    };
  }, []);
  var y = e.removeScrollBar, m = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    m ? p.createElement(i, { styles: Io(n) }) : null,
    y ? p.createElement(Ro, { gapMode: e.gapMode }) : null
  );
}
function _o(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const $o = uo(ka, Mo);
var Aa = p.forwardRef(function(e, t) {
  return p.createElement(Lt, se({}, e, { ref: t, sideCar: $o }));
});
Aa.classNames = Lt.classNames;
var Bo = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Oe = /* @__PURE__ */ new WeakMap(), st = /* @__PURE__ */ new WeakMap(), ct = {}, _t = 0, Pa = function(e) {
  return e && (e.host || Pa(e.parentNode));
}, Wo = function(e, t) {
  return t.map(function(r) {
    if (e.contains(r))
      return r;
    var a = Pa(r);
    return a && e.contains(a) ? a : (console.error("aria-hidden", r, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(r) {
    return !!r;
  });
}, Uo = function(e, t, r, a) {
  var n = Wo(t, Array.isArray(e) ? e : [e]);
  ct[r] || (ct[r] = /* @__PURE__ */ new WeakMap());
  var i = ct[r], o = [], l = /* @__PURE__ */ new Set(), c = new Set(n), d = function(f) {
    !f || l.has(f) || (l.add(f), d(f.parentNode));
  };
  n.forEach(d);
  var g = function(f) {
    !f || c.has(f) || Array.prototype.forEach.call(f.children, function(u) {
      if (l.has(u))
        g(u);
      else
        try {
          var y = u.getAttribute(a), m = y !== null && y !== "false", h = (Oe.get(u) || 0) + 1, v = (i.get(u) || 0) + 1;
          Oe.set(u, h), i.set(u, v), o.push(u), h === 1 && m && st.set(u, !0), v === 1 && u.setAttribute(r, "true"), m || u.setAttribute(a, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", u, b);
        }
    });
  };
  return g(t), l.clear(), _t++, function() {
    o.forEach(function(f) {
      var u = Oe.get(f) - 1, y = i.get(f) - 1;
      Oe.set(f, u), i.set(f, y), u || (st.has(f) || f.removeAttribute(a), st.delete(f)), y || f.removeAttribute(r);
    }), _t--, _t || (Oe = /* @__PURE__ */ new WeakMap(), Oe = /* @__PURE__ */ new WeakMap(), st = /* @__PURE__ */ new WeakMap(), ct = {});
  };
}, Vo = function(e, t, r) {
  r === void 0 && (r = "data-aria-hidden");
  var a = Array.from(Array.isArray(e) ? e : [e]), n = Bo(e);
  return n ? (a.push.apply(a, Array.from(n.querySelectorAll("[aria-live]"))), Uo(a, n, r, "aria-hidden")) : function() {
    return null;
  };
}, dr = "Dialog", [Oa, bd] = or(dr), [Zo, ge] = Oa(dr), Na = (e) => {
  const {
    __scopeDialog: t,
    children: r,
    open: a,
    defaultOpen: n,
    onOpenChange: i,
    modal: o = !0
  } = e, l = p.useRef(null), c = p.useRef(null), [d = !1, g] = lr({
    prop: a,
    defaultProp: n,
    onChange: i
  });
  return /* @__PURE__ */ s(
    Zo,
    {
      scope: t,
      triggerRef: l,
      contentRef: c,
      contentId: pt(),
      titleId: pt(),
      descriptionId: pt(),
      open: d,
      onOpenChange: g,
      onOpenToggle: p.useCallback(() => g((f) => !f), [g]),
      modal: o,
      children: r
    }
  );
};
Na.displayName = dr;
var Ha = "DialogTrigger", Go = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, n = ge(Ha, r), i = ae(t, n.triggerRef);
    return /* @__PURE__ */ s(
      G.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": gr(n.open),
        ...a,
        ref: i,
        onClick: Z(e.onClick, n.onOpenToggle)
      }
    );
  }
);
Go.displayName = Ha;
var jo = "DialogPortal", [xd, Ia] = Oa(jo, {
  forceMount: void 0
}), mt = "DialogOverlay", Da = p.forwardRef(
  (e, t) => {
    const r = Ia(mt, e.__scopeDialog), { forceMount: a = r.forceMount, ...n } = e, i = ge(mt, e.__scopeDialog);
    return i.modal ? /* @__PURE__ */ s($e, { present: a || i.open, children: /* @__PURE__ */ s(Yo, { ...n, ref: t }) }) : null;
  }
);
Da.displayName = mt;
var Yo = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, n = ge(mt, r);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ s(Aa, { as: sr, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ s(
        G.div,
        {
          "data-state": gr(n.open),
          ...a,
          ref: t,
          style: { pointerEvents: "auto", ...a.style }
        }
      ) })
    );
  }
), Fe = "DialogContent", Ma = p.forwardRef(
  (e, t) => {
    const r = Ia(Fe, e.__scopeDialog), { forceMount: a = r.forceMount, ...n } = e, i = ge(Fe, e.__scopeDialog);
    return /* @__PURE__ */ s($e, { present: a || i.open, children: i.modal ? /* @__PURE__ */ s(qo, { ...n, ref: t }) : /* @__PURE__ */ s(Ko, { ...n, ref: t }) });
  }
);
Ma.displayName = Fe;
var qo = p.forwardRef(
  (e, t) => {
    const r = ge(Fe, e.__scopeDialog), a = p.useRef(null), n = ae(t, r.contentRef, a);
    return p.useEffect(() => {
      const i = a.current;
      if (i) return Vo(i);
    }, []), /* @__PURE__ */ s(
      _a,
      {
        ...e,
        ref: n,
        trapFocus: r.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Z(e.onCloseAutoFocus, (i) => {
          var o;
          i.preventDefault(), (o = r.triggerRef.current) == null || o.focus();
        }),
        onPointerDownOutside: Z(e.onPointerDownOutside, (i) => {
          const o = i.detail.originalEvent, l = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || l) && i.preventDefault();
        }),
        onFocusOutside: Z(
          e.onFocusOutside,
          (i) => i.preventDefault()
        )
      }
    );
  }
), Ko = p.forwardRef(
  (e, t) => {
    const r = ge(Fe, e.__scopeDialog), a = p.useRef(!1), n = p.useRef(!1);
    return /* @__PURE__ */ s(
      _a,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (i) => {
          var o, l;
          (o = e.onCloseAutoFocus) == null || o.call(e, i), i.defaultPrevented || (a.current || (l = r.triggerRef.current) == null || l.focus(), i.preventDefault()), a.current = !1, n.current = !1;
        },
        onInteractOutside: (i) => {
          var c, d;
          (c = e.onInteractOutside) == null || c.call(e, i), i.defaultPrevented || (a.current = !0, i.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const o = i.target;
          ((d = r.triggerRef.current) == null ? void 0 : d.contains(o)) && i.preventDefault(), i.detail.originalEvent.type === "focusin" && n.current && i.preventDefault();
        }
      }
    );
  }
), _a = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, trapFocus: a, onOpenAutoFocus: n, onCloseAutoFocus: i, ...o } = e, l = ge(Fe, r), c = p.useRef(null), d = ae(t, c);
    return ao(), /* @__PURE__ */ L(K, { children: [
      /* @__PURE__ */ s(
        Ca,
        {
          asChild: !0,
          loop: !0,
          trapped: a,
          onMountAutoFocus: n,
          onUnmountAutoFocus: i,
          children: /* @__PURE__ */ s(
            cr,
            {
              role: "dialog",
              id: l.contentId,
              "aria-describedby": l.descriptionId,
              "aria-labelledby": l.titleId,
              "data-state": gr(l.open),
              ...o,
              ref: d,
              onDismiss: () => l.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ L(K, { children: [
        /* @__PURE__ */ s(Xo, { titleId: l.titleId }),
        /* @__PURE__ */ s(Jo, { contentRef: c, descriptionId: l.descriptionId })
      ] })
    ] });
  }
), pr = "DialogTitle", $a = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, n = ge(pr, r);
    return /* @__PURE__ */ s(G.h2, { id: n.titleId, ...a, ref: t });
  }
);
$a.displayName = pr;
var Ba = "DialogDescription", Wa = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, n = ge(Ba, r);
    return /* @__PURE__ */ s(G.p, { id: n.descriptionId, ...a, ref: t });
  }
);
Wa.displayName = Ba;
var Ua = "DialogClose", Va = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: r, ...a } = e, n = ge(Ua, r);
    return /* @__PURE__ */ s(
      G.button,
      {
        type: "button",
        ...a,
        ref: t,
        onClick: Z(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
Va.displayName = Ua;
function gr(e) {
  return e ? "open" : "closed";
}
var Za = "DialogTitleWarning", [Cd, Ga] = zi(Za, {
  contentName: Fe,
  titleName: pr,
  docsSlug: "dialog"
}), Xo = ({ titleId: e }) => {
  const t = Ga(Za), r = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(r));
  }, [r, e]), null;
}, Qo = "DialogDescriptionWarning", Jo = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Ga(Qo).contentName}}.`;
  return p.useEffect(() => {
    var i;
    const n = (i = e.current) == null ? void 0 : i.getAttribute("aria-describedby");
    t && n && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, el = Na, ja = Da, Ya = Ma, tl = $a, rl = Wa, al = Va, nl = "ekv08d0", il = "ekv08d1";
function qa(e) {
  var t, r, a = "";
  if (typeof e == "string" || typeof e == "number") a += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (r = qa(e[t])) && (a && (a += " "), a += r);
  } else for (r in e) e[r] && (a && (a += " "), a += r);
  return a;
}
function Q() {
  for (var e, t, r = 0, a = "", n = arguments.length; r < n; r++) (e = arguments[r]) && (t = qa(e)) && (a && (a += " "), a += t);
  return a;
}
const ol = el, fr = tl, ur = rl, ll = al, Ka = pe.forwardRef(({ children: e, className: t, ...r }, a) => s(ja, { ref: a, className: Q(il, t), ...r, children: e }));
Ka.displayName = ja.displayName;
const Xa = pe.forwardRef(({ children: e, className: t, ...r }, a) => s(Ya, { ref: a, className: Q(nl, t), ...r, children: e }));
Xa.displayName = Ya.displayName;
var sl = "_1yehyn70", cl = "_1yehyn71", dl = "_1yehyn72";
const pl = X.RCL, ut = {
  brand: pl,
  locale: {
    code: "en_US",
    country: "US",
    currency: "USD",
    market: "1",
    office: "MIA"
  }
}, Qa = rr({
  brand: ut.brand,
  dictionary: nr,
  itineraryService: new ga(ut),
  locale: ut.locale,
  env: da.TEST,
  variation: void 0,
  // TODO: Remove after A/B test
  setVariation: () => {
  }
  // TODO: Remove after A/B test
}), J = () => Je(Qa), Ja = ({
  children: e,
  hideCloseButton: t = !1,
  onClose: r,
  open: a,
  testId: n
}) => {
  const { brand: i } = J();
  return /* @__PURE__ */ L(ol, { open: a, children: [
    /* @__PURE__ */ s(Ka, { onClick: r }),
    /* @__PURE__ */ s(Xa, { className: sl, children: /* @__PURE__ */ L("div", { className: cl, "data-testid": n, children: [
      !t && /* @__PURE__ */ s(ll, { asChild: !0, children: /* @__PURE__ */ s(
        "button",
        {
          "data-testid": `${n}-close-button`,
          "aria-label": "Close",
          className: dl,
          onClick: r,
          children: /* @__PURE__ */ s(ki, { brand: i, size: 25 })
        }
      ) }),
      e
    ] }) })
  ] });
};
var et = "bvpbu90", en = "bvpbu91", tn = "bvpbu92", rn = "bvpbu93", an = "bvpbu94", nn = "bvpbu95", on = "bvpbu96", ln = "bvpbu97", Ye = "bvpbu98", gl = "bvpbu99", fl = "bvpbu9a", ul = "bvpbu9b", hl = "bvpbu9c", sn = "bvpbu9d", yl = "bvpbu9e", ml = "bvpbu9f", cn = "bvpbu9g", dn = "bvpbu9h", He = "bvpbu9i", vl = "bvpbu9j", bl = "bvpbu9k", xl = "bvpbu9l", pn = "bvpbu9m", Cl = "bvpbu9n", Sl = "bvpbu9o", wl = "bvpbu9p", El = "bvpbu9q", Ll = "bvpbu9r", kl = "bvpbu9s", ue = { palette: { surface: { primary: "var(--palette-bg-primary)", secondary: "var(--palette-bg-secondary)", footer: "var(--palette-bg-footer)" }, stepper: { surface: { current: "var(--palette-stepper-surface-current)", completed: "var(--palette-stepper-surface-completed)", disabled: "var(--palette-stepper-surface-disabled)" }, text: { current: "var(--palette-stepper-text-current)", disabled: "var(--palette-stepper-text-disabled)" } }, container: { primary: "var(--palette-container-primary)", primaryAlphaDark: "var(--palette-container-primary-alpha-dark)", secondary: "var(--palette-container-secondary)", secondaryAlphaDark: "var(--palette-container-secondary-alpha-dark)", brand: "var(--palette-container-brand)", accent: "var(--palette-container-accent)", error: "var(--palette-container-error)", success: "var(--palette-container-success)", warning: "var(--palette-container-warning)" }, subtle: { primary: "var(--palette-subtle-primary)", accent: "var(--palette-subtle-accent)", brand: "var(--palette-subtle-brand)", positive: "var(--palette-subtle-positive)", negative: "var(--palette-subtle-negative)" }, text: { dark: { body: "var(--palette-text-dark-body)", weaker: "var(--palette-text-dark-weaker)", brand: "var(--palette-text-dark-brand)" }, light: { reversed: "var(--palette-text-light-reversed)", weaker: "var(--palette-text-light-weaker)" }, action: { accent: "var(--palette-text-action-accent)", hover: "var(--palette-text-action-hover)", visited: "var(--palette-text-action-visited)", fontFamily: "var(--palette-text-action-font-family)", textDecoration: "var(--palette-text-action-text-decoration)" }, status: { disabled: "var(--palette-text-status-disabled)", error: "var(--palette-text-status-error)", success: "var(--palette-text-status-success)", promo: "var(--palette-text-status-promo)", warning: "var(--palette-text-status-warning)", info: "var(--palette-text-status-info)" } }, icon: { body: "var(--palette-icon-body)", brand: "var(--palette-icon-brand)", brandLogo: "var(--palette-icon-brand-logo)", reversed: "var(--palette-icon-reversed)", accent: "var(--palette-icon-accent)", accentHover: "var(--palette-icon-accent-hover)", disabled: "var(--palette-icon-disabled)", error: "var(--palette-icon-error)", success: "var(--palette-icon-success)", info: "var(--palette-icon-info)", warning: "var(--palette-icon-warning)", promo: "var(--palette-icon-promo)" }, border: { divider: "var(--palette-border-divider)", dividerRaised: "var(--palette-border-divider-raised)", dividerFooter: "var(--palette-border-divider-footer)", accent: "var(--palette-border-accent)", brand: "var(--palette-border-brand)", special: "var(--palette-border-special)", focus: "var(--palette-border-focus)", error: "var(--palette-border-error)", errorDark: "var(--palette-border-error-dark)", success: "var(--palette-border-success)", successDark: "var(--palette-border-success-dark)", info: "var(--palette-border-info)", infoDark: "var(--palette-border-info-dark)", warning: "var(--palette-border-warning)", warningDark: "var(--palette-border-warning-dark)", promo: "var(--palette-border-promo)" }, button: { outline: "var(--palette-button-outline)", primary: { default: "var(--palette-button-primary-default)", hover: "var(--palette-button-primary-hover)", pressed: "var(--palette-button-primary-pressed)", disabled: "var(--palette-button-primary-disabled)", border: "var(--palette-button-primary-border)", text: "var(--palette-button-primary-text)", disabledText: "var(--palette-button-primary-disabled-text)", disabledBorder: "var(--palette-button-primary-disabled-border)" }, secondary: { default: "var(--palette-button-secondary-default)", hover: "var(--palette-button-secondary-hover)", pressed: "var(--palette-button-secondary-pressed)", disabled: "var(--palette-button-secondary-disabled)", border: "var(--palette-button-secondary-border)", text: "var(--palette-button-secondary-text)", disabledText: "var(--palette-button-secondary-disabled-text)", disabledBorder: "var(--palette-button-secondary-disabled-border)" }, ghost: { default: "var(--palette-button-ghost-default)", hover: "var(--palette-button-ghost-hover)", pressed: "var(--palette-button-ghost-pressed)", disabled: "var(--palette-button-ghost-disabled)", border: "var(--palette-button-ghost-border)", text: "var(--palette-button-ghost-text)", disabledText: "var(--palette-button-ghost-disabled-text)", disabledBorder: "var(--palette-button-ghost-disabled-border)" }, special: { default: "var(--palette-button-special-default)", hover: "var(--palette-button-special-hover)", pressed: "var(--palette-button-special-pressed)", disabled: "var(--palette-button-special-disabled)", border: "var(--palette-button-special-border)", text: "var(--palette-button-special-text)", disabledText: "var(--palette-button-special-disabled-text)", disabledBorder: "var(--palette-button-special-disabled-border)" } }, form: { surface: { default: "var(--palette-form-bg-default)", disabled: "var(--palette-form-bg-disabled)" }, text: { label: "var(--palette-form-text-label)", placeholder: "var(--palette-form-text-placeholder)", active: "var(--palette-form-text-active)", error: "var(--palette-form-text-error)" }, icon: { default: "var(--palette-form-icon-default)", accent: "var(--palette-form-icon-accent)", error: "var(--palette-form-icon-error)", disabled: "var(--palette-form-icon-disabled)" }, border: { default: "var(--palette-form-border-default)", active: "var(--palette-form-border-active)", error: "var(--palette-form-border-error)" } }, selector: { surface: { default: "var(--palette-selector-surface-default)", subtle: "var(--palette-selector-surface-subtle)", subtleHover: "var(--palette-selector-surface-subtile-hover)", hover: "var(--palette-selector-surface-hover)", active: "var(--palette-selector-surface-active)", selected: "var(--palette-selector-surface-selected)", disabled: "var(--palette-selector-surface-disabled)", disabledSelected: "var(--palette-selector-surface-disabled-selected)" }, text: { accent: "var(--palette-selector-text-accent)", default: "var(--palette-selector-text-default)", disabled: "var(--palette-selector-text-disabled)", disabledSecondary: "var(--palette-selector-text-disabled-secondary)", reversed: "var(--palette-selector-text-reversed)" }, icon: { accent: "var(--palette-selector-icon-accent)", default: "var(--palette-selector-icon-default)", disabled: "var(--palette-selector-icon-disabled)", disabledSecondary: "var(--palette-selector-icon-disabled-secondary)", reversed: "var(--palette-selector-icon-reversed)" }, border: { default: "var(--palette-selector-border-default)", accent: "var(--palette-selector-border-accent)", disabled: "var(--palette-selector-border-disabled)" } }, badge: { surface: { promotion: "var(--palette-badge-surface-promotion)", highlight: "var(--palette-badge-surface-highlight)", feature: "var(--palette-badge-surface-feature)", casinoRoyale: "var(--palette-badge-surface-casino-royale)" }, border: { promotion: "var(--palette-badge-border-promotion)", hightlight: "var(--palette-badge-border-highlight)", feature: "var(--palette-badge-border-feature)", casinoRoyale: "var(--palette-badge-border-casino-royale)" }, text: { promotion: "var(--palette-badge-text-promotion)", highlight: "var(--palette-badge-text-highlight)", feature: "var(--palette-badge-text-feature)", casinoRoyale: "var(--palette-badge-text-casino-royale)" } } }, button: { textTransform: "var(--button-text-transform)", borderRadius: "var(--button-border-radius)", size: { lg: { padding: "var(--button-size-lg-padding)", iconSize: "var(--button-size-lg-icon-size)", gap: "var(--button-size-lg-gap)" }, md: { padding: "var(--button-size-md-padding)", iconSize: "var(--button-size-md-icon-size)", gap: "var(--button-size-md-gap)" }, sm: { padding: "var(--button-size-sm-padding)", iconSize: "var(--button-size-sm-icon-size)", gap: "var(--button-size-sm-gap)" } }, sizeGhost: { lg: { padding: "var(--button-size-ghost-lg-padding)", iconSize: "var(--button-size-ghost-lg-icon-size)", gap: "var(--button-size-ghost-lg-gap)" }, md: { padding: "var(--button-size-ghost-md-padding)", iconSize: "var(--button-size-ghost-md-icon-size)", gap: "var(--button-size-ghost-md-gap)" }, sm: { padding: "var(--button-size-ghost-sm-padding)", iconSize: "var(--button-size-ghost-sm-icon-size)", gap: "var(--button-size-ghost-sm-gap)" } } }, shadow: { box: "var(--shadow-box)", tooltip: "var(--shadow-tooltip)", stickyFooter: "var(--shadow-sticky-footer)", raised: { small: "var(--shadow-raised-small)", medium: "var(--shadow-raised-medium)", large: "var(--shadow-raised-large)", xlarge: "var(--shadow-raised-xlarge)" }, surface: { upper: { small: "var(--shadow-surface-upper-small)", medium: "var(--shadow-surface-upper-medium)", large: "var(--shadow-surface-upper-large)" }, bottom: { small: "var(--shadow-surface-bottom-small)", medium: "var(--shadow-surface-bottom-medium)", large: "var(--shadow-surface-bottom-large)" }, left: { small: "var(--shadow-surface-left-small)", medium: "var(--shadow-surface-left-medium)", large: "var(--shadow-surface-left-large)" }, right: { small: "var(--shadow-surface-right-small)", medium: "var(--shadow-surface-right-medium)", large: "var(--shadow-surface-right-large)" } } }, gradiants: { linear: "var(--gradiants-linear)" }, borderRadius: { xs: "var(--border-radius-xs)", small: "var(--border-radius-small)", medium: "var(--border-radius-medium)", large: "var(--border-radius-large)", xlarge: "var(--border-radius-xlarge)" }, spacing: { 0: "var(--spacing-0)", 1: "var(--spacing-1)", 2: "var(--spacing-2)", 3: "var(--spacing-3)", 4: "var(--spacing-4)", 5: "var(--spacing-5)", 6: "var(--spacing-6)", 7: "var(--spacing-7)", 8: "var(--spacing-8)", 9: "var(--spacing-9)", 10: "var(--spacing-10)", 11: "var(--spacing-11)", 12: "var(--spacing-12)", 13: "var(--spacing-13)", 14: "var(--spacing-14)", 15: "var(--spacing-15)", 16: "var(--spacing-16)" }, typography: { xs: { headline: { 1: { fontFamily: "var(--typography-xs-headline-1-font-family)", fontSize: "var(--typography-xs-headline-1-font-size)", lineHeight: "var(--typography-xs-headline-1-line-height)", letterSpacing: "var(--typography-xs-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-xs-heading-1-font-family)", fontSize: "var(--typography-xs-heading-1-font-size)", lineHeight: "var(--typography-xs-heading-1-line-height)", letterSpacing: "var(--typography-xs-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-xs-heading-2-font-family)", fontSize: "var(--typography-xs-heading-2-font-size)", lineHeight: "var(--typography-xs-heading-2-line-height)", letterSpacing: "var(--typography-xs-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-xs-heading-3-font-family)", fontSize: "var(--typography-xs-heading-3-font-size)", lineHeight: "var(--typography-xs-heading-3-line-height)", letterSpacing: "var(--typography-xs-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-xs-heading-4-font-family)", fontSize: "var(--typography-xs-heading-4-font-size)", lineHeight: "var(--typography-xs-heading-4-line-height)", letterSpacing: "var(--typography-xs-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-xs-display-big-semi-font-family)", fontSize: "var(--typography-xs-display-big-semi-font-size)", lineHeight: "var(--typography-xs-display-big-semi-line-height)", letterSpacing: "var(--typography-xs-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-xs-display-med-semi-font-family)", fontSize: "var(--typography-xs-display-med-semi-font-size)", lineHeight: "var(--typography-xs-display-med-semi-line-height)", letterSpacing: "var(--typography-xs-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-xs-display-med-reg-font-family)", fontSize: "var(--typography-xs-display-med-reg-font-size)", lineHeight: "var(--typography-xs-display-med-reg-line-height)", letterSpacing: "var(--typography-xs-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-display-small-semi-font-family)", fontSize: "var(--typography-xs-display-small-semi-font-size)", lineHeight: "var(--typography-xs-display-small-semi-line-height)", letterSpacing: "var(--typography-xs-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-xs-display-small-reg-font-family)", fontSize: "var(--typography-xs-display-small-reg-font-size)", lineHeight: "var(--typography-xs-display-small-reg-line-height)", letterSpacing: "var(--typography-xs-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-xs-body-big-bold-font-family)", fontSize: "var(--typography-xs-body-big-bold-font-size)", lineHeight: "var(--typography-xs-body-big-bold-line-height)", letterSpacing: "var(--typography-xs-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-xs-body-bold-font-family)", fontSize: "var(--typography-xs-body-bold-font-size)", lineHeight: "var(--typography-xs-body-bold-line-height)", letterSpacing: "var(--typography-xs-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-xs-body-semi-font-family)", fontSize: "var(--typography-xs-body-semi-font-size)", lineHeight: "var(--typography-xs-body-semi-line-height)", letterSpacing: "var(--typography-xs-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-body-reg-font-family)", fontSize: "var(--typography-xs-body-reg-font-size)", lineHeight: "var(--typography-xs-body-reg-line-height)", letterSpacing: "var(--typography-xs-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-xs-body-link-font-family)", fontSize: "var(--typography-xs-body-link-font-size)", lineHeight: "var(--typography-xs-body-link-line-height)", letterSpacing: "var(--typography-xs-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-xs-subtext-semi-font-family)", fontSize: "var(--typography-xs-subtext-semi-font-size)", lineHeight: "var(--typography-xs-subtext-semi-line-height)", letterSpacing: "var(--typography-xs-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-subtext-reg-font-family)", fontSize: "var(--typography-xs-subtext-reg-font-size)", lineHeight: "var(--typography-xs-subtext-reg-line-height)", letterSpacing: "var(--typography-xs-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-xs-subtext-link-font-family)", fontSize: "var(--typography-xs-subtext-link-font-size)", lineHeight: "var(--typography-xs-subtext-link-line-height)", letterSpacing: "var(--typography-xs-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-xs-button-semi-font-family)", fontSize: "var(--typography-xs-button-semi-font-size)", lineHeight: "var(--typography-xs-button-semi-line-height)", letterSpacing: "var(--typography-xs-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-button-small-semi-font-family)", fontSize: "var(--typography-xs-button-small-semi-font-size)", lineHeight: "var(--typography-xs-button-small-semi-line-height)", letterSpacing: "var(--typography-xs-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-xs-standlink-big-semi-font-family)", fontSize: "var(--typography-xs-standlink-big-semi-font-size)", lineHeight: "var(--typography-xs-standlink-big-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-xs-standlink-med-semi-font-family)", fontSize: "var(--typography-xs-standlink-med-semi-font-size)", lineHeight: "var(--typography-xs-standlink-med-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-standlink-small-semi-font-family)", fontSize: "var(--typography-xs-standlink-small-semi-font-size)", lineHeight: "var(--typography-xs-standlink-small-semi-line-height)", letterSpacing: "var(--typography-xs-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-xs-label-semi-font-family)", fontSize: "var(--typography-xs-label-semi-font-size)", lineHeight: "var(--typography-xs-label-semi-line-height)", letterSpacing: "var(--typography-xs-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-xs-label-small-semi-font-family)", fontSize: "var(--typography-xs-label-small-semi-font-size)", lineHeight: "var(--typography-xs-label-small-semi-line-height)", letterSpacing: "var(--typography-xs-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-xs-label-small-reg-font-family)", fontSize: "var(--typography-xs-label-small-reg-font-size)", lineHeight: "var(--typography-xs-label-small-reg-line-height)", letterSpacing: "var(--typography-xs-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-xs-placeholder-reg-font-family)", fontSize: "var(--typography-xs-placeholder-reg-font-size)", lineHeight: "var(--typography-xs-placeholder-reg-line-height)", letterSpacing: "var(--typography-xs-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-xs-caption-bold-font-family)", fontSize: "var(--typography-xs-caption-bold-font-size)", lineHeight: "var(--typography-xs-caption-bold-line-height)", letterSpacing: "var(--typography-xs-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-xs-caption-reg-font-family)", fontSize: "var(--typography-xs-caption-reg-font-size)", lineHeight: "var(--typography-xs-caption-reg-line-height)", letterSpacing: "var(--typography-xs-caption-reg-letter-spacing)" } } }, md: { headline: { 1: { fontFamily: "var(--typography-md-headline-1-font-family)", fontSize: "var(--typography-md-headline-1-font-size)", lineHeight: "var(--typography-md-headline-1-line-height)", letterSpacing: "var(--typography-md-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-md-heading-1-font-family)", fontSize: "var(--typography-md-heading-1-font-size)", lineHeight: "var(--typography-md-heading-1-line-height)", letterSpacing: "var(--typography-md-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-md-heading-2-font-family)", fontSize: "var(--typography-md-heading-2-font-size)", lineHeight: "var(--typography-md-heading-2-line-height)", letterSpacing: "var(--typography-md-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-md-heading-3-font-family)", fontSize: "var(--typography-md-heading-3-font-size)", lineHeight: "var(--typography-md-heading-3-line-height)", letterSpacing: "var(--typography-md-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-md-heading-4-font-family)", fontSize: "var(--typography-md-heading-4-font-size)", lineHeight: "var(--typography-md-heading-4-line-height)", letterSpacing: "var(--typography-md-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-md-display-big-semi-font-family)", fontSize: "var(--typography-md-display-big-semi-font-size)", lineHeight: "var(--typography-md-display-big-semi-line-height)", letterSpacing: "var(--typography-md-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-md-display-med-semi-font-family)", fontSize: "var(--typography-md-display-med-semi-font-size)", lineHeight: "var(--typography-md-display-med-semi-line-height)", letterSpacing: "var(--typography-md-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-md-display-med-reg-font-family)", fontSize: "var(--typography-md-display-med-reg-font-size)", lineHeight: "var(--typography-md-display-med-reg-line-height)", letterSpacing: "var(--typography-md-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-display-small-semi-font-family)", fontSize: "var(--typography-md-display-small-semi-font-size)", lineHeight: "var(--typography-md-display-small-semi-line-height)", letterSpacing: "var(--typography-md-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-md-display-small-reg-font-family)", fontSize: "var(--typography-md-display-small-reg-font-size)", lineHeight: "var(--typography-md-display-small-reg-line-height)", letterSpacing: "var(--typography-md-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-md-body-big-bold-font-family)", fontSize: "var(--typography-md-body-big-bold-font-size)", lineHeight: "var(--typography-md-body-big-bold-line-height)", letterSpacing: "var(--typography-md-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-md-body-bold-font-family)", fontSize: "var(--typography-md-body-bold-font-size)", lineHeight: "var(--typography-md-body-bold-line-height)", letterSpacing: "var(--typography-md-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-md-body-semi-font-family)", fontSize: "var(--typography-md-body-semi-font-size)", lineHeight: "var(--typography-md-body-semi-line-height)", letterSpacing: "var(--typography-md-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-body-reg-font-family)", fontSize: "var(--typography-md-body-reg-font-size)", lineHeight: "var(--typography-md-body-reg-line-height)", letterSpacing: "var(--typography-md-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-md-body-link-font-family)", fontSize: "var(--typography-md-body-link-font-size)", lineHeight: "var(--typography-md-body-link-line-height)", letterSpacing: "var(--typography-md-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-md-subtext-semi-font-family)", fontSize: "var(--typography-md-subtext-semi-font-size)", lineHeight: "var(--typography-md-subtext-semi-line-height)", letterSpacing: "var(--typography-md-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-subtext-reg-font-family)", fontSize: "var(--typography-md-subtext-reg-font-size)", lineHeight: "var(--typography-md-subtext-reg-line-height)", letterSpacing: "var(--typography-md-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-md-subtext-link-font-family)", fontSize: "var(--typography-md-subtext-link-font-size)", lineHeight: "var(--typography-md-subtext-link-line-height)", letterSpacing: "var(--typography-md-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-md-button-semi-font-family)", fontSize: "var(--typography-md-button-semi-font-size)", lineHeight: "var(--typography-md-button-semi-line-height)", letterSpacing: "var(--typography-md-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-button-small-semi-font-family)", fontSize: "var(--typography-md-button-small-semi-font-size)", lineHeight: "var(--typography-md-button-small-semi-line-height)", letterSpacing: "var(--typography-md-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-md-standlink-big-semi-font-family)", fontSize: "var(--typography-md-standlink-big-semi-font-size)", lineHeight: "var(--typography-md-standlink-big-semi-line-height)", letterSpacing: "var(--typography-md-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-md-standlink-med-semi-font-family)", fontSize: "var(--typography-md-standlink-med-semi-font-size)", lineHeight: "var(--typography-md-standlink-med-semi-line-height)", letterSpacing: "var(--typography-md-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-standlink-small-semi-font-family)", fontSize: "var(--typography-md-standlink-small-semi-font-size)", lineHeight: "var(--typography-md-standlink-small-semi-line-height)", letterSpacing: "var(--typography-md-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-md-label-semi-font-family)", fontSize: "var(--typography-md-label-semi-font-size)", lineHeight: "var(--typography-md-label-semi-line-height)", letterSpacing: "var(--typography-md-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-md-label-small-semi-font-family)", fontSize: "var(--typography-md-label-small-semi-font-size)", lineHeight: "var(--typography-md-label-small-semi-line-height)", letterSpacing: "var(--typography-md-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-md-label-small-reg-font-family)", fontSize: "var(--typography-md-label-small-reg-font-size)", lineHeight: "var(--typography-md-label-small-reg-line-height)", letterSpacing: "var(--typography-md-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-md-placeholder-reg-font-family)", fontSize: "var(--typography-md-placeholder-reg-font-size)", lineHeight: "var(--typography-md-placeholder-reg-line-height)", letterSpacing: "var(--typography-md-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-md-caption-bold-font-family)", fontSize: "var(--typography-md-caption-bold-font-size)", lineHeight: "var(--typography-md-caption-bold-line-height)", letterSpacing: "var(--typography-md-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-md-caption-reg-font-family)", fontSize: "var(--typography-md-caption-reg-font-size)", lineHeight: "var(--typography-md-caption-reg-line-height)", letterSpacing: "var(--typography-md-caption-reg-letter-spacing)" } } }, lg: { headline: { 1: { fontFamily: "var(--typography-lg-headline-1-font-family)", fontSize: "var(--typography-lg-headline-1-font-size)", lineHeight: "var(--typography-lg-headline-1-line-height)", letterSpacing: "var(--typography-lg-headline-1-letter-spacing)" } }, heading: { 1: { fontFamily: "var(--typography-lg-heading-1-font-family)", fontSize: "var(--typography-lg-heading-1-font-size)", lineHeight: "var(--typography-lg-heading-1-line-height)", letterSpacing: "var(--typography-lg-heading-1-letter-spacing)" }, 2: { fontFamily: "var(--typography-lg-heading-2-font-family)", fontSize: "var(--typography-lg-heading-2-font-size)", lineHeight: "var(--typography-lg-heading-2-line-height)", letterSpacing: "var(--typography-lg-heading-2-letter-spacing)" }, 3: { fontFamily: "var(--typography-lg-heading-3-font-family)", fontSize: "var(--typography-lg-heading-3-font-size)", lineHeight: "var(--typography-lg-heading-3-line-height)", letterSpacing: "var(--typography-lg-heading-3-letter-spacing)" }, 4: { fontFamily: "var(--typography-lg-heading-4-font-family)", fontSize: "var(--typography-lg-heading-4-font-size)", lineHeight: "var(--typography-lg-heading-4-line-height)", letterSpacing: "var(--typography-lg-heading-4-letter-spacing)" } }, display: { bigSemi: { fontFamily: "var(--typography-lg-display-big-semi-font-family)", fontSize: "var(--typography-lg-display-big-semi-font-size)", lineHeight: "var(--typography-lg-display-big-semi-line-height)", letterSpacing: "var(--typography-lg-display-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-lg-display-med-semi-font-family)", fontSize: "var(--typography-lg-display-med-semi-font-size)", lineHeight: "var(--typography-lg-display-med-semi-line-height)", letterSpacing: "var(--typography-lg-display-med-semi-letter-spacing)" }, medReg: { fontFamily: "var(--typography-lg-display-med-reg-font-family)", fontSize: "var(--typography-lg-display-med-reg-font-size)", lineHeight: "var(--typography-lg-display-med-reg-line-height)", letterSpacing: "var(--typography-lg-display-med-reg-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-display-small-semi-font-family)", fontSize: "var(--typography-lg-display-small-semi-font-size)", lineHeight: "var(--typography-lg-display-small-semi-line-height)", letterSpacing: "var(--typography-lg-display-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-lg-display-small-reg-font-family)", fontSize: "var(--typography-lg-display-small-reg-font-size)", lineHeight: "var(--typography-lg-display-small-reg-line-height)", letterSpacing: "var(--typography-lg-display-small-reg-letter-spacing)" } }, body: { bigBold: { fontFamily: "var(--typography-lg-body-big-bold-font-family)", fontSize: "var(--typography-lg-body-big-bold-font-size)", lineHeight: "var(--typography-lg-body-big-bold-line-height)", letterSpacing: "var(--typography-lg-body-big-bold-letter-spacing)" }, bold: { fontFamily: "var(--typography-lg-body-bold-font-family)", fontSize: "var(--typography-lg-body-bold-font-size)", lineHeight: "var(--typography-lg-body-bold-line-height)", letterSpacing: "var(--typography-lg-body-bold-letter-spacing)" }, semi: { fontFamily: "var(--typography-lg-body-semi-font-family)", fontSize: "var(--typography-lg-body-semi-font-size)", lineHeight: "var(--typography-lg-body-semi-line-height)", letterSpacing: "var(--typography-lg-body-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-body-reg-font-family)", fontSize: "var(--typography-lg-body-reg-font-size)", lineHeight: "var(--typography-lg-body-reg-line-height)", letterSpacing: "var(--typography-lg-body-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-lg-body-link-font-family)", fontSize: "var(--typography-lg-body-link-font-size)", lineHeight: "var(--typography-lg-body-link-line-height)", letterSpacing: "var(--typography-lg-body-link-letter-spacing)" } }, subtext: { semi: { fontFamily: "var(--typography-lg-subtext-semi-font-family)", fontSize: "var(--typography-lg-subtext-semi-font-size)", lineHeight: "var(--typography-lg-subtext-semi-line-height)", letterSpacing: "var(--typography-lg-subtext-semi-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-subtext-reg-font-family)", fontSize: "var(--typography-lg-subtext-reg-font-size)", lineHeight: "var(--typography-lg-subtext-reg-line-height)", letterSpacing: "var(--typography-lg-subtext-reg-letter-spacing)" }, link: { fontFamily: "var(--typography-lg-subtext-link-font-family)", fontSize: "var(--typography-lg-subtext-link-font-size)", lineHeight: "var(--typography-lg-subtext-link-line-height)", letterSpacing: "var(--typography-lg-subtext-link-letter-spacing)" } }, button: { semi: { fontFamily: "var(--typography-lg-button-semi-font-family)", fontSize: "var(--typography-lg-button-semi-font-size)", lineHeight: "var(--typography-lg-button-semi-line-height)", letterSpacing: "var(--typography-lg-button-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-button-small-semi-font-family)", fontSize: "var(--typography-lg-button-small-semi-font-size)", lineHeight: "var(--typography-lg-button-small-semi-line-height)", letterSpacing: "var(--typography-lg-button-small-semi-letter-spacing)" } }, standlink: { bigSemi: { fontFamily: "var(--typography-lg-standlink-big-semi-font-family)", fontSize: "var(--typography-lg-standlink-big-semi-font-size)", lineHeight: "var(--typography-lg-standlink-big-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-big-semi-letter-spacing)" }, medSemi: { fontFamily: "var(--typography-lg-standlink-med-semi-font-family)", fontSize: "var(--typography-lg-standlink-med-semi-font-size)", lineHeight: "var(--typography-lg-standlink-med-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-med-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-standlink-small-semi-font-family)", fontSize: "var(--typography-lg-standlink-small-semi-font-size)", lineHeight: "var(--typography-lg-standlink-small-semi-line-height)", letterSpacing: "var(--typography-lg-standlink-small-semi-letter-spacing)" } }, label: { semi: { fontFamily: "var(--typography-lg-label-semi-font-family)", fontSize: "var(--typography-lg-label-semi-font-size)", lineHeight: "var(--typography-lg-label-semi-line-height)", letterSpacing: "var(--typography-lg-label-semi-letter-spacing)" }, smallSemi: { fontFamily: "var(--typography-lg-label-small-semi-font-family)", fontSize: "var(--typography-lg-label-small-semi-font-size)", lineHeight: "var(--typography-lg-label-small-semi-line-height)", letterSpacing: "var(--typography-lg-label-small-semi-letter-spacing)" }, smallReg: { fontFamily: "var(--typography-lg-label-small-reg-font-family)", fontSize: "var(--typography-lg-label-small-reg-font-size)", lineHeight: "var(--typography-lg-label-small-reg-line-height)", letterSpacing: "var(--typography-lg-label-small-reg-letter-spacing)" } }, placeholder: { reg: { fontFamily: "var(--typography-lg-placeholder-reg-font-family)", fontSize: "var(--typography-lg-placeholder-reg-font-size)", lineHeight: "var(--typography-lg-placeholder-reg-line-height)", letterSpacing: "var(--typography-lg-placeholder-reg-letter-spacing)" } }, caption: { bold: { fontFamily: "var(--typography-lg-caption-bold-font-family)", fontSize: "var(--typography-lg-caption-bold-font-size)", lineHeight: "var(--typography-lg-caption-bold-line-height)", letterSpacing: "var(--typography-lg-caption-bold-letter-spacing)" }, reg: { fontFamily: "var(--typography-lg-caption-reg-font-family)", fontSize: "var(--typography-lg-caption-reg-font-size)", lineHeight: "var(--typography-lg-caption-reg-line-height)", letterSpacing: "var(--typography-lg-caption-reg-letter-spacing)" } } }, size: { 0: "var(--typography-size-0)", 1: "var(--typography-size-1)", 2: "var(--typography-size-2)", 3: "var(--typography-size-3)", 4: "var(--typography-size-4)", 5: "var(--typography-size-5)", 6: "var(--typography-size-6)", 7: "var(--typography-size-7)", 8: "var(--typography-size-8)", 9: "var(--typography-size-9)", 10: "var(--typography-size-10)", 11: "var(--typography-size-11)", 12: "var(--typography-size-12)", 13: "var(--typography-size-13)" }, font: { regular: "var(--typography-font-regular)", semiBold: "var(--typography-font-semi-bold)", bold: "var(--typography-font-bold)", secondary: "var(--typography-font-secondary)" }, fontFeatureSettings: "var(--typography-font-feature-settings)", fontWeight: { light: "var(--typography-font-weight-light)", normal: "var(--typography-font-weight-normal)", semiBold: "var(--typography-font-weight-semiBold)", bold: "var(--typography-font-weight-bold)" } } };
const gn = ({ brand: e, size: t, fill: r = R.palette.border.divider, ...a }) => {
  const n = L("svg", { width: t, height: t, viewBox: "0 0 100 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "heart-rcl-warning", ...a, children: [L("g", { "clip-path": "url(#clip0_5773_74195)", children: [s("g", { "clip-path": "url(#clip1_5773_74195)", children: s("path", { d: "M15.0119 43.9456L14.9888 43.9216L14.9652 43.8981C9.03708 37.9975 8.97054 27.9312 15.0119 21.6447L15.035 21.6207L15.0575 21.5962C20.6519 15.5101 30.089 15.4245 36.0693 21.6003L36.0693 21.6003L36.1121 21.6447L36.1122 21.6448L40.4532 26.1619L42.6163 28.4128L44.7794 26.1619L49.1205 21.6447L49.1436 21.6206L49.1662 21.5959L49.2074 21.5513C54.8118 15.5038 64.2324 15.4389 70.1976 21.6207C75.9656 27.9221 75.895 38.041 70.2206 43.9456L42.6163 72.6704L40.5929 70.5649L31.1348 60.7229L15.0119 43.9456Z", stroke: r, "stroke-width": "6", "stroke-miterlimit": "10", "stroke-linecap": "round" }) }), s("circle", { cx: "77.5", cy: "38", r: "20", fill: "white" }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M75.2531 27.4078C75.8275 26.4133 76.8886 25.8008 78.0369 25.8008C79.1853 25.8008 80.2464 26.4133 80.8209 27.408L89.6269 42.6681C89.9853 43.1959 90.1803 43.8209 90.1808 44.4723C90.1808 46.2476 88.7417 47.6867 86.9664 47.6867H69.113C67.9646 47.6867 66.9035 47.0742 66.3289 46.0793C65.7549 45.0848 65.7549 43.8598 66.329 42.8651L75.2531 27.4078ZM78.3962 28.8082C78.322 28.6798 78.1851 28.6008 78.0369 28.6008C77.8888 28.6008 77.7519 28.6798 77.6779 28.808L68.754 44.2649C68.6799 44.3933 68.6799 44.5514 68.7537 44.6793C68.8279 44.8077 68.9648 44.8867 69.113 44.8867H86.9664C87.1953 44.8867 87.3808 44.7012 87.3808 44.4733C87.3807 44.387 87.3562 44.3085 87.2563 44.1547L78.3962 28.8082Z", fill: R.palette.icon.error }), s("path", { d: "M78.0413 32.5391C78.6012 32.5391 79.0553 32.9929 79.0553 33.5531L78.7961 39.6004C78.7702 40.1474 78.3451 40.3552 78.0413 40.3552C77.701 40.3552 77.3164 40.1759 77.2865 39.6004L77.0273 33.5531C77.0273 32.9929 77.4815 32.5391 78.0413 32.5391Z", fill: R.palette.icon.error }), s("path", { d: "M78.9532 43.4206C78.7144 43.6617 78.3801 43.799 78.0382 43.799C77.696 43.799 77.3617 43.6617 77.1206 43.4206C76.8796 43.1795 76.7422 42.8452 76.7422 42.503C76.7422 42.1609 76.8796 41.8291 77.1206 41.5881C77.3617 41.347 77.696 41.207 78.0382 41.207C78.3801 41.207 78.7144 41.347 78.9532 41.5881C79.1968 41.8291 79.3342 42.1635 79.3342 42.503C79.3342 42.8452 79.1968 43.1795 78.9532 43.4206Z", fill: R.palette.icon.error })] }), L("defs", { children: [s("clipPath", { id: "clip0_5773_74195", children: s("rect", { width: "99", height: "84", fill: "white", transform: "translate(0.5)" }) }), s("clipPath", { id: "clip1_5773_74195", children: s("rect", { width: "84", height: "84", fill: "white", transform: "translate(0.5)" }) })] })] }), i = L("svg", { width: t, height: t, viewBox: "0 0 88 88", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-testid": "heart-cel-warning", ...a, children: [s("path", { d: "M48.3073 20.2887C51.8114 16.6534 56.6707 14.7276 61.595 15.0312C70.6973 15.5242 78 24.0039 78 33.9004C78.01 41.2848 74.9039 48.2918 69.4709 53.1224L62.3444 59.4577L62.344 59.412L44.003 75.6719L18.5353 53.1238C13.1074 48.3088 10 41.3074 10 33.9174C10 24.0459 17.3022 15.5568 26.5168 15.0274L27.3705 15.0226C34.9673 15.0226 41.4267 20.0726 43.7852 27.0769L43.996 27.752L44.2318 26.9921C44.9697 24.8146 46.1175 22.7924 47.6346 21.0285L48.3073 20.2887ZM74 33.9031C74 26.0505 68.2715 19.3987 61.3488 19.0236C57.6037 18.7927 53.8841 20.2668 51.1895 23.0623C48.6647 25.6902 47.2717 29.1676 47.2636 32.8775L47.2592 34.8731H40.7494L40.741 32.8815C40.7087 25.2191 34.7021 19.0226 27.3818 19.0226L26.6434 19.0241C19.7339 19.4231 14 26.0889 14 33.9174C14 40.1705 16.623 46.0804 21.1882 50.1302L44 70.324L66.3444 50.5252L66.344 50.548L66.8132 50.133C71.1174 46.306 73.6932 40.8413 73.9743 35.002L74 33.9031Z", fill: r }), s("path", { d: "M70.5 59C78.7843 59 85.5 52.2843 85.5 44C85.5 35.7157 78.7843 29 70.5 29C62.2157 29 55.5 35.7157 55.5 44C55.5 52.2843 62.2157 59 70.5 59Z", fill: "white" }), s("path", { d: "M69.2662 44.6165V39.7747H70.6412V44.6165H69.2662Z", fill: R.palette.icon.error }), s("path", { d: "M69.2662 46.5532V48.0057H70.6412V46.5532H69.2662Z", fill: R.palette.icon.error }), s("path", { d: "M60.8334 50.2121L69.5486 33.75H70.3587L79.0739 50.2121L78.6689 50.8848H61.2384L60.8334 50.2121ZM77.9076 49.9682L69.9537 34.944L61.9997 49.9682H77.9076Z", fill: R.palette.icon.error })] });
  return e === X.CEL ? i : n;
}, Rl = ({ brand: e, padlockColor: t = R.palette.icon.accent, size: r, stroke: a = R.palette.border.divider, ...n }) => {
  const i = L("svg", { role: "icon", "data-testid": "locked-heart-rcl", width: r, height: r, viewBox: "0 0 89 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("g", { clipPath: "url(#clip0_67_16)", children: s("path", { d: "M48.7074 21.5513C54.3118 15.5038 63.7325 15.4389 69.6976 21.6207C75.4656 27.9221 75.395 38.041 69.7206 43.9456L42.1163 72.6704L14.5119 43.9456L14.4888 43.9216L14.4652 43.8981C8.53708 37.9975 8.47054 27.9312 14.5119 21.6447L14.535 21.6207L14.5575 21.5962C20.1519 15.5101 29.589 15.4245 35.5693 21.6003L35.5694 21.6003L35.6121 21.6447L35.6122 21.6447L39.9532 26.1619L42.1163 28.4128L44.2794 26.1619L48.6205 21.6447L48.6436 21.6206L48.6661 21.5961L48.7074 21.5513Z", stroke: a, strokeWidth: "6", strokeMiterlimit: "10", strokeLinecap: "round" }) }), s("circle", { cx: "71.2623", cy: "41.7369", r: "17.6842", fill: R.palette.icon.reversed }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67.9718 36.6989C67.9718 35.7644 68.3658 35.1009 68.9629 34.646C69.5859 34.1714 70.463 33.9053 71.3861 33.9053C72.3092 33.9053 73.1863 34.1714 73.8092 34.646C74.4063 35.1009 74.8004 35.7644 74.8004 36.6989L74.8004 40.4219H67.9717L67.9718 36.6989ZM66.1094 40.4219L66.1095 36.6989C66.1095 35.1501 66.8018 33.9513 67.8343 33.1646C68.8408 32.3977 70.1365 32.043 71.3861 32.043C72.6357 32.043 73.9313 32.3977 74.9379 33.1646C75.9704 33.9513 76.6627 35.1501 76.6627 36.6989L76.6627 40.4219H77.8363C78.3886 40.4219 78.8363 40.8696 78.8363 41.4219V49.9752C78.8363 50.5275 78.3886 50.9752 77.8363 50.9752H64.9375C64.3852 50.9752 63.9375 50.5275 63.9375 49.9752V41.4219C63.9375 40.8696 64.3852 40.4219 64.9375 40.4219H66.1094ZM72.0915 45.7934C72.4177 45.5697 72.6316 45.1943 72.6316 44.7689C72.6316 44.0832 72.0757 43.5273 71.39 43.5273C70.7043 43.5273 70.1484 44.0832 70.1484 44.7689C70.1484 45.1943 70.3623 45.5697 70.6885 45.7934L70.1484 48.4936H72.6316L72.0915 45.7934Z", fill: t }), s("defs", { children: s("clipPath", { id: "clip0_67_16", children: s("rect", { width: "84", height: "84", fill: R.palette.icon.reversed }) }) })] }), o = L("svg", { role: "icon", "data-testid": "locked-heart-cel", width: r, height: r, viewBox: "0 0 77 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.3073 5.28863C41.8114 1.65336 46.6707 -0.272425 51.595 0.0311366C60.6973 0.524206 68 9.00388 68 18.9004C68.01 26.2848 64.9039 33.2917 59.4709 38.1223L52.3444 44.4576L52.344 44.412L34.003 60.6718L8.53526 38.1237C3.10737 33.3088 0 26.3074 0 18.9174C0 9.04583 7.30218 0.556788 16.5168 0.0273791L17.3705 0.0225786C24.9673 0.0225786 31.4267 5.07261 33.7852 12.0768L33.996 12.752L34.2318 11.992C34.9697 9.81456 36.1175 7.79237 37.6346 6.02847L38.3073 5.28863ZM64 18.9031C64 11.0504 58.2715 4.39865 51.3488 4.02356C47.6037 3.79268 43.8841 5.2668 41.1895 8.06226C38.6647 10.6902 37.2717 14.1676 37.2636 17.8774L37.2592 19.8731H30.7494L30.741 17.8815C30.7087 10.219 24.7021 4.02258 17.3818 4.02255L16.6434 4.02402C9.73387 4.42303 4 11.0889 4 18.9174C4 25.1704 6.62295 31.0803 11.1882 35.1301L34 55.324L56.3444 35.5251L56.344 35.548L56.8132 35.1329C61.1174 31.3059 63.6932 25.8413 63.9743 20.002L64 18.9031Z", fill: a }), s("circle", { cx: "65", cy: "26", r: "12", fill: R.palette.icon.reversed }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M62 19.5H61.5V20V23.5H60H59.5V24V32V32.5H60H70H70.5V32V24V23.5H70H68.5V20V19.5H68H62ZM67.5 23.5H62.5V20.5H67.5V23.5ZM60.5 31.5V24.5H69.5V31.5H60.5ZM66 27C66 27.3701 65.7989 27.6933 65.5 27.8662V30H64.5V27.8662C64.2011 27.6933 64 27.3701 64 27C64 26.4477 64.4477 26 65 26C65.5523 26 66 26.4477 66 27Z", fill: t })] });
  return e === X.RCL ? i : o;
}, fn = ({ brand: e, fill: t = R.palette.icon.warning, size: r, filled: a, ...n }) => {
  const i = s("svg", { role: "icon", "data-testid": "warning-rcl-filled", xmlns: "http://www.w3.org/2000/svg", width: r, height: r, viewBox: "0 0 16 16", fill: "none", ...n, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7214 11.1768L9.50158 3.86763C9.19153 3.3308 8.61864 3 7.99871 3C7.37878 3 6.80596 3.33068 6.49591 3.8675L2.2324 11.2523C1.92259 11.7891 1.92251 12.4505 2.23232 12.9874C2.54237 13.5242 3.11534 13.8551 3.73527 13.8551H12.2648C13.2231 13.8551 14 13.0783 14 12.1199C13.9998 11.7745 13.8979 11.4491 13.7214 11.1768ZM8.01005 5.82234C8.35547 5.82234 8.63564 6.10236 8.63564 6.44794L8.47573 10.179C8.45974 10.5164 8.19747 10.6446 8.01005 10.6446C7.80008 10.6446 7.56276 10.534 7.54437 10.179L7.38445 6.44794C7.38445 6.10236 7.66463 5.82234 8.01005 5.82234ZM8.01006 12.7694C8.22099 12.7694 8.42728 12.6847 8.57457 12.536C8.72489 12.3872 8.80965 12.1809 8.80965 11.9698C8.80965 11.7604 8.72489 11.5541 8.57457 11.4053C8.42728 11.2566 8.22099 11.1703 8.01006 11.1703C7.79897 11.1703 7.59268 11.2566 7.44395 11.4053C7.29523 11.5541 7.21047 11.7588 7.21047 11.9698C7.21047 12.1809 7.29523 12.3872 7.44395 12.536C7.59268 12.6847 7.79897 12.7694 8.01006 12.7694Z", fill: t }) }), o = L("svg", { role: "icon", "data-testid": "warning-rcl-stroke", width: r, height: r, ...n, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [s("path", { d: "M15.9999 11.7968C16.539 11.7968 16.9763 12.2339 16.9763 12.7733L16.7267 18.5968C16.7018 19.1235 16.2924 19.3237 15.9999 19.3237C15.6722 19.3237 15.3017 19.1509 15.273 18.5968L15.0234 12.7733C15.0234 12.2339 15.4607 11.7968 15.9999 11.7968Z", fill: t }), s("path", { d: "M15.9999 22.6405C16.3291 22.6405 16.6511 22.5082 16.881 22.276C17.1156 22.0439 17.2479 21.7219 17.2479 21.3924C17.2479 21.0655 17.1156 20.7435 16.881 20.5113C16.6511 20.2792 16.3291 20.1444 15.9999 20.1444C15.6704 20.1444 15.3484 20.2792 15.1163 20.5113C14.8842 20.7435 14.7519 21.063 14.7519 21.3924C14.7519 21.7219 14.8842 22.0439 15.1163 22.276C15.3484 22.5082 15.6704 22.6405 15.9999 22.6405Z", fill: t }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.9156 7.20174C14.3452 6.45806 15.1387 6 15.9974 6C16.8562 6 17.6497 6.45806 18.0792 7.20174L26.6005 21.9614C26.8532 22.3422 26.9997 22.7994 27 23.2882C27 24.6157 25.9239 25.6923 24.5963 25.6923H7.40372C6.54497 25.6923 5.75146 25.2343 5.32194 24.4906C4.89276 23.7469 4.89265 22.8306 5.32183 22.087L13.9156 7.20174ZM15.0525 7.85833L6.45889 22.7431C6.26412 23.0807 6.26408 23.4966 6.45889 23.8342C6.65391 24.1717 7.01402 24.3795 7.40372 24.3795H24.5953C25.1976 24.3795 25.6869 23.8914 25.6872 23.2891C25.687 23.0608 25.6179 22.8511 25.5001 22.6775L25.4866 22.6577L16.9424 7.85833C16.7474 7.52071 16.3872 7.31282 15.9974 7.31282C15.6077 7.31282 15.2475 7.52077 15.0525 7.85833Z", fill: t })] }), l = a ? i : o, c = L("svg", { role: "icon", "data-testid": "warning-cel-stroke", xmlns: "http://www.w3.org/2000/svg", width: r, height: r, viewBox: "0 0 32 32", fill: "none", ...n, children: [s("path", { d: "M16.5789 12.3684C16.5789 12.0487 16.3197 11.7895 16 11.7895C15.6803 11.7895 15.4211 12.0487 15.4211 12.3684V18.1579C15.4211 18.4776 15.6803 18.7368 16 18.7368C16.3197 18.7368 16.5789 18.4776 16.5789 18.1579V12.3684Z", fill: t }), s("path", { d: "M17.1579 21.6316C17.1579 22.2711 16.6395 22.7895 16 22.7895C15.3605 22.7895 14.8421 22.2711 14.8421 21.6316C14.8421 20.9921 15.3605 20.4737 16 20.4737C16.6395 20.4737 17.1579 20.9921 17.1579 21.6316Z", fill: t }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16.5046 6.29513C16.4021 6.11283 16.2092 6 16 6C15.7908 6 15.5979 6.11283 15.4954 6.29513L5.07435 24.8214C4.97352 25.0007 4.97536 25.22 5.07919 25.3975C5.18303 25.5751 5.37328 25.6842 5.57895 25.6842H26.421C26.6267 25.6842 26.817 25.5751 26.9208 25.3975C27.0246 25.22 27.0265 25.0007 26.9256 24.8214L16.5046 6.29513ZM16 7.75985L25.4311 24.5263H6.56886L16 7.75985Z", fill: t })] });
  return e === X.CEL ? c : l;
};
var zl = "i6ntru1", Fl = "i6ntru2", Tl = "i6ntru3", Al = "i6ntru4 i6ntru0", Pl = "i6ntru5 i6ntru0", Ol = "i6ntru6 i6ntru0", Nl = "i6ntru7 i6ntru0", vt = "i6ntru8", Hl = "hc4wsv2", Il = "hc4wsv3";
function un({ size: e, stroke: t = "#FFFEFE", className: r, ...a }) {
  return s("svg", { className: Q(Hl, r), width: e, height: e, viewBox: "25 25 50 50", "data-testid": "circular-loader", ...a, children: s("circle", { className: Il, cx: "50", cy: "50", r: "20", fill: "none", stroke: t, strokeWidth: 8 }) });
}
const hn = {
  primary: Al,
  secondary: Pl,
  ghost: Ol,
  special: Nl
}, yn = {
  small: Tl,
  medium: Fl,
  large: zl
}, bt = 1, he = pe.forwardRef(function(t, r) {
  const { variant: a = "primary", className: n, size: i = "medium", isPending: o = !1, icon: l, renderIcon: c, children: d, ...g } = t, f = {
    size: bt,
    fill: R.palette.button[a].text,
    className: vt,
    "data-position": "right"
  };
  return L("button", { className: Q(hn[a], yn[i], n), ref: r, disabled: o, ...g, children: [o && s(un, { size: bt, stroke: R.palette.button[a].disabledText, className: vt, "data-position": "left" }), d, l && s(l, { ...f }), c && c(f)] });
}), Dl = pe.forwardRef(function(t, r) {
  const { variant: a = "primary", className: n, size: i = "medium", isPending: o = !1, icon: l, renderIcon: c, children: d, ...g } = t, f = {
    size: bt,
    fill: R.palette.button[a].text,
    className: vt,
    "data-position": "right"
  };
  return L("a", { className: Q(hn[a], yn[i], n), ref: r, ...g, children: [o && s(un, { size: bt, stroke: R.palette.button[a].disabledText, className: vt, "data-position": "left" }), d, l && s(l, { ...f }), c && c(f)] });
});
function Ml(e) {
  const t = p.useRef({ value: e, previous: e });
  return p.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function mn(e) {
  const [t, r] = p.useState(void 0);
  return ze(() => {
    if (e) {
      r({ width: e.offsetWidth, height: e.offsetHeight });
      const a = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const i = n[0];
        let o, l;
        if ("borderBoxSize" in i) {
          const c = i.borderBoxSize, d = Array.isArray(c) ? c[0] : c;
          o = d.inlineSize, l = d.blockSize;
        } else
          o = e.offsetWidth, l = e.offsetHeight;
        r({ width: o, height: l });
      });
      return a.observe(e, { box: "border-box" }), () => a.unobserve(e);
    } else
      r(void 0);
  }, [e]), t;
}
var hr = "Checkbox", [_l, Sd] = or(hr), [$l, Bl] = _l(hr), vn = p.forwardRef(
  (e, t) => {
    const {
      __scopeCheckbox: r,
      name: a,
      checked: n,
      defaultChecked: i,
      required: o,
      disabled: l,
      value: c = "on",
      onCheckedChange: d,
      form: g,
      ...f
    } = e, [u, y] = p.useState(null), m = ae(t, (x) => y(x)), h = p.useRef(!1), v = u ? g || !!u.closest("form") : !0, [b = !1, C] = lr({
      prop: n,
      defaultProp: i,
      onChange: d
    }), S = p.useRef(b);
    return p.useEffect(() => {
      const x = u == null ? void 0 : u.form;
      if (x) {
        const w = () => C(S.current);
        return x.addEventListener("reset", w), () => x.removeEventListener("reset", w);
      }
    }, [u, C]), /* @__PURE__ */ L($l, { scope: r, state: b, disabled: l, children: [
      /* @__PURE__ */ s(
        G.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": Se(b) ? "mixed" : b,
          "aria-required": o,
          "data-state": Cn(b),
          "data-disabled": l ? "" : void 0,
          disabled: l,
          value: c,
          ...f,
          ref: m,
          onKeyDown: Z(e.onKeyDown, (x) => {
            x.key === "Enter" && x.preventDefault();
          }),
          onClick: Z(e.onClick, (x) => {
            C((w) => Se(w) ? !0 : !w), v && (h.current = x.isPropagationStopped(), h.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ s(
        Wl,
        {
          control: u,
          bubbles: !h.current,
          name: a,
          value: c,
          checked: b,
          required: o,
          disabled: l,
          form: g,
          style: { transform: "translateX(-100%)" },
          defaultChecked: Se(i) ? !1 : i
        }
      )
    ] });
  }
);
vn.displayName = hr;
var bn = "CheckboxIndicator", xn = p.forwardRef(
  (e, t) => {
    const { __scopeCheckbox: r, forceMount: a, ...n } = e, i = Bl(bn, r);
    return /* @__PURE__ */ s($e, { present: a || Se(i.state) || i.state === !0, children: /* @__PURE__ */ s(
      G.span,
      {
        "data-state": Cn(i.state),
        "data-disabled": i.disabled ? "" : void 0,
        ...n,
        ref: t,
        style: { pointerEvents: "none", ...e.style }
      }
    ) });
  }
);
xn.displayName = bn;
var Wl = (e) => {
  const { control: t, checked: r, bubbles: a = !0, defaultChecked: n, ...i } = e, o = p.useRef(null), l = Ml(r), c = mn(t);
  p.useEffect(() => {
    const g = o.current, f = window.HTMLInputElement.prototype, y = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (l !== r && y) {
      const m = new Event("click", { bubbles: a });
      g.indeterminate = Se(r), y.call(g, Se(r) ? !1 : r), g.dispatchEvent(m);
    }
  }, [l, r, a]);
  const d = p.useRef(Se(r) ? !1 : r);
  return /* @__PURE__ */ s(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n ?? d.current,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...c,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function Se(e) {
  return e === "indeterminate";
}
function Cn(e) {
  return Se(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
var Ul = vn, Vl = xn, Zl = "qq5cl40";
const qe = rr(void 0);
function Sn({ id: e, name: t = e, layout: r = "none", state: a = "default", children: n, className: i, ...o }) {
  const l = Ze(() => ({
    id: e,
    name: t,
    state: a
  }), [e, t, a]);
  return r === "none" ? s(qe.Provider, { value: l, children: n }) : s("div", { className: Q(Zl, i), "data-layout": r, ...o, children: s(qe.Provider, { value: l, children: n }) });
}
function Gl(e, t) {
  if (e == null) return {};
  var r = {}, a = Object.keys(e), n, i;
  for (i = 0; i < a.length; i++)
    n = a[i], !(t.indexOf(n) >= 0) && (r[n] = e[n]);
  return r;
}
var jl = ["color"], Yl = /* @__PURE__ */ sa(function(e, t) {
  var r = e.color, a = r === void 0 ? "currentColor" : r, n = Gl(e, jl);
  return Ir("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, n, {
    ref: t
  }), Ir("path", {
    d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
    fill: a,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const ql = ({ brand: e, size: t, fill: r, ...a }) => {
  const n = s("svg", { role: "icon", "data-testid": "check-rcl-stroke", width: t, height: t, ...a, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: s("path", { d: "M12.8571 24.1743L5 16.3171L7.21571 14.1014L12.8571 19.7271L24.7843 7.8L27 10.0314L12.8571 24.1743Z", fill: r }) }), i = s("svg", { role: "icon", "data-testid": "check-cel-stroke", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...a, children: s("path", { d: "M12.3684 23.6902L5 16.3218L6.05856 15.2647L12.3684 21.5745L25.9429 8.00003L27 9.05711L12.3684 23.6902Z", fill: r }) });
  return e === X.CEL ? i : n;
};
var Kl = "ng4ck83";
const wn = sa(({ id: e, name: t, brand: r, state: a, className: n, size: i, ...o }, l) => {
  const c = Je(qe), d = e ?? (c == null ? void 0 : c.id), g = t ?? (c == null ? void 0 : c.name), f = a ?? (c == null ? void 0 : c.state) ?? "default";
  return s(Ul, { id: d, name: g, "data-validity-state": f, className: Q(Kl, n, i), ref: l, ...o, children: s(Vl, { children: f === "indeterminate" ? s(Yl, { stroke: R.palette.text.light.reversed }) : s(ql, { brand: r, size: 16, fill: R.palette.text.light.reversed }) }) });
});
wn.displayName = "RcgCheckbox";
var Xl = "m32rfb0 rtjcqvp";
const Ke = pe.forwardRef(function({ className: t, children: r, ...a }, n) {
  return s("span", { className: Q(Xl, t), ref: n, ...a, children: r });
});
var Ql = "w3i1ix0";
const En = ({ children: e, onSubmit: t, className: r, ...a }) => s("form", { onSubmit: (i) => {
  i.preventDefault(), t();
}, className: Q(Ql, r), ...a, children: e });
var Jl = "_1auan2m0";
const yr = pe.forwardRef(function({ id: t, name: r, state: a, className: n, ...i }, o) {
  const l = Je(qe), c = t ?? (l == null ? void 0 : l.id), d = r ?? (l == null ? void 0 : l.name), g = a ?? (l == null ? void 0 : l.state) ?? "default";
  return s("input", { id: c, name: d, className: Q(Jl, n), "data-validity-state": g, ref: o, ...i });
});
yr.displayName = "RcgInput";
var es = "_128771w0 rtjcqvp";
const xt = pe.forwardRef(function({ htmlFor: t, state: r, className: a, children: n, ...i }, o) {
  const l = Je(qe), c = t ?? (l == null ? void 0 : l.id), d = r ?? (l == null ? void 0 : l.state) ?? "default";
  return s("label", { htmlFor: c, className: Q(es, a), "data-validity-state": d, ref: o, ...i, children: n });
});
xt.displayName = "RcgLabel";
const Ln = rr({
  isLoggedIn: !1,
  identityService: new ya(ut),
  authenticateUser: () => Promise.resolve(!1),
  isWatchlist: !1
  // TODO: Remove after A/B test
}), Be = () => Je(Ln), kn = ({
  initialFields: e,
  onError: t,
  validateField: r = (a) => a.trim() !== ""
}) => {
  const [a, n] = A(e), [i, o] = A({}), l = ar(!1);
  return {
    formState: a,
    errors: i,
    /* Methods */
    onInputChange: (f) => {
      const { name: u, value: y, maxLength: m } = f.target;
      if (!(m !== -1 && y.length > m) && (n({
        ...a,
        [u]: y
      }), l.current)) {
        const h = r(y);
        o((v) => ({
          ...v,
          [u]: !h
        }));
      }
    },
    onBlur: (f) => {
      const { name: u, value: y } = f.target, m = r(y);
      !m && t && t(), o((h) => ({
        ...h,
        [u]: !m
      })), l.current = !0;
    },
    handleCheckboxChange: (f) => (u) => {
      n((y) => ({
        ...y,
        [f]: u
      }));
    }
  };
}, mr = ({ icon: e, testId: t, text: r, title: a }) => /* @__PURE__ */ L(K, { children: [
  /* @__PURE__ */ s("div", { className: pn, "data-testid": t, children: e }),
  /* @__PURE__ */ L("div", { className: cn, children: [
    /* @__PURE__ */ s(fr, { className: dn, children: a }),
    r && /* @__PURE__ */ s(ur, { className: He, children: r })
  ] })
] });
var N = /* @__PURE__ */ ((e) => (e.CreateAccount = "CREATE-ACCOUNT", e.EnterEmail = "ENTER-EMAIL", e.EnterOtpCode = "ENTER-OTP-CODE", e.SignIn = "SIGN-IN", e.SuccessfulLogin = "SUCCESSFUL-LOGIN", e.TimesUp = "TIMES-UP", e))(N || {});
const ts = (e, t, r) => {
  switch (e) {
    case "limit-reached":
      return t.labelLimitReachedTitle;
    case "dashboard":
      return t.labelEnhancedAuthenticationDashboardTitle;
    default:
      return r ? t.labelEnhancedAuthenticationDefaultWatchlistTitle : t.labelEnhancedAuthenticationDefaultTitle;
  }
}, rs = ({ setActiveStep: e, variation: t }) => {
  const [r, a] = A(!1), [n, i] = A(""), { brand: o, dictionary: l, locale: c, setVariation: d } = J(), { identityService: g, isWatchlist: f } = Be(), { formState: u, errors: y, onInputChange: m, onBlur: h, handleCheckboxChange: v } = kn({
    initialFields: {
      email: "",
      optIn: !1
    },
    onError: () => b(),
    validateField: (k) => Vt.isValidEmail(k.trim())
  }), b = _(() => {
    W.emailFormError(c);
  }, [c]), C = async () => {
    const k = u.email.trim();
    if (Vt.isValidEmail(k)) {
      a(!0), i("");
      try {
        const { loginState: E, variation: T } = await g.login(k, {
          optIn: u.optIn,
          optInCopy: l.labelPrivacyPolicy
        });
        E === yt.SUCCESS ? (e(N.SuccessfulLogin), d(T)) : e(N.EnterOtpCode);
      } catch (E) {
        console.error(E), E instanceof Error && i(E.message);
      } finally {
        a(!1);
      }
    }
  }, S = _(() => {
    e(N.CreateAccount), W.signUpOnClick(c), W.createAccountModalLoad({
      brand: Ut[o],
      locale: c,
      variation: t
    });
  }, [e, o, c, t]), x = _(() => {
    e(N.SignIn), W.signInOnClick(c);
  }, [e, c]), w = ts(t, l, f);
  return /* @__PURE__ */ L("div", { className: et, children: [
    /* @__PURE__ */ s(
      mr,
      {
        icon: t === "limit-reached" ? /* @__PURE__ */ s(gn, { size: 84, brand: o }) : /* @__PURE__ */ s(Rl, { brand: o, size: 84 }),
        testId: "modal-icon-locked",
        title: w,
        text: t === "limit-reached" ? l.labelLimitReachedSubtitle : void 0
      }
    ),
    /* @__PURE__ */ L("div", { className: en, children: [
      /* @__PURE__ */ L(En, { onSubmit: C, className: tn, children: [
        /* @__PURE__ */ s(Sn, { id: "modal-email-input", state: y.email ? "error" : "default", children: /* @__PURE__ */ L(K, { children: [
          /* @__PURE__ */ s(xt, { htmlFor: "modal-email-input", className: rn, children: l.labelEmailAddress }),
          /* @__PURE__ */ s(
            yr,
            {
              className: _e.isRoyal(o) ? an : nn,
              placeholder: l.labelEmailAddressPlaceholder,
              onBlur: h,
              onChange: m,
              value: u.email,
              name: "email",
              type: "email"
            }
          ),
          y.email && /* @__PURE__ */ L("div", { className: on, children: [
            /* @__PURE__ */ s(fn, { className: ln, fill: ue.palette.icon.error, brand: o, size: 15 }),
            /* @__PURE__ */ s(Ke, { className: Ye, children: l.errorEmailAddressVerification })
          ] })
        ] }) }),
        /* @__PURE__ */ L("div", { className: gl, children: [
          /* @__PURE__ */ s(
            wn,
            {
              brand: o,
              id: "modal-privacy-policy-checkbox",
              checked: u.optIn,
              name: "optIn",
              onCheckedChange: v("optIn")
            }
          ),
          /* @__PURE__ */ s(
            xt,
            {
              className: fl,
              htmlFor: "modal-privacy-policy-checkbox",
              dangerouslySetInnerHTML: {
                __html: l.labelPrivacyPolicy
              }
            }
          )
        ] }),
        /* @__PURE__ */ s(
          he,
          {
            variant: "primary",
            "data-testid": "modal-continue-button",
            isPending: r,
            disabled: r || !u.email,
            children: l.actionContinue
          }
        )
      ] }),
      n && /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(Ke, { className: Ye, "data-testid": "modal-login-error-message", children: l.errorEmailValidationRequest }) }),
      /* @__PURE__ */ s("span", { className: ul, children: l.labelOr }),
      /* @__PURE__ */ L("div", { className: hl, children: [
        /* @__PURE__ */ s(he, { "data-testid": "modal-sign-in-button", onClick: x, variant: "secondary", children: l.actionSignInAccount }),
        /* @__PURE__ */ s(
          he,
          {
            "data-testid": "modal-create-account-button",
            onClick: S,
            variant: "secondary",
            children: l.actionCreateAnAccount
          }
        )
      ] })
    ] })
  ] });
}, Rn = ({ brand: e, fill: t = R.palette.surface.footer, size: r, ...a }) => {
  const n = s("svg", { role: "icon", "data-testid": "arrow-left-rcl-stroke", width: r, height: r, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...a, children: s("path", { d: "M5 15.9687C5.00057 15.6 5.13694 15.2467 5.37912 14.9865L13.7909 5.94781C14.2952 5.40592 15.1115 5.40739 15.6141 5.95109C16.1167 6.49478 16.1154 7.37482 15.6111 7.91671L9.40499 14.5853L25.7127 14.6108C26.4247 14.6119 27.001 15.2351 27 16.0027C26.999 16.7703 26.4209 17.3917 25.7089 17.3906L9.39824 17.3651L15.6141 24.0889C16.1167 24.6326 16.1154 25.5126 15.6111 26.0545C15.1068 26.5964 14.2905 26.5949 13.7879 26.0512L5.37609 16.9522C5.13471 16.6911 4.99943 16.3373 5 15.9687Z", fill: t }) }), i = s("svg", { role: "icon", "data-testid": "arrow-left-cel-stroke", width: r, height: r, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...a, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.7059 26L5 16.3268L5.03501 14.9957L13.7409 6.28986L15.1089 7.65785L8.05432 14.7124L27 14.7124L27 16.647L7.89098 16.647L15.1439 24.7058L13.7059 26Z", fill: t }) });
  return e === X.RCL ? n : i;
}, as = ({ brand: e, shieldColor: t = R.palette.icon.success, shieldColorDark: r = R.palette.text.status.success, size: a, stroke: n = R.palette.border.divider, ...i }) => {
  const o = L("svg", { role: "icon", "data-testid": "secure-heart-rcl", width: a, height: a, viewBox: "0 0 88 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i, children: [s("g", { clipPath: "url(#clip0_51_18)", children: s("path", { d: "M48.7074 21.5513C54.3118 15.5038 63.7325 15.4389 69.6976 21.6207C75.4656 27.9221 75.395 38.041 69.7206 43.9456L42.1163 72.6704L14.5119 43.9456L14.4888 43.9216L14.4652 43.8981C8.53708 37.9975 8.47054 27.9312 14.5119 21.6447L14.535 21.6207L14.5575 21.5962C20.1519 15.5101 29.589 15.4245 35.5693 21.6003L35.5694 21.6003L35.6121 21.6447L35.6122 21.6447L39.9532 26.1619L42.1163 28.4128L44.2794 26.1619L48.6205 21.6447L48.6436 21.6206L48.6661 21.5961L48.7074 21.5513Z", stroke: n, strokeWidth: "6", strokeMiterlimit: "10", strokeLinecap: "round" }) }), s("circle", { cx: "70.2623", cy: "39.7369", r: "17.6842", fill: R.palette.icon.reversed }), s("path", { d: "M70.0116 47.1421C69.7988 47.2684 69.6236 47.3667 69.4975 47.4354C69.4944 47.4338 69.4913 47.4321 69.4881 47.4304C69.3345 47.3487 69.1122 47.2276 68.8406 47.0719C68.2968 46.7601 67.5579 46.3109 66.7768 45.7612C65.1891 44.644 63.5244 43.1777 62.8757 41.6642C62.2053 40.0999 61.978 38.0518 61.9265 36.3563C61.901 35.5159 61.9189 34.7764 61.9432 34.2474C61.9472 34.161 61.9513 34.0804 61.9555 34.0059C62.2517 34.0771 62.639 34.1563 63.076 34.2114C64.0441 34.3333 65.3389 34.3476 66.4175 33.8083C67.4037 33.3152 68.2603 32.7025 68.8674 32.2168C69.1239 32.0116 69.3375 31.8277 69.4995 31.6831C69.6614 31.8277 69.8751 32.0116 70.1316 32.2168C70.7386 32.7025 71.5952 33.3152 72.5814 33.8083C73.6601 34.3476 74.9551 34.3333 75.9233 34.2114C76.3595 34.1564 76.7461 34.0774 77.0422 34.0063C77.0445 34.0595 77.0468 34.1158 77.0488 34.1752C77.0657 34.6634 77.069 35.3545 77.0148 36.1609C76.9057 37.781 76.5661 39.8319 75.6634 41.6375C74.7696 43.4251 73.188 44.9037 71.7967 45.9472C71.1056 46.4655 70.4718 46.8688 70.0116 47.1421Z", fill: r, stroke: t, strokeLinejoin: "round" }), s("path", { d: "M75.9236 34.2114C76.3596 34.1564 76.7463 34.0774 77.0422 34.0064C77.0446 34.0595 77.0469 34.1159 77.0489 34.1753C77.0658 34.6635 77.0692 35.3545 77.015 36.1609C76.9061 37.781 76.5667 39.832 75.6639 41.6375C74.7701 43.4251 73.1886 44.9037 71.7972 45.9472C71.1062 46.4655 70.4724 46.8688 70.0121 47.1421C70.008 47.1445 70.004 47.1469 70 47.1493V32.11C70.0427 32.1449 70.0867 32.1805 70.1321 32.2168C70.7392 32.7025 71.5957 33.3152 72.5819 33.8083C73.6606 34.3476 74.9555 34.3333 75.9236 34.2114Z", fill: t, stroke: t, strokeLinejoin: "round" }), s("defs", { children: s("clipPath", { id: "clip0_51_18", children: s("rect", { width: "84", height: "84", fill: R.palette.icon.reversed }) }) })] }), l = L("svg", { role: "icon", "data-testid": "secure-heart-cel", width: a, height: a, viewBox: "0 0 77 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...i, children: [s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.8073 5.28866C42.3114 1.65339 47.1707 -0.272394 52.095 0.0311671C61.1973 0.524237 68.5 9.00391 68.5 18.9004C68.51 26.2848 65.4039 33.2918 59.9709 38.1224L52.8444 44.4577L52.844 44.412L34.503 60.6719L9.03526 38.1238C3.60737 33.3088 0.5 26.3074 0.5 18.9174C0.5 9.04586 7.80218 0.556818 17.0168 0.0274097L17.8705 0.0226091C25.4673 0.0226091 31.9267 5.07264 34.2852 12.0769L34.496 12.752L34.7318 11.9921C35.4697 9.81459 36.6175 7.7924 38.1346 6.0285L38.8073 5.28866ZM64.5 18.9031C64.5 11.0505 58.7715 4.39868 51.8488 4.02359C48.1037 3.79271 44.3841 5.26683 41.6895 8.06229C39.1647 10.6902 37.7717 14.1676 37.7636 17.8775L37.7592 19.8731H31.2494L31.241 17.8815C31.2087 10.2191 25.2021 4.02261 17.8818 4.02258L17.1434 4.02405C10.2339 4.42306 4.5 11.0889 4.5 18.9174C4.5 25.1705 7.12295 31.0804 11.6882 35.1302L34.5 55.324L56.8444 35.5252L56.844 35.548L57.3132 35.133C61.6174 31.306 64.1932 25.8413 64.4743 20.002L64.5 18.9031Z", fill: n }), s("circle", { cx: "61", cy: "29", r: "15", fill: R.palette.icon.reversed }), s("path", { d: "M61 20L61 38M61 20C61 20 58.75 21.5 57.25 22.25C55.75 23 53.5 23 53.5 23C53.5 23 53.5 29 53.5 32C53.5 34.9985 60.9924 37.997 61 38M61 20C61 20 63.25 21.5 64.75 22.25C66.25 23 68.5 23 68.5 23C68.5 23 68.5 29 68.5 32C68.5 35 61 38 61 38", stroke: t })] });
  return e === X.RCL ? o : l;
}, ns = 3e4, is = ({ children: e }) => {
  const { dictionary: t, locale: r } = J(), { identityService: a } = Be(), [n, i] = A(!1), [o, l] = A(!1), [c, d] = A(""), g = ar(void 0), f = _(async () => {
    d(""), l(!0);
    try {
      await a.resendCode(), i(!0), g.current = setTimeout(() => {
        i(!1);
      }, ns), W.resendOtpCodeRequestSuccessful(r);
    } catch (u) {
      console.error(u), u instanceof Error && d(u.message), W.resendOtpCodeRequestFailed(r);
    } finally {
      l(!1);
    }
  }, [a, r]);
  return Re(() => () => {
    clearTimeout(g.current), i(!1);
  }, []), /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s("div", { className: yl, children: /* @__PURE__ */ L("p", { className: He, children: [
      /* @__PURE__ */ s("span", { children: t.labelHaventReceivedACode }),
      " ",
      /* @__PURE__ */ s(
        "button",
        {
          className: ml,
          "data-testid": "modal-resend-code-button",
          onClick: f,
          disabled: n || o,
          children: t.actionResendCode
        }
      )
    ] }) }),
    e,
    n && /* @__PURE__ */ L("div", { children: [
      /* @__PURE__ */ L("p", { className: He, children: [
        t.labelGetAnotherCodeIn,
        " ",
        t.labelOtpCodeExpirationTime,
        " ",
        t.labelSeconds
      ] }),
      /* @__PURE__ */ s("p", { className: He, children: t.labelHaventReceivedEmail })
    ] }),
    c && /* @__PURE__ */ s(Ke, { className: Ye, "data-testid": "modal-code-error-message", children: t.errorResendOtpCode })
  ] });
}, $t = 8, os = ({ setActiveStep: e }) => {
  const { brand: t, dictionary: r, locale: a, setVariation: n } = J(), { identityService: i, isWatchlist: o } = Be(), [l, c] = A(!1), [d, g] = A(null), { formState: f, onInputChange: u } = kn({
    initialFields: {
      otpCode: ""
    },
    validateField: (h) => h.length > 0
  }), y = _(async () => {
    const h = f.otpCode.trim();
    if (h.length === $t) {
      c(!0), g(null);
      try {
        const v = await i.validateOtpCode(h);
        e(N.SuccessfulLogin), n(v);
      } catch (v) {
        if (v instanceof ua) {
          e(N.TimesUp), W.otpCodeExpired(a);
          return;
        }
        if (v instanceof ha) {
          g((b) => ({
            ...b,
            invalidEmailOrCode: !0
          })), W.invalidOtpCode(a);
          return;
        }
        g((b) => ({
          ...b,
          connectionError: !0
        })), W.otpCodeRequestFailed(a);
      } finally {
        c(!1);
      }
    }
  }, [e, f.otpCode, i, a, n]), m = _(() => {
    e(N.EnterEmail);
  }, [e]);
  return /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        className: sn,
        "data-testid": "modal-back-button",
        onClick: m,
        type: "button",
        children: /* @__PURE__ */ s(Rn, { fill: ue.palette.icon.accent, brand: t, size: 25 })
      }
    ),
    /* @__PURE__ */ L("div", { className: et, children: [
      /* @__PURE__ */ s(
        mr,
        {
          icon: /* @__PURE__ */ s(as, { brand: t, size: 84 }),
          testId: "modal-icon-locked",
          title: r.labelVerifyEmailAddress,
          text: `${o ? r.labelEnsureOwnershipOfTheListOfItemsWatchlist : r.labelEnsureOwnershipOfTheListOfItems} ${r.labelEnterTheCode} ${r.labelExpCodeWarning}`
        }
      ),
      /* @__PURE__ */ L("div", { className: en, children: [
        /* @__PURE__ */ s(En, { onSubmit: y, className: tn, children: /* @__PURE__ */ L(K, { children: [
          /* @__PURE__ */ s(
            Sn,
            {
              id: "modal-verification-code-input",
              state: d != null && d.invalidEmailOrCode ? "error" : "default",
              children: /* @__PURE__ */ L(K, { children: [
                /* @__PURE__ */ s(xt, { className: rn, htmlFor: "modal-verification-code-input", children: r.labelVerificationCode }),
                /* @__PURE__ */ s(
                  yr,
                  {
                    className: _e.isRoyal(t) ? an : nn,
                    placeholder: r.labelPlaceholderVerificationCode,
                    onChange: u,
                    value: f.otpCode,
                    name: "otpCode",
                    type: "number",
                    maxLength: $t
                  }
                ),
                (d == null ? void 0 : d.invalidEmailOrCode) && /* @__PURE__ */ L("div", { className: on, children: [
                  /* @__PURE__ */ s(fn, { className: ln, fill: ue.palette.icon.error, brand: t, size: 15 }),
                  /* @__PURE__ */ s(Ke, { className: Ye, children: r.errorOtpVerificationCode })
                ] })
              ] })
            }
          ),
          /* @__PURE__ */ s(
            he,
            {
              variant: "primary",
              "data-testid": "modal-continue-button",
              isPending: l,
              disabled: l || f.otpCode.trim().length < $t,
              children: r.actionContinue
            }
          )
        ] }) }),
        /* @__PURE__ */ s(is, { children: (d == null ? void 0 : d.connectionError) && /* @__PURE__ */ s(Ke, { className: Ye, children: r.errorValidationCodeRequest }) })
      ] })
    ] })
  ] });
}, ls = "0.17.2", ss = {
  USA: "US"
}, cs = ({ activeStep: e, setActiveStep: t, variation: r }) => {
  const { brand: a, env: n, locale: i, itineraryService: o } = J(), l = ar(null), c = e === N.SignIn ? "sign-in" : "create-account", d = _(() => {
    t(N.EnterEmail);
  }, [t]), g = _(async () => {
    await o.userMerge(), t(N.SuccessfulLogin);
  }, [o, t]);
  Re(() => {
    const u = l.current;
    return u == null || u.addEventListener("successSession", g), () => {
      u == null || u.removeEventListener("successSession", g);
    };
  }, [g, l]);
  const f = {
    siteSection: r === "dashboard" ? Ge.FavoritesDashboard : Ge.Cruises,
    brand: Ut[a],
    country: i.country,
    language: i.code.split("-")[0],
    loginStatus: fa.Anonymous,
    appName: r === "dashboard" ? je.OneCart : je.CruiseSearch,
    scVersion: ls,
    referringLinkLocation: window.location.href
  };
  return /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s(
      "button",
      {
        className: sn,
        "data-testid": "modal-back-button",
        type: "button",
        onClick: d,
        children: /* @__PURE__ */ s(Rn, { fill: ue.palette.icon.accent, brand: a, size: 25 })
      }
    ),
    /* @__PURE__ */ s("div", { className: et, children: /* @__PURE__ */ s("div", { className: kl, children: /* @__PURE__ */ s("div", { children: /* @__PURE__ */ s(
      "global-login",
      {
        "analytics-data-object": JSON.stringify(f),
        brand: Ut[a],
        "component-to-show": c,
        country: ss[i.country],
        env: n,
        ref: l,
        "set-legacy-cookies": !0,
        "data-testid": "global-login"
      }
    ) }) }) })
  ] });
}, ds = ({ brand: e, checkColor: t = R.palette.icon.success, size: r, stroke: a = R.palette.border.divider, ...n }) => {
  const i = L("svg", { role: "icon", "data-testid": "heart-check-rcl", width: r, height: r, viewBox: "0 0 89 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("g", { clipPath: "url(#clip0_53_263)", children: s("path", { d: "M48.7074 21.5513C54.3118 15.5038 63.7325 15.4389 69.6976 21.6207C75.4656 27.9221 75.395 38.041 69.7206 43.9456L42.1163 72.6704L14.5119 43.9456L14.4888 43.9216L14.4652 43.8981C8.53708 37.9975 8.47054 27.9312 14.5119 21.6447L14.535 21.6207L14.5575 21.5962C20.1519 15.5101 29.589 15.4245 35.5693 21.6003L35.5694 21.6003L35.6121 21.6447L35.6122 21.6447L39.9532 26.1619L42.1163 28.4128L44.2794 26.1619L48.6205 21.6447L48.6436 21.6206L48.6661 21.5961L48.7074 21.5513Z", stroke: a, strokeWidth: "6", strokeMiterlimit: "10", strokeLinecap: "round" }) }), s("circle", { cx: "71.2623", cy: "37.7369", r: "17.6842", fill: R.palette.icon.reversed }), s("path", { d: "M68.5 44.775L62.25 38.525L64.0125 36.7625L68.5 41.2375L77.9875 31.75L79.75 33.525L68.5 44.775Z", fill: t }), s("defs", { children: s("clipPath", { id: "clip0_53_263", children: s("rect", { width: "84", height: "84", fill: R.palette.icon.reversed }) }) })] }), o = L("svg", { role: "icon", "data-testid": "heart-check-cel", width: r, height: r, viewBox: "0 0 77 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.8073 5.28866C42.3114 1.65339 47.1707 -0.272394 52.095 0.0311671C61.1973 0.524237 68.5 9.00391 68.5 18.9004C68.51 26.2848 65.4039 33.2918 59.9709 38.1224L52.8444 44.4577L52.844 44.412L34.503 60.6719L9.03526 38.1238C3.60737 33.3088 0.5 26.3074 0.5 18.9174C0.5 9.04586 7.80218 0.556818 17.0168 0.0274097L17.8705 0.0226091C25.4673 0.0226091 31.9267 5.07264 34.2852 12.0769L34.496 12.752L34.7318 11.9921C35.4697 9.81459 36.6175 7.7924 38.1346 6.0285L38.8073 5.28866ZM64.5 18.9031C64.5 11.0505 58.7715 4.39868 51.8488 4.02359C48.1037 3.79271 44.3841 5.26683 41.6895 8.06229C39.1647 10.6902 37.7717 14.1676 37.7636 17.8775L37.7592 19.8731H31.2494L31.241 17.8815C31.2087 10.2191 25.2021 4.02261 17.8818 4.02258L17.1434 4.02405C10.2339 4.42306 4.5 11.0889 4.5 18.9174C4.5 25.1705 7.12295 31.0804 11.6882 35.1302L34.5 55.324L56.8444 35.5252L56.844 35.548L57.3132 35.133C61.6174 31.306 64.1932 25.8413 64.4743 20.002L64.5 18.9031Z", fill: a }), s("circle", { cx: "57.7623", cy: "31.7369", r: "17.6842", fill: "white" }), s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67 32C67 36.9706 62.9706 41 58 41C53.0294 41 49 36.9706 49 32C49 27.0294 53.0294 23 58 23C62.9706 23 67 27.0294 67 32ZM65.5 32C65.5 36.1421 62.1421 39.5 58 39.5C53.8579 39.5 50.5 36.1421 50.5 32C50.5 27.8579 53.8579 24.5 58 24.5C62.1421 24.5 65.5 27.8579 65.5 32ZM56.3018 35.6388L52.8604 32.4943C52.8604 32.4943 52.6359 32.2611 52.6057 32.0373C52.5667 31.7487 52.7385 31.5157 52.8239 31.4194C52.9114 31.3209 53.1437 31.1169 53.4665 31.1169C53.7422 31.1169 53.938 31.2809 53.938 31.2809L56.699 33.8004L61.9531 28.3131C61.9531 28.3131 62.53 27.8677 63.041 28.3532C63.552 28.8387 63.1286 29.4298 63.1286 29.4298L57.2018 35.6388C57.2018 35.6388 56.967 35.7616 56.699 35.7616C56.431 35.7616 56.3018 35.6388 56.3018 35.6388Z", fill: t }), s("mask", { id: "mask0_1753_54877", maskUnits: "userSpaceOnUse", x: "49", y: "23", width: "18", height: "18", children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M67 32C67 36.9706 62.9706 41 58 41C53.0294 41 49 36.9706 49 32C49 27.0294 53.0294 23 58 23C62.9706 23 67 27.0294 67 32ZM65.5 32C65.5 36.1421 62.1421 39.5 58 39.5C53.8579 39.5 50.5 36.1421 50.5 32C50.5 27.8579 53.8579 24.5 58 24.5C62.1421 24.5 65.5 27.8579 65.5 32ZM56.3018 35.6388L52.8604 32.4943C52.8604 32.4943 52.6359 32.2611 52.6057 32.0373C52.5667 31.7487 52.7385 31.5157 52.8239 31.4194C52.9114 31.3209 53.1437 31.1169 53.4665 31.1169C53.7422 31.1169 53.938 31.2809 53.938 31.2809L56.699 33.8004L61.9531 28.3131C61.9531 28.3131 62.53 27.8677 63.041 28.3532C63.552 28.8387 63.1286 29.4298 63.1286 29.4298L57.2018 35.6388C57.2018 35.6388 56.967 35.7616 56.699 35.7616C56.431 35.7616 56.3018 35.6388 56.3018 35.6388Z", fill: R.palette.icon.reversed }) }), s("g", { mask: "url(#mask0_1753_54877)", children: s("rect", { x: "49", y: "23", width: "18", height: "18", fill: t }) })] });
  return e === X.RCL ? i : o;
}, ps = ({ onSuccessfulLogin: e, variation: t }) => {
  const { brand: r, dictionary: a } = J(), { identityService: n, isWatchlist: i } = Be();
  return /* @__PURE__ */ L("div", { className: et, children: [
    /* @__PURE__ */ s("div", { className: pn, children: /* @__PURE__ */ s(ds, { brand: r, size: 84 }) }),
    /* @__PURE__ */ L("div", { className: bl, children: [
      /* @__PURE__ */ L("div", { className: cn, children: [
        /* @__PURE__ */ s(fr, { className: dn, children: a.labelSignedIn }),
        n.maskedEmail && /* @__PURE__ */ L("p", { className: He, children: [
          a.labelHello,
          " ",
          /* @__PURE__ */ s("span", { className: vl, "data-testid": "modal-masked-email-text", children: n.maskedEmail })
        ] }),
        /* @__PURE__ */ s(ur, { className: He, children: t === "dashboard" ? a.labelHowToContinueExploringTheFeature : i ? a.labelEmailOnlyHowToContinueWatchlist : a.labelEmailOnlyHowToContinue })
      ] }),
      t !== "dashboard" ? /* @__PURE__ */ L("div", { className: wl, children: [
        /* @__PURE__ */ s(
          he,
          {
            variant: "primary",
            "data-testid": "modal-continue-browsing-button",
            onClick: e,
            children: a.actionContinueBrowsing
          }
        ),
        /* @__PURE__ */ s(
          Dl,
          {
            variant: "secondary",
            "data-testid": "modal-go-to-dashboard-button",
            href: i ? "/watchlist" : "/favorites",
            onClick: e,
            children: i ? a.actionGoToDashboardWatchlist : a.actionGoToDashboard
          }
        )
      ] }) : /* @__PURE__ */ s("div", { className: Cl, children: /* @__PURE__ */ s(
        he,
        {
          className: Sl,
          variant: "primary",
          "data-testid": "succesful-auth-ok-button",
          onClick: e,
          children: a.labelOkay
        }
      ) })
    ] })
  ] });
}, gs = ({ brand: e, clockColor: t = R.palette.icon.disabled, size: r, stroke: a = R.palette.border.divider, ...n }) => {
  const i = L("svg", { role: "icon", "data-testid": "heart-clock-rcl", width: r, height: r, viewBox: "0 0 87 84", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("g", { clipPath: "url(#clip0_54_4)", children: s("path", { d: "M48.7074 21.5513C54.3118 15.5038 63.7325 15.4389 69.6976 21.6207C75.4656 27.9221 75.395 38.041 69.7206 43.9456L42.1163 72.6704L14.5119 43.9456L14.4888 43.9216L14.4652 43.8981C8.53708 37.9975 8.47054 27.9312 14.5119 21.6447L14.535 21.6207L14.5575 21.5962C20.1519 15.5101 29.589 15.4245 35.5693 21.6003L35.5694 21.6003L35.6121 21.6447L35.6122 21.6447L39.9532 26.1619L42.1163 28.4128L44.2794 26.1619L48.6205 21.6447L48.6436 21.6206L48.6661 21.5961L48.7074 21.5513Z", stroke: a, strokeWidth: "6", strokeMiterlimit: "10", strokeLinecap: "round" }) }), s("circle", { cx: "69.2623", cy: "39.7369", r: "17.6842", fill: R.palette.icon.reversed }), s("circle", { cx: "70", cy: "39", r: "9", stroke: t, strokeWidth: "2" }), s("path", { d: "M70 33L70 39", stroke: t, strokeWidth: "2", strokeLinecap: "round" }), s("path", { d: "M76 39L70 39", stroke: t, strokeWidth: "2", strokeLinecap: "round" }), s("defs", { children: s("clipPath", { id: "clip0_54_4", children: s("rect", { width: "84", height: "84", fill: R.palette.icon.reversed }) }) })] }), o = L("svg", { role: "icon", "data-testid": "heart-clock-cel", width: r, height: r, viewBox: "0 0 81 64", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...n, children: [s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.8073 5.28866C42.3114 1.65339 47.1707 -0.272394 52.095 0.0311671C61.1973 0.524237 68.5 9.00391 68.5 18.9004C68.51 26.2848 65.4039 33.2918 59.9709 38.1224L52.8444 44.4577L52.844 44.412L34.503 60.6719L9.03526 38.1238C3.60737 33.3088 0.5 26.3074 0.5 18.9174C0.5 9.04586 7.80218 0.556818 17.0168 0.0274097L17.8705 0.0226091C25.4673 0.0226091 31.9267 5.07264 34.2852 12.0769L34.496 12.752L34.7318 11.9921C35.4697 9.81459 36.6175 7.7924 38.1346 6.0285L38.8073 5.28866ZM64.5 18.9031C64.5 11.0505 58.7715 4.39868 51.8488 4.02359C48.1037 3.79271 44.3841 5.26683 41.6895 8.06229C39.1647 10.6902 37.7717 14.1676 37.7636 17.8775L37.7592 19.8731H31.2494L31.241 17.8815C31.2087 10.2191 25.2021 4.02261 17.8818 4.02258L17.1434 4.02405C10.2339 4.42306 4.5 11.0889 4.5 18.9174C4.5 25.1705 7.12295 31.0804 11.6882 35.1302L34.5 55.324L56.8444 35.5252L56.844 35.548L57.3132 35.133C61.6174 31.306 64.1932 25.8413 64.4743 20.002L64.5 18.9031Z", fill: a }), s("circle", { cx: "63.2623", cy: "31.7369", r: "17.6842", fill: R.palette.icon.reversed }), s("g", { clipPath: "url(#clip0_1753_93901)", children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M55.625 32C55.625 27.9269 58.9269 24.625 63 24.625C67.0731 24.625 70.375 27.9269 70.375 32C70.375 36.0731 67.0731 39.375 63 39.375C58.9269 39.375 55.625 36.0731 55.625 32ZM63 23.625C58.3746 23.625 54.625 27.3746 54.625 32C54.625 36.6254 58.3746 40.375 63 40.375C67.6254 40.375 71.375 36.6254 71.375 32C71.375 27.3746 67.6254 23.625 63 23.625ZM63 28.625V32.6198L67.2464 35.0715L66.7464 35.9375L61.875 33.125L62 32.9085V28.625H63Z", fill: t }) }), s("defs", { children: s("clipPath", { id: "clip0_1753_93901", children: s("rect", { width: "18", height: "18", fill: R.palette.icon.reversed, transform: "translate(54 23)" }) }) })] });
  return e === X.RCL ? i : o;
}, fs = ({ setActiveStep: e }) => {
  const { brand: t, dictionary: r } = J(), a = _(() => {
    e(N.EnterEmail);
  }, [e]);
  return /* @__PURE__ */ L("div", { className: et, children: [
    /* @__PURE__ */ s(
      mr,
      {
        icon: /* @__PURE__ */ s(gs, { brand: t, size: 84 }),
        testId: "modal-icon-times-up",
        title: r.labelTimeIsUp,
        text: r.labelVerificationCodeExpired
      }
    ),
    /* @__PURE__ */ s("div", { className: El, children: /* @__PURE__ */ s(
      he,
      {
        className: Ll,
        variant: "primary",
        "data-testid": "modal-start-again-button",
        onClick: a,
        children: r.actionStartAgain
      }
    ) })
  ] });
}, us = ({
  open: e,
  onClose: t,
  onSuccessfulLogin: r,
  variation: a = "default",
  testId: n
}) => {
  const [i, o] = A(N.EnterEmail), { locale: l } = J(), c = _(() => {
    t(), o(N.EnterEmail);
  }, [t]), d = Ze(() => {
    switch (i) {
      case N.EnterEmail:
        return /* @__PURE__ */ s(rs, { setActiveStep: o, variation: a });
      case N.EnterOtpCode:
        return /* @__PURE__ */ s(os, { setActiveStep: o });
      case N.SuccessfulLogin:
        return /* @__PURE__ */ s(ps, { onSuccessfulLogin: r, variation: a });
      case N.TimesUp:
        return /* @__PURE__ */ s(fs, { setActiveStep: o });
      case N.SignIn:
      case N.CreateAccount:
        return /* @__PURE__ */ s(cs, { activeStep: i, setActiveStep: o, variation: a });
      default:
        return null;
    }
  }, [i, r, a]);
  return Re(() => {
    if (e) {
      if (a === "limit-reached")
        return W.favoritesReachedLimit(l);
      W.signInPanelDisplayed(l);
    }
  }, [e, a, l]), /* @__PURE__ */ s(
    Ja,
    {
      open: e,
      onClose: c,
      testId: n,
      hideCloseButton: i === N.SuccessfulLogin,
      children: /* @__PURE__ */ s("div", { className: xl, children: d })
    }
  );
}, hs = () => !!xe.getCookieByName("VDS_ID") || !!xe.getCookieByName("expCartId"), ys = ({
  config: e,
  children: t,
  variation: r = "default"
}) => {
  const { itineraryService: a } = J(), [n, i] = A(hs()), [o, l] = A(r), [c, d] = A(!1), [g, f] = A(null), [u, y] = A(!1), m = _((b, C = !1) => (d(!0), y(C), b && l(b), new Promise((S, x) => {
    f({ resolve: S, reject: x });
  })), []), h = _(async () => {
    await a.getFavorites(!0), i(!0), d(!1), g && (g.resolve(!0), f(null));
  }, [g, a]), v = Ze(
    () => ({
      identityService: new ya(e),
      isLoggedIn: n,
      authenticateUser: m,
      isWatchlist: u
      // TODO: Remove after A/B test
    }),
    [m, e, n, u]
  );
  return /* @__PURE__ */ L(Ln.Provider, { value: v, children: [
    t,
    /* @__PURE__ */ s(
      us,
      {
        onClose: () => d(!1),
        onSuccessfulLogin: h,
        open: c,
        testId: "authentication-modal",
        variation: o
      }
    )
  ] });
}, wd = ({
  config: e,
  env: t,
  children: r,
  authenticationModalVariation: a = "default"
}) => {
  const [n, i] = A(), { itineraryService: o } = Ze(
    () => ({
      itineraryService: new ga(e)
    }),
    [e]
  );
  Re(() => {
    o && (async () => {
      const d = await o.getExperience();
      i(d);
    })();
  }, [o]);
  const l = Ze(
    () => ({
      env: t,
      brand: e.brand,
      locale: e.locale,
      dictionary: _e.isRoyal(e.brand) ? nr : Si,
      itineraryService: o,
      variation: n,
      setVariation: i
      // TODO: Remove after A/B test
    }),
    [e.brand, e.locale, t, o, n]
  );
  return /* @__PURE__ */ s(Qa.Provider, { value: l, children: /* @__PURE__ */ s(ys, { config: e, variation: a, children: r }) });
};
var ms = "_14o4ski0", qr = { base: "_14o4ski1", saved: "_14o4ski2" }, Kr = { base: "_14o4ski3", saved: "_14o4ski4" }, kt = /* @__PURE__ */ ((e) => (e.Icon = "icon", e.WithText = "withText", e))(kt || {});
const Xr = ({ brand: e, size: t, fill: r = R.palette.surface.footer, ...a }) => {
  const n = s("svg", { role: "icon", "data-testid": "heart-rcl-filled", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...a, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.4165 7.73239C19.5623 5.41691 23.156 5.42255 25.392 7.7493C27.536 10.0817 27.536 13.8338 25.392 16.0648L17.1181 24.6746C16.5279 25.2887 15.5473 25.2909 14.957 24.6767C12.6714 22.2983 7.4866 16.903 6.68106 16.0648C4.43965 13.8338 4.43965 10.0817 6.68106 7.7493C8.81995 5.42243 12.4137 5.41691 14.6562 7.73276C14.6616 7.73826 14.6669 7.74377 14.6722 7.7493L16.0365 9.16901L17.4009 7.7493C17.4061 7.74365 17.4113 7.73801 17.4165 7.73239Z", fill: r }) }), i = s("svg", { role: "icon", "data-testid": "heart-cel-filled", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...a, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3935 7.71104C18.5272 6.53492 20.0993 5.91187 21.6925 6.01008C24.6374 6.16961 27 8.91303 27 12.1148C27.0032 14.5039 25.9983 16.7709 24.2406 18.3337L21.9349 20.3834L21.9348 20.3686L16.001 25.6291L7.76141 18.3342C6.00532 16.7764 5 14.5112 5 12.1203C5 8.9266 7.36247 6.18015 10.3437 6.00887L10.6199 6.00731C13.0776 6.00731 15.1675 7.64115 15.9305 9.90722L15.9987 10.1257L16.075 9.87979C16.3137 9.17531 16.6851 8.52107 17.1759 7.9504L17.3935 7.71104Z", fill: r }) });
  return e === X.CEL ? i : n;
}, vs = ({ brand: e, size: t, fill: r = R.palette.surface.footer, ...a }) => {
  const n = s("svg", { role: "icon", "data-testid": "heart-rcl-stroke", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...a, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.68106 8.2093C4.43965 10.5417 4.43965 14.2938 6.68106 16.5248L14.8502 25.0255C15.4995 25.7011 16.577 25.6976 17.2262 25.022L25.392 16.5248C27.536 14.2938 27.536 10.5417 25.392 8.2093C23.156 5.88256 19.5623 5.87692 17.4165 8.1924L16.0365 9.62902L14.6562 8.19276C12.4137 5.87692 8.81995 5.88243 6.68106 8.2093ZM13.2734 9.53188C13.2726 9.53109 13.2718 9.53029 13.2711 9.5295C11.7696 7.98149 9.45931 8.03139 8.09829 9.51203L8.08384 9.52775L8.06904 9.54314C6.5273 11.1475 6.57 13.6982 8.03907 15.1604L8.05422 15.1755L16.0365 23.4818L24.004 15.191C25.4119 13.7259 25.4569 11.1415 23.9892 9.52775C22.4911 7.98499 20.1895 8.03221 18.8284 9.50087L18.8167 9.5135L16.0369 12.4075L13.2734 9.53188Z", fill: r }) }), i = s("svg", { role: "icon", "data-testid": "heart-cel-stroke", xmlns: "http://www.w3.org/2000/svg", width: t, height: t, viewBox: "0 0 32 32", fill: "none", ...a, children: s("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.3935 7.71104C18.5272 6.53492 20.0993 5.91187 21.6925 6.01008C24.6374 6.16961 27 8.91303 27 12.1148C27.0032 14.5039 25.9983 16.7709 24.2406 18.3337L21.9349 20.3834L21.9348 20.3686L16.001 25.6291L7.76141 18.3342C6.00532 16.7764 5 14.5112 5 12.1203C5 8.9266 7.36247 6.18015 10.3437 6.00887L10.6199 6.00731C13.0776 6.00731 15.1675 7.64115 15.9305 9.90722L15.9987 10.1257L16.075 9.87979C16.3137 9.17531 16.6851 8.52107 17.1759 7.9504L17.3935 7.71104ZM25.7059 12.1157C25.7059 9.57515 23.8525 7.4231 21.6129 7.30175C20.4012 7.22705 19.1978 7.70397 18.326 8.60839C17.5092 9.45859 17.0585 10.5836 17.0559 11.7839L17.0545 12.4295H14.9483L14.9456 11.7852C14.9352 9.30616 12.9918 7.30143 10.6235 7.30142L10.3846 7.3019C8.14919 7.43099 6.29412 9.58758 6.29412 12.1203C6.29412 14.1434 7.14272 16.0554 8.61973 17.3656L16 23.8989L23.2291 17.4934L23.2289 17.5008L23.3807 17.3665C24.7733 16.1284 25.6066 14.3604 25.6976 12.4712L25.7059 12.1157Z", fill: r }) });
  return e === X.CEL ? i : n;
}, zn = ({
  isSaved: e,
  onClick: t,
  variant: r,
  text: a,
  size: n = 30,
  className: i,
  testId: o,
  hideIcon: l,
  isDisabled: c = !1,
  dataId: d
}) => {
  const [g, f] = pe.useState(!1), { brand: u } = J();
  return r === kt.WithText ? /* @__PURE__ */ L(
    he,
    {
      size: "small",
      variant: "secondary",
      className: Q(!e || g ? qr.base : qr.saved, i),
      onClick: t,
      "data-testid": o,
      onMouseEnter: () => f(!0),
      onMouseLeave: () => f(!1),
      disabled: c,
      "data-id": d,
      children: [
        !l && /* @__PURE__ */ s(K, { children: e && !g ? /* @__PURE__ */ s(Xr, { fill: ue.palette.icon.error, brand: u, size: 25 }) : /* @__PURE__ */ s(
          vs,
          {
            fill: _e.isRoyal(u) ? ue.palette.icon.accent : ue.palette.icon.brand,
            brand: u,
            size: 25
          }
        ) }),
        e && a.hover && g ? /* @__PURE__ */ s("span", { children: a.hover }) : /* @__PURE__ */ s("span", { children: e ? a.saved : a.unsaved })
      ]
    }
  ) : /* @__PURE__ */ s("button", { className: Q(ms, i), onClick: t, "data-testid": o, "data-id": d, children: /* @__PURE__ */ s(
    Xr,
    {
      className: e ? Kr.saved : Kr.base,
      fill: e ? ue.palette.icon.error : ue.palette.icon.reversed,
      brand: u,
      size: n
    }
  ) });
};
var bs = "_1t7do610", xs = "_1t7do611", Cs = "_1t7do612", Qr = "_1t7do613", Ss = "_1t7do614", ws = "_1t7do615";
const Fn = ({
  isStateroom: e,
  open: t,
  onClose: r,
  testId: a
}) => {
  const { brand: n, dictionary: i, variation: o } = J(), l = e && o === B.LEGACY;
  return /* @__PURE__ */ s(Ja, { open: t, onClose: r, testId: a, children: /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s("div", { className: Ss, children: /* @__PURE__ */ s(gn, { className: ws, size: 84, brand: n }) }),
    /* @__PURE__ */ s(fr, { className: bs, "data-testid": `${a}-title`, children: l ? i.labelLimitReachedSTitleWatchlist : i.labelLimitReachedTitle }),
    /* @__PURE__ */ s(ur, { className: xs, "data-testid": `${a}-text`, children: l ? i.labelCleanUpFavoritesWatchlist : i.labelCleanUpFavorites }),
    l ? /* @__PURE__ */ s("a", { className: Qr, href: "/watchlist", "data-testid": `${a}-navigation-link`, children: i.actionGoToDashboardWatchlist }) : /* @__PURE__ */ s("a", { className: Qr, href: "/favorites", "data-testid": `${a}-navigation-link`, children: i.actionGoToDashboard }),
    /* @__PURE__ */ s(
      he,
      {
        className: Cs,
        onClick: r,
        "data-testid": `${a}-okay-button`,
        children: i.labelOkay
      }
    )
  ] }) });
}, Es = ["top", "right", "bottom", "left"], Ee = Math.min, ee = Math.max, Ct = Math.round, dt = Math.floor, ce = (e) => ({
  x: e,
  y: e
}), Ls = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, ks = {
  start: "end",
  end: "start"
};
function Xt(e, t, r) {
  return ee(e, Ee(t, r));
}
function ye(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function me(e) {
  return e.split("-")[0];
}
function We(e) {
  return e.split("-")[1];
}
function vr(e) {
  return e === "x" ? "y" : "x";
}
function br(e) {
  return e === "y" ? "height" : "width";
}
function Le(e) {
  return ["top", "bottom"].includes(me(e)) ? "y" : "x";
}
function xr(e) {
  return vr(Le(e));
}
function Rs(e, t, r) {
  r === void 0 && (r = !1);
  const a = We(e), n = xr(e), i = br(n);
  let o = n === "x" ? a === (r ? "end" : "start") ? "right" : "left" : a === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = St(o)), [o, St(o)];
}
function zs(e) {
  const t = St(e);
  return [Qt(e), t, Qt(t)];
}
function Qt(e) {
  return e.replace(/start|end/g, (t) => ks[t]);
}
function Fs(e, t, r) {
  const a = ["left", "right"], n = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? n : a : t ? a : n;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function Ts(e, t, r, a) {
  const n = We(e);
  let i = Fs(me(e), r === "start", a);
  return n && (i = i.map((o) => o + "-" + n), t && (i = i.concat(i.map(Qt)))), i;
}
function St(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Ls[t]);
}
function As(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Tn(e) {
  return typeof e != "number" ? As(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function wt(e) {
  const {
    x: t,
    y: r,
    width: a,
    height: n
  } = e;
  return {
    width: a,
    height: n,
    top: r,
    left: t,
    right: t + a,
    bottom: r + n,
    x: t,
    y: r
  };
}
function Jr(e, t, r) {
  let {
    reference: a,
    floating: n
  } = e;
  const i = Le(t), o = xr(t), l = br(o), c = me(t), d = i === "y", g = a.x + a.width / 2 - n.width / 2, f = a.y + a.height / 2 - n.height / 2, u = a[l] / 2 - n[l] / 2;
  let y;
  switch (c) {
    case "top":
      y = {
        x: g,
        y: a.y - n.height
      };
      break;
    case "bottom":
      y = {
        x: g,
        y: a.y + a.height
      };
      break;
    case "right":
      y = {
        x: a.x + a.width,
        y: f
      };
      break;
    case "left":
      y = {
        x: a.x - n.width,
        y: f
      };
      break;
    default:
      y = {
        x: a.x,
        y: a.y
      };
  }
  switch (We(t)) {
    case "start":
      y[o] -= u * (r && d ? -1 : 1);
      break;
    case "end":
      y[o] += u * (r && d ? -1 : 1);
      break;
  }
  return y;
}
const Ps = async (e, t, r) => {
  const {
    placement: a = "bottom",
    strategy: n = "absolute",
    middleware: i = [],
    platform: o
  } = r, l = i.filter(Boolean), c = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let d = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: g,
    y: f
  } = Jr(d, a, c), u = a, y = {}, m = 0;
  for (let h = 0; h < l.length; h++) {
    const {
      name: v,
      fn: b
    } = l[h], {
      x: C,
      y: S,
      data: x,
      reset: w
    } = await b({
      x: g,
      y: f,
      initialPlacement: a,
      placement: u,
      strategy: n,
      middlewareData: y,
      rects: d,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    g = C ?? g, f = S ?? f, y = {
      ...y,
      [v]: {
        ...y[v],
        ...x
      }
    }, w && m <= 50 && (m++, typeof w == "object" && (w.placement && (u = w.placement), w.rects && (d = w.rects === !0 ? await o.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : w.rects), {
      x: g,
      y: f
    } = Jr(d, u, c)), h = -1);
  }
  return {
    x: g,
    y: f,
    placement: u,
    strategy: n,
    middlewareData: y
  };
};
async function Xe(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: a,
    y: n,
    platform: i,
    rects: o,
    elements: l,
    strategy: c
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: g = "viewport",
    elementContext: f = "floating",
    altBoundary: u = !1,
    padding: y = 0
  } = ye(t, e), m = Tn(y), v = l[u ? f === "floating" ? "reference" : "floating" : f], b = wt(await i.getClippingRect({
    element: (r = await (i.isElement == null ? void 0 : i.isElement(v))) == null || r ? v : v.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: d,
    rootBoundary: g,
    strategy: c
  })), C = f === "floating" ? {
    x: a,
    y: n,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), x = await (i.isElement == null ? void 0 : i.isElement(S)) ? await (i.getScale == null ? void 0 : i.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = wt(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: l,
    rect: C,
    offsetParent: S,
    strategy: c
  }) : C);
  return {
    top: (b.top - w.top + m.top) / x.y,
    bottom: (w.bottom - b.bottom + m.bottom) / x.y,
    left: (b.left - w.left + m.left) / x.x,
    right: (w.right - b.right + m.right) / x.x
  };
}
const Os = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: r,
      y: a,
      placement: n,
      rects: i,
      platform: o,
      elements: l,
      middlewareData: c
    } = t, {
      element: d,
      padding: g = 0
    } = ye(e, t) || {};
    if (d == null)
      return {};
    const f = Tn(g), u = {
      x: r,
      y: a
    }, y = xr(n), m = br(y), h = await o.getDimensions(d), v = y === "y", b = v ? "top" : "left", C = v ? "bottom" : "right", S = v ? "clientHeight" : "clientWidth", x = i.reference[m] + i.reference[y] - u[y] - i.floating[m], w = u[y] - i.reference[y], k = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(d));
    let E = k ? k[S] : 0;
    (!E || !await (o.isElement == null ? void 0 : o.isElement(k))) && (E = l.floating[S] || i.floating[m]);
    const T = x / 2 - w / 2, H = E / 2 - h[m] / 2 - 1, P = Ee(f[b], H), j = Ee(f[C], H), Y = P, I = E - h[m] - j, O = E / 2 - h[m] / 2 + T, re = Xt(Y, O, I), D = !c.arrow && We(n) != null && O !== re && i.reference[m] / 2 - (O < Y ? P : j) - h[m] / 2 < 0, M = D ? O < Y ? O - Y : O - I : 0;
    return {
      [y]: u[y] + M,
      data: {
        [y]: re,
        centerOffset: O - re - M,
        ...D && {
          alignmentOffset: M
        }
      },
      reset: D
    };
  }
}), Ns = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: n,
        middlewareData: i,
        rects: o,
        initialPlacement: l,
        platform: c,
        elements: d
      } = t, {
        mainAxis: g = !0,
        crossAxis: f = !0,
        fallbackPlacements: u,
        fallbackStrategy: y = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: h = !0,
        ...v
      } = ye(e, t);
      if ((r = i.arrow) != null && r.alignmentOffset)
        return {};
      const b = me(n), C = Le(l), S = me(l) === l, x = await (c.isRTL == null ? void 0 : c.isRTL(d.floating)), w = u || (S || !h ? [St(l)] : zs(l)), k = m !== "none";
      !u && k && w.push(...Ts(l, h, m, x));
      const E = [l, ...w], T = await Xe(t, v), H = [];
      let P = ((a = i.flip) == null ? void 0 : a.overflows) || [];
      if (g && H.push(T[b]), f) {
        const O = Rs(n, o, x);
        H.push(T[O[0]], T[O[1]]);
      }
      if (P = [...P, {
        placement: n,
        overflows: H
      }], !H.every((O) => O <= 0)) {
        var j, Y;
        const O = (((j = i.flip) == null ? void 0 : j.index) || 0) + 1, re = E[O];
        if (re)
          return {
            data: {
              index: O,
              overflows: P
            },
            reset: {
              placement: re
            }
          };
        let D = (Y = P.filter((M) => M.overflows[0] <= 0).sort((M, F) => M.overflows[1] - F.overflows[1])[0]) == null ? void 0 : Y.placement;
        if (!D)
          switch (y) {
            case "bestFit": {
              var I;
              const M = (I = P.filter((F) => {
                if (k) {
                  const U = Le(F.placement);
                  return U === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  U === "y";
                }
                return !0;
              }).map((F) => [F.placement, F.overflows.filter((U) => U > 0).reduce((U, le) => U + le, 0)]).sort((F, U) => F[1] - U[1])[0]) == null ? void 0 : I[0];
              M && (D = M);
              break;
            }
            case "initialPlacement":
              D = l;
              break;
          }
        if (n !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
};
function ea(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ta(e) {
  return Es.some((t) => e[t] >= 0);
}
const Hs = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: r
      } = t, {
        strategy: a = "referenceHidden",
        ...n
      } = ye(e, t);
      switch (a) {
        case "referenceHidden": {
          const i = await Xe(t, {
            ...n,
            elementContext: "reference"
          }), o = ea(i, r.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: ta(o)
            }
          };
        }
        case "escaped": {
          const i = await Xe(t, {
            ...n,
            altBoundary: !0
          }), o = ea(i, r.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: ta(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function Is(e, t) {
  const {
    placement: r,
    platform: a,
    elements: n
  } = e, i = await (a.isRTL == null ? void 0 : a.isRTL(n.floating)), o = me(r), l = We(r), c = Le(r) === "y", d = ["left", "top"].includes(o) ? -1 : 1, g = i && c ? -1 : 1, f = ye(t, e);
  let {
    mainAxis: u,
    crossAxis: y,
    alignmentAxis: m
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return l && typeof m == "number" && (y = l === "end" ? m * -1 : m), c ? {
    x: y * g,
    y: u * d
  } : {
    x: u * d,
    y: y * g
  };
}
const Ds = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, a;
      const {
        x: n,
        y: i,
        placement: o,
        middlewareData: l
      } = t, c = await Is(t, e);
      return o === ((r = l.offset) == null ? void 0 : r.placement) && (a = l.arrow) != null && a.alignmentOffset ? {} : {
        x: n + c.x,
        y: i + c.y,
        data: {
          ...c,
          placement: o
        }
      };
    }
  };
}, Ms = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: a,
        placement: n
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (v) => {
            let {
              x: b,
              y: C
            } = v;
            return {
              x: b,
              y: C
            };
          }
        },
        ...c
      } = ye(e, t), d = {
        x: r,
        y: a
      }, g = await Xe(t, c), f = Le(me(n)), u = vr(f);
      let y = d[u], m = d[f];
      if (i) {
        const v = u === "y" ? "top" : "left", b = u === "y" ? "bottom" : "right", C = y + g[v], S = y - g[b];
        y = Xt(C, y, S);
      }
      if (o) {
        const v = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", C = m + g[v], S = m - g[b];
        m = Xt(C, m, S);
      }
      const h = l.fn({
        ...t,
        [u]: y,
        [f]: m
      });
      return {
        ...h,
        data: {
          x: h.x - r,
          y: h.y - a,
          enabled: {
            [u]: i,
            [f]: o
          }
        }
      };
    }
  };
}, _s = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: r,
        y: a,
        placement: n,
        rects: i,
        middlewareData: o
      } = t, {
        offset: l = 0,
        mainAxis: c = !0,
        crossAxis: d = !0
      } = ye(e, t), g = {
        x: r,
        y: a
      }, f = Le(n), u = vr(f);
      let y = g[u], m = g[f];
      const h = ye(l, t), v = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (c) {
        const S = u === "y" ? "height" : "width", x = i.reference[u] - i.floating[S] + v.mainAxis, w = i.reference[u] + i.reference[S] - v.mainAxis;
        y < x ? y = x : y > w && (y = w);
      }
      if (d) {
        var b, C;
        const S = u === "y" ? "width" : "height", x = ["top", "left"].includes(me(n)), w = i.reference[f] - i.floating[S] + (x && ((b = o.offset) == null ? void 0 : b[f]) || 0) + (x ? 0 : v.crossAxis), k = i.reference[f] + i.reference[S] + (x ? 0 : ((C = o.offset) == null ? void 0 : C[f]) || 0) - (x ? v.crossAxis : 0);
        m < w ? m = w : m > k && (m = k);
      }
      return {
        [u]: y,
        [f]: m
      };
    }
  };
}, $s = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var r, a;
      const {
        placement: n,
        rects: i,
        platform: o,
        elements: l
      } = t, {
        apply: c = () => {
        },
        ...d
      } = ye(e, t), g = await Xe(t, d), f = me(n), u = We(n), y = Le(n) === "y", {
        width: m,
        height: h
      } = i.floating;
      let v, b;
      f === "top" || f === "bottom" ? (v = f, b = u === (await (o.isRTL == null ? void 0 : o.isRTL(l.floating)) ? "start" : "end") ? "left" : "right") : (b = f, v = u === "end" ? "top" : "bottom");
      const C = h - g.top - g.bottom, S = m - g.left - g.right, x = Ee(h - g[v], C), w = Ee(m - g[b], S), k = !t.middlewareData.shift;
      let E = x, T = w;
      if ((r = t.middlewareData.shift) != null && r.enabled.x && (T = S), (a = t.middlewareData.shift) != null && a.enabled.y && (E = C), k && !u) {
        const P = ee(g.left, 0), j = ee(g.right, 0), Y = ee(g.top, 0), I = ee(g.bottom, 0);
        y ? T = m - 2 * (P !== 0 || j !== 0 ? P + j : ee(g.left, g.right)) : E = h - 2 * (Y !== 0 || I !== 0 ? Y + I : ee(g.top, g.bottom));
      }
      await c({
        ...t,
        availableWidth: T,
        availableHeight: E
      });
      const H = await o.getDimensions(l.floating);
      return m !== H.width || h !== H.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Rt() {
  return typeof window < "u";
}
function Ue(e) {
  return An(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function te(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function fe(e) {
  var t;
  return (t = (An(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function An(e) {
  return Rt() ? e instanceof Node || e instanceof te(e).Node : !1;
}
function ie(e) {
  return Rt() ? e instanceof Element || e instanceof te(e).Element : !1;
}
function de(e) {
  return Rt() ? e instanceof HTMLElement || e instanceof te(e).HTMLElement : !1;
}
function ra(e) {
  return !Rt() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof te(e).ShadowRoot;
}
function tt(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: a,
    display: n
  } = oe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + a + r) && !["inline", "contents"].includes(n);
}
function Bs(e) {
  return ["table", "td", "th"].includes(Ue(e));
}
function zt(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Cr(e) {
  const t = Sr(), r = ie(e) ? oe(e) : e;
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((a) => (r.willChange || "").includes(a)) || ["paint", "layout", "strict", "content"].some((a) => (r.contain || "").includes(a));
}
function Ws(e) {
  let t = ke(e);
  for (; de(t) && !De(t); ) {
    if (Cr(t))
      return t;
    if (zt(t))
      return null;
    t = ke(t);
  }
  return null;
}
function Sr() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function De(e) {
  return ["html", "body", "#document"].includes(Ue(e));
}
function oe(e) {
  return te(e).getComputedStyle(e);
}
function Ft(e) {
  return ie(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ke(e) {
  if (Ue(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    ra(e) && e.host || // Fallback.
    fe(e)
  );
  return ra(t) ? t.host : t;
}
function Pn(e) {
  const t = ke(e);
  return De(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : de(t) && tt(t) ? t : Pn(t);
}
function Qe(e, t, r) {
  var a;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const n = Pn(e), i = n === ((a = e.ownerDocument) == null ? void 0 : a.body), o = te(n);
  if (i) {
    const l = Jt(o);
    return t.concat(o, o.visualViewport || [], tt(n) ? n : [], l && r ? Qe(l) : []);
  }
  return t.concat(n, Qe(n, [], r));
}
function Jt(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function On(e) {
  const t = oe(e);
  let r = parseFloat(t.width) || 0, a = parseFloat(t.height) || 0;
  const n = de(e), i = n ? e.offsetWidth : r, o = n ? e.offsetHeight : a, l = Ct(r) !== i || Ct(a) !== o;
  return l && (r = i, a = o), {
    width: r,
    height: a,
    $: l
  };
}
function wr(e) {
  return ie(e) ? e : e.contextElement;
}
function Ie(e) {
  const t = wr(e);
  if (!de(t))
    return ce(1);
  const r = t.getBoundingClientRect(), {
    width: a,
    height: n,
    $: i
  } = On(t);
  let o = (i ? Ct(r.width) : r.width) / a, l = (i ? Ct(r.height) : r.height) / n;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}
const Us = /* @__PURE__ */ ce(0);
function Nn(e) {
  const t = te(e);
  return !Sr() || !t.visualViewport ? Us : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function Vs(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== te(e) ? !1 : t;
}
function Te(e, t, r, a) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const n = e.getBoundingClientRect(), i = wr(e);
  let o = ce(1);
  t && (a ? ie(a) && (o = Ie(a)) : o = Ie(e));
  const l = Vs(i, r, a) ? Nn(i) : ce(0);
  let c = (n.left + l.x) / o.x, d = (n.top + l.y) / o.y, g = n.width / o.x, f = n.height / o.y;
  if (i) {
    const u = te(i), y = a && ie(a) ? te(a) : a;
    let m = u, h = Jt(m);
    for (; h && a && y !== m; ) {
      const v = Ie(h), b = h.getBoundingClientRect(), C = oe(h), S = b.left + (h.clientLeft + parseFloat(C.paddingLeft)) * v.x, x = b.top + (h.clientTop + parseFloat(C.paddingTop)) * v.y;
      c *= v.x, d *= v.y, g *= v.x, f *= v.y, c += S, d += x, m = te(h), h = Jt(m);
    }
  }
  return wt({
    width: g,
    height: f,
    x: c,
    y: d
  });
}
function Er(e, t) {
  const r = Ft(e).scrollLeft;
  return t ? t.left + r : Te(fe(e)).left + r;
}
function Hn(e, t, r) {
  r === void 0 && (r = !1);
  const a = e.getBoundingClientRect(), n = a.left + t.scrollLeft - (r ? 0 : (
    // RTL <body> scrollbar.
    Er(e, a)
  )), i = a.top + t.scrollTop;
  return {
    x: n,
    y: i
  };
}
function Zs(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: a,
    strategy: n
  } = e;
  const i = n === "fixed", o = fe(a), l = t ? zt(t.floating) : !1;
  if (a === o || l && i)
    return r;
  let c = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = ce(1);
  const g = ce(0), f = de(a);
  if ((f || !f && !i) && ((Ue(a) !== "body" || tt(o)) && (c = Ft(a)), de(a))) {
    const y = Te(a);
    d = Ie(a), g.x = y.x + a.clientLeft, g.y = y.y + a.clientTop;
  }
  const u = o && !f && !i ? Hn(o, c, !0) : ce(0);
  return {
    width: r.width * d.x,
    height: r.height * d.y,
    x: r.x * d.x - c.scrollLeft * d.x + g.x + u.x,
    y: r.y * d.y - c.scrollTop * d.y + g.y + u.y
  };
}
function Gs(e) {
  return Array.from(e.getClientRects());
}
function js(e) {
  const t = fe(e), r = Ft(e), a = e.ownerDocument.body, n = ee(t.scrollWidth, t.clientWidth, a.scrollWidth, a.clientWidth), i = ee(t.scrollHeight, t.clientHeight, a.scrollHeight, a.clientHeight);
  let o = -r.scrollLeft + Er(e);
  const l = -r.scrollTop;
  return oe(a).direction === "rtl" && (o += ee(t.clientWidth, a.clientWidth) - n), {
    width: n,
    height: i,
    x: o,
    y: l
  };
}
function Ys(e, t) {
  const r = te(e), a = fe(e), n = r.visualViewport;
  let i = a.clientWidth, o = a.clientHeight, l = 0, c = 0;
  if (n) {
    i = n.width, o = n.height;
    const d = Sr();
    (!d || d && t === "fixed") && (l = n.offsetLeft, c = n.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: l,
    y: c
  };
}
function qs(e, t) {
  const r = Te(e, !0, t === "fixed"), a = r.top + e.clientTop, n = r.left + e.clientLeft, i = de(e) ? Ie(e) : ce(1), o = e.clientWidth * i.x, l = e.clientHeight * i.y, c = n * i.x, d = a * i.y;
  return {
    width: o,
    height: l,
    x: c,
    y: d
  };
}
function aa(e, t, r) {
  let a;
  if (t === "viewport")
    a = Ys(e, r);
  else if (t === "document")
    a = js(fe(e));
  else if (ie(t))
    a = qs(t, r);
  else {
    const n = Nn(e);
    a = {
      x: t.x - n.x,
      y: t.y - n.y,
      width: t.width,
      height: t.height
    };
  }
  return wt(a);
}
function In(e, t) {
  const r = ke(e);
  return r === t || !ie(r) || De(r) ? !1 : oe(r).position === "fixed" || In(r, t);
}
function Ks(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let a = Qe(e, [], !1).filter((l) => ie(l) && Ue(l) !== "body"), n = null;
  const i = oe(e).position === "fixed";
  let o = i ? ke(e) : e;
  for (; ie(o) && !De(o); ) {
    const l = oe(o), c = Cr(o);
    !c && l.position === "fixed" && (n = null), (i ? !c && !n : !c && l.position === "static" && !!n && ["absolute", "fixed"].includes(n.position) || tt(o) && !c && In(e, o)) ? a = a.filter((g) => g !== o) : n = l, o = ke(o);
  }
  return t.set(e, a), a;
}
function Xs(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: a,
    strategy: n
  } = e;
  const o = [...r === "clippingAncestors" ? zt(t) ? [] : Ks(t, this._c) : [].concat(r), a], l = o[0], c = o.reduce((d, g) => {
    const f = aa(t, g, n);
    return d.top = ee(f.top, d.top), d.right = Ee(f.right, d.right), d.bottom = Ee(f.bottom, d.bottom), d.left = ee(f.left, d.left), d;
  }, aa(t, l, n));
  return {
    width: c.right - c.left,
    height: c.bottom - c.top,
    x: c.left,
    y: c.top
  };
}
function Qs(e) {
  const {
    width: t,
    height: r
  } = On(e);
  return {
    width: t,
    height: r
  };
}
function Js(e, t, r) {
  const a = de(t), n = fe(t), i = r === "fixed", o = Te(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const c = ce(0);
  if (a || !a && !i)
    if ((Ue(t) !== "body" || tt(n)) && (l = Ft(t)), a) {
      const u = Te(t, !0, i, t);
      c.x = u.x + t.clientLeft, c.y = u.y + t.clientTop;
    } else n && (c.x = Er(n));
  const d = n && !a && !i ? Hn(n, l) : ce(0), g = o.left + l.scrollLeft - c.x - d.x, f = o.top + l.scrollTop - c.y - d.y;
  return {
    x: g,
    y: f,
    width: o.width,
    height: o.height
  };
}
function Bt(e) {
  return oe(e).position === "static";
}
function na(e, t) {
  if (!de(e) || oe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let r = e.offsetParent;
  return fe(e) === r && (r = r.ownerDocument.body), r;
}
function Dn(e, t) {
  const r = te(e);
  if (zt(e))
    return r;
  if (!de(e)) {
    let n = ke(e);
    for (; n && !De(n); ) {
      if (ie(n) && !Bt(n))
        return n;
      n = ke(n);
    }
    return r;
  }
  let a = na(e, t);
  for (; a && Bs(a) && Bt(a); )
    a = na(a, t);
  return a && De(a) && Bt(a) && !Cr(a) ? r : a || Ws(e) || r;
}
const ec = async function(e) {
  const t = this.getOffsetParent || Dn, r = this.getDimensions, a = await r(e.floating);
  return {
    reference: Js(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: a.width,
      height: a.height
    }
  };
};
function tc(e) {
  return oe(e).direction === "rtl";
}
const rc = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Zs,
  getDocumentElement: fe,
  getClippingRect: Xs,
  getOffsetParent: Dn,
  getElementRects: ec,
  getClientRects: Gs,
  getDimensions: Qs,
  getScale: Ie,
  isElement: ie,
  isRTL: tc
};
function ac(e, t) {
  let r = null, a;
  const n = fe(e);
  function i() {
    var l;
    clearTimeout(a), (l = r) == null || l.disconnect(), r = null;
  }
  function o(l, c) {
    l === void 0 && (l = !1), c === void 0 && (c = 1), i();
    const {
      left: d,
      top: g,
      width: f,
      height: u
    } = e.getBoundingClientRect();
    if (l || t(), !f || !u)
      return;
    const y = dt(g), m = dt(n.clientWidth - (d + f)), h = dt(n.clientHeight - (g + u)), v = dt(d), C = {
      rootMargin: -y + "px " + -m + "px " + -h + "px " + -v + "px",
      threshold: ee(0, Ee(1, c)) || 1
    };
    let S = !0;
    function x(w) {
      const k = w[0].intersectionRatio;
      if (k !== c) {
        if (!S)
          return o();
        k ? o(!1, k) : a = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      S = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...C,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, C);
    }
    r.observe(e);
  }
  return o(!0), i;
}
function nc(e, t, r, a) {
  a === void 0 && (a = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: c = !1
  } = a, d = wr(e), g = n || i ? [...d ? Qe(d) : [], ...Qe(t)] : [];
  g.forEach((b) => {
    n && b.addEventListener("scroll", r, {
      passive: !0
    }), i && b.addEventListener("resize", r);
  });
  const f = d && l ? ac(d, r) : null;
  let u = -1, y = null;
  o && (y = new ResizeObserver((b) => {
    let [C] = b;
    C && C.target === d && y && (y.unobserve(t), cancelAnimationFrame(u), u = requestAnimationFrame(() => {
      var S;
      (S = y) == null || S.observe(t);
    })), r();
  }), d && !c && y.observe(d), y.observe(t));
  let m, h = c ? Te(e) : null;
  c && v();
  function v() {
    const b = Te(e);
    h && (b.x !== h.x || b.y !== h.y || b.width !== h.width || b.height !== h.height) && r(), h = b, m = requestAnimationFrame(v);
  }
  return r(), () => {
    var b;
    g.forEach((C) => {
      n && C.removeEventListener("scroll", r), i && C.removeEventListener("resize", r);
    }), f == null || f(), (b = y) == null || b.disconnect(), y = null, c && cancelAnimationFrame(m);
  };
}
const ic = Ds, oc = Ms, lc = Ns, sc = $s, cc = Hs, ia = Os, dc = _s, pc = (e, t, r) => {
  const a = /* @__PURE__ */ new Map(), n = {
    platform: rc,
    ...r
  }, i = {
    ...n.platform,
    _c: a
  };
  return Ps(e, t, {
    ...n,
    platform: i
  });
};
var ht = typeof document < "u" ? bi : Re;
function Et(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, a, n;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (a = r; a-- !== 0; )
        if (!Et(e[a], t[a]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), r = n.length, r !== Object.keys(t).length)
      return !1;
    for (a = r; a-- !== 0; )
      if (!{}.hasOwnProperty.call(t, n[a]))
        return !1;
    for (a = r; a-- !== 0; ) {
      const i = n[a];
      if (!(i === "_owner" && e.$$typeof) && !Et(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Mn(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function oa(e, t) {
  const r = Mn(e);
  return Math.round(t * r) / r;
}
function Wt(e) {
  const t = p.useRef(e);
  return ht(() => {
    t.current = e;
  }), t;
}
function gc(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: n,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: l = !0,
    whileElementsMounted: c,
    open: d
  } = e, [g, f] = p.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [u, y] = p.useState(a);
  Et(u, a) || y(a);
  const [m, h] = p.useState(null), [v, b] = p.useState(null), C = p.useCallback((F) => {
    F !== k.current && (k.current = F, h(F));
  }, []), S = p.useCallback((F) => {
    F !== E.current && (E.current = F, b(F));
  }, []), x = i || m, w = o || v, k = p.useRef(null), E = p.useRef(null), T = p.useRef(g), H = c != null, P = Wt(c), j = Wt(n), Y = Wt(d), I = p.useCallback(() => {
    if (!k.current || !E.current)
      return;
    const F = {
      placement: t,
      strategy: r,
      middleware: u
    };
    j.current && (F.platform = j.current), pc(k.current, E.current, F).then((U) => {
      const le = {
        ...U,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: Y.current !== !1
      };
      O.current && !Et(T.current, le) && (T.current = le, ca.flushSync(() => {
        f(le);
      }));
    });
  }, [u, t, r, j, Y]);
  ht(() => {
    d === !1 && T.current.isPositioned && (T.current.isPositioned = !1, f((F) => ({
      ...F,
      isPositioned: !1
    })));
  }, [d]);
  const O = p.useRef(!1);
  ht(() => (O.current = !0, () => {
    O.current = !1;
  }), []), ht(() => {
    if (x && (k.current = x), w && (E.current = w), x && w) {
      if (P.current)
        return P.current(x, w, I);
      I();
    }
  }, [x, w, I, P, H]);
  const re = p.useMemo(() => ({
    reference: k,
    floating: E,
    setReference: C,
    setFloating: S
  }), [C, S]), D = p.useMemo(() => ({
    reference: x,
    floating: w
  }), [x, w]), M = p.useMemo(() => {
    const F = {
      position: r,
      left: 0,
      top: 0
    };
    if (!D.floating)
      return F;
    const U = oa(D.floating, g.x), le = oa(D.floating, g.y);
    return l ? {
      ...F,
      transform: "translate(" + U + "px, " + le + "px)",
      ...Mn(D.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: U,
      top: le
    };
  }, [r, l, D.floating, g.x, g.y]);
  return p.useMemo(() => ({
    ...g,
    update: I,
    refs: re,
    elements: D,
    floatingStyles: M
  }), [g, I, re, D, M]);
}
const fc = (e) => {
  function t(r) {
    return {}.hasOwnProperty.call(r, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(r) {
      const {
        element: a,
        padding: n
      } = typeof e == "function" ? e(r) : e;
      return a && t(a) ? a.current != null ? ia({
        element: a.current,
        padding: n
      }).fn(r) : {} : a ? ia({
        element: a,
        padding: n
      }).fn(r) : {};
    }
  };
}, uc = (e, t) => ({
  ...ic(e),
  options: [e, t]
}), hc = (e, t) => ({
  ...oc(e),
  options: [e, t]
}), yc = (e, t) => ({
  ...dc(e),
  options: [e, t]
}), mc = (e, t) => ({
  ...lc(e),
  options: [e, t]
}), vc = (e, t) => ({
  ...sc(e),
  options: [e, t]
}), bc = (e, t) => ({
  ...cc(e),
  options: [e, t]
}), xc = (e, t) => ({
  ...fc(e),
  options: [e, t]
});
var Cc = "Arrow", _n = p.forwardRef((e, t) => {
  const { children: r, width: a = 10, height: n = 5, ...i } = e;
  return /* @__PURE__ */ s(
    G.svg,
    {
      ...i,
      ref: t,
      width: a,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? r : /* @__PURE__ */ s("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
_n.displayName = Cc;
var Sc = _n;
function wc(e, t = []) {
  let r = [];
  function a(i, o) {
    const l = p.createContext(o), c = r.length;
    r = [...r, o];
    function d(f) {
      const { scope: u, children: y, ...m } = f, h = (u == null ? void 0 : u[e][c]) || l, v = p.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ s(h.Provider, { value: v, children: y });
    }
    function g(f, u) {
      const y = (u == null ? void 0 : u[e][c]) || l, m = p.useContext(y);
      if (m) return m;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${i}\``);
    }
    return d.displayName = i + "Provider", [d, g];
  }
  const n = () => {
    const i = r.map((o) => p.createContext(o));
    return function(l) {
      const c = (l == null ? void 0 : l[e]) || i;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...l, [e]: c } }),
        [l, c]
      );
    };
  };
  return n.scopeName = e, [a, Ec(n, ...t)];
}
function Ec(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const r = () => {
    const a = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(i) {
      const o = a.reduce((l, { useScope: c, scopeName: d }) => {
        const f = c(i)[`__scope${d}`];
        return { ...l, ...f };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: o }), [o]);
    };
  };
  return r.scopeName = t.scopeName, r;
}
var Lr = "Popper", [$n, Bn] = wc(Lr), [Lc, Wn] = $n(Lr), Un = (e) => {
  const { __scopePopper: t, children: r } = e, [a, n] = p.useState(null);
  return /* @__PURE__ */ s(Lc, { scope: t, anchor: a, onAnchorChange: n, children: r });
};
Un.displayName = Lr;
var Vn = "PopperAnchor", Zn = p.forwardRef(
  (e, t) => {
    const { __scopePopper: r, virtualRef: a, ...n } = e, i = Wn(Vn, r), o = p.useRef(null), l = ae(t, o);
    return p.useEffect(() => {
      i.onAnchorChange((a == null ? void 0 : a.current) || o.current);
    }), a ? null : /* @__PURE__ */ s(G.div, { ...n, ref: l });
  }
);
Zn.displayName = Vn;
var kr = "PopperContent", [kc, Rc] = $n(kr), Gn = p.forwardRef(
  (e, t) => {
    var Fr, Tr, Ar, Pr, Or, Nr;
    const {
      __scopePopper: r,
      side: a = "bottom",
      sideOffset: n = 0,
      align: i = "center",
      alignOffset: o = 0,
      arrowPadding: l = 0,
      avoidCollisions: c = !0,
      collisionBoundary: d = [],
      collisionPadding: g = 0,
      sticky: f = "partial",
      hideWhenDetached: u = !1,
      updatePositionStrategy: y = "optimized",
      onPlaced: m,
      ...h
    } = e, v = Wn(kr, r), [b, C] = p.useState(null), S = ae(t, (Ve) => C(Ve)), [x, w] = p.useState(null), k = mn(x), E = (k == null ? void 0 : k.width) ?? 0, T = (k == null ? void 0 : k.height) ?? 0, H = a + (i !== "center" ? "-" + i : ""), P = typeof g == "number" ? g : { top: 0, right: 0, bottom: 0, left: 0, ...g }, j = Array.isArray(d) ? d : [d], Y = j.length > 0, I = {
      padding: P,
      boundary: j.filter(Fc),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: Y
    }, { refs: O, floatingStyles: re, placement: D, isPositioned: M, middlewareData: F } = gc({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: H,
      whileElementsMounted: (...Ve) => nc(...Ve, {
        animationFrame: y === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        uc({ mainAxis: n + T, alignmentAxis: o }),
        c && hc({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? yc() : void 0,
          ...I
        }),
        c && mc({ ...I }),
        vc({
          ...I,
          apply: ({ elements: Ve, rects: Hr, availableWidth: fi, availableHeight: ui }) => {
            const { width: hi, height: yi } = Hr.reference, nt = Ve.floating.style;
            nt.setProperty("--radix-popper-available-width", `${fi}px`), nt.setProperty("--radix-popper-available-height", `${ui}px`), nt.setProperty("--radix-popper-anchor-width", `${hi}px`), nt.setProperty("--radix-popper-anchor-height", `${yi}px`);
          }
        }),
        x && xc({ element: x, padding: l }),
        Tc({ arrowWidth: E, arrowHeight: T }),
        u && bc({ strategy: "referenceHidden", ...I })
      ]
    }), [U, le] = qn(D), at = we(m);
    ze(() => {
      M && (at == null || at());
    }, [M, at]);
    const si = (Fr = F.arrow) == null ? void 0 : Fr.x, ci = (Tr = F.arrow) == null ? void 0 : Tr.y, di = ((Ar = F.arrow) == null ? void 0 : Ar.centerOffset) !== 0, [pi, gi] = p.useState();
    return ze(() => {
      b && gi(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ s(
      "div",
      {
        ref: O.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...re,
          transform: M ? re.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: pi,
          "--radix-popper-transform-origin": [
            (Pr = F.transformOrigin) == null ? void 0 : Pr.x,
            (Or = F.transformOrigin) == null ? void 0 : Or.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((Nr = F.hide) == null ? void 0 : Nr.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ s(
          kc,
          {
            scope: r,
            placedSide: U,
            onArrowChange: w,
            arrowX: si,
            arrowY: ci,
            shouldHideArrow: di,
            children: /* @__PURE__ */ s(
              G.div,
              {
                "data-side": U,
                "data-align": le,
                ...h,
                ref: S,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: M ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Gn.displayName = kr;
var jn = "PopperArrow", zc = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, Yn = p.forwardRef(function(t, r) {
  const { __scopePopper: a, ...n } = t, i = Rc(jn, a), o = zc[i.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ s(
      "span",
      {
        ref: i.onArrowChange,
        style: {
          position: "absolute",
          left: i.arrowX,
          top: i.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[i.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[i.placedSide],
          visibility: i.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ s(
          Sc,
          {
            ...n,
            ref: r,
            style: {
              ...n.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
Yn.displayName = jn;
function Fc(e) {
  return e !== null;
}
var Tc = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var v, b, C;
    const { placement: r, rects: a, middlewareData: n } = t, o = ((v = n.arrow) == null ? void 0 : v.centerOffset) !== 0, l = o ? 0 : e.arrowWidth, c = o ? 0 : e.arrowHeight, [d, g] = qn(r), f = { start: "0%", center: "50%", end: "100%" }[g], u = (((b = n.arrow) == null ? void 0 : b.x) ?? 0) + l / 2, y = (((C = n.arrow) == null ? void 0 : C.y) ?? 0) + c / 2;
    let m = "", h = "";
    return d === "bottom" ? (m = o ? f : `${u}px`, h = `${-c}px`) : d === "top" ? (m = o ? f : `${u}px`, h = `${a.floating.height + c}px`) : d === "right" ? (m = `${-c}px`, h = o ? f : `${y}px`) : d === "left" && (m = `${a.floating.width + c}px`, h = o ? f : `${y}px`), { data: { x: m, y: h } };
  }
});
function qn(e) {
  const [t, r = "center"] = e.split("-");
  return [t, r];
}
var Ac = Un, Pc = Zn, Oc = Gn, Nc = Yn, Hc = "VisuallyHidden", Kn = p.forwardRef(
  (e, t) => /* @__PURE__ */ s(
    G.span,
    {
      ...e,
      ref: t,
      style: {
        // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
        position: "absolute",
        border: 0,
        width: 1,
        height: 1,
        padding: 0,
        margin: -1,
        overflow: "hidden",
        clip: "rect(0, 0, 0, 0)",
        whiteSpace: "nowrap",
        wordWrap: "normal",
        ...e.style
      }
    }
  )
);
Kn.displayName = Hc;
var Ic = Kn, [Tt, Ed] = or("Tooltip", [
  Bn
]), At = Bn(), Xn = "TooltipProvider", Dc = 700, er = "tooltip.open", [Mc, Rr] = Tt(Xn), Qn = (e) => {
  const {
    __scopeTooltip: t,
    delayDuration: r = Dc,
    skipDelayDuration: a = 300,
    disableHoverableContent: n = !1,
    children: i
  } = e, [o, l] = p.useState(!0), c = p.useRef(!1), d = p.useRef(0);
  return p.useEffect(() => {
    const g = d.current;
    return () => window.clearTimeout(g);
  }, []), /* @__PURE__ */ s(
    Mc,
    {
      scope: t,
      isOpenDelayed: o,
      delayDuration: r,
      onOpen: p.useCallback(() => {
        window.clearTimeout(d.current), l(!1);
      }, []),
      onClose: p.useCallback(() => {
        window.clearTimeout(d.current), d.current = window.setTimeout(
          () => l(!0),
          a
        );
      }, [a]),
      isPointerInTransitRef: c,
      onPointerInTransitChange: p.useCallback((g) => {
        c.current = g;
      }, []),
      disableHoverableContent: n,
      children: i
    }
  );
};
Qn.displayName = Xn;
var Pt = "Tooltip", [_c, rt] = Tt(Pt), Jn = (e) => {
  const {
    __scopeTooltip: t,
    children: r,
    open: a,
    defaultOpen: n = !1,
    onOpenChange: i,
    disableHoverableContent: o,
    delayDuration: l
  } = e, c = Rr(Pt, e.__scopeTooltip), d = At(t), [g, f] = p.useState(null), u = pt(), y = p.useRef(0), m = o ?? c.disableHoverableContent, h = l ?? c.delayDuration, v = p.useRef(!1), [b = !1, C] = lr({
    prop: a,
    defaultProp: n,
    onChange: (E) => {
      E ? (c.onOpen(), document.dispatchEvent(new CustomEvent(er))) : c.onClose(), i == null || i(E);
    }
  }), S = p.useMemo(() => b ? v.current ? "delayed-open" : "instant-open" : "closed", [b]), x = p.useCallback(() => {
    window.clearTimeout(y.current), y.current = 0, v.current = !1, C(!0);
  }, [C]), w = p.useCallback(() => {
    window.clearTimeout(y.current), y.current = 0, C(!1);
  }, [C]), k = p.useCallback(() => {
    window.clearTimeout(y.current), y.current = window.setTimeout(() => {
      v.current = !0, C(!0), y.current = 0;
    }, h);
  }, [h, C]);
  return p.useEffect(() => () => {
    y.current && (window.clearTimeout(y.current), y.current = 0);
  }, []), /* @__PURE__ */ s(Ac, { ...d, children: /* @__PURE__ */ s(
    _c,
    {
      scope: t,
      contentId: u,
      open: b,
      stateAttribute: S,
      trigger: g,
      onTriggerChange: f,
      onTriggerEnter: p.useCallback(() => {
        c.isOpenDelayed ? k() : x();
      }, [c.isOpenDelayed, k, x]),
      onTriggerLeave: p.useCallback(() => {
        m ? w() : (window.clearTimeout(y.current), y.current = 0);
      }, [w, m]),
      onOpen: x,
      onClose: w,
      disableHoverableContent: m,
      children: r
    }
  ) });
};
Jn.displayName = Pt;
var tr = "TooltipTrigger", ei = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...a } = e, n = rt(tr, r), i = Rr(tr, r), o = At(r), l = p.useRef(null), c = ae(t, l, n.onTriggerChange), d = p.useRef(!1), g = p.useRef(!1), f = p.useCallback(() => d.current = !1, []);
    return p.useEffect(() => () => document.removeEventListener("pointerup", f), [f]), /* @__PURE__ */ s(Pc, { asChild: !0, ...o, children: /* @__PURE__ */ s(
      G.button,
      {
        "aria-describedby": n.open ? n.contentId : void 0,
        "data-state": n.stateAttribute,
        ...a,
        ref: c,
        onPointerMove: Z(e.onPointerMove, (u) => {
          u.pointerType !== "touch" && !g.current && !i.isPointerInTransitRef.current && (n.onTriggerEnter(), g.current = !0);
        }),
        onPointerLeave: Z(e.onPointerLeave, () => {
          n.onTriggerLeave(), g.current = !1;
        }),
        onPointerDown: Z(e.onPointerDown, () => {
          d.current = !0, document.addEventListener("pointerup", f, { once: !0 });
        }),
        onFocus: Z(e.onFocus, () => {
          d.current || n.onOpen();
        }),
        onBlur: Z(e.onBlur, n.onClose),
        onClick: Z(e.onClick, n.onClose)
      }
    ) });
  }
);
ei.displayName = tr;
var zr = "TooltipPortal", [$c, Bc] = Tt(zr, {
  forceMount: void 0
}), ti = (e) => {
  const { __scopeTooltip: t, forceMount: r, children: a, container: n } = e, i = rt(zr, t);
  return /* @__PURE__ */ s($c, { scope: t, forceMount: r, children: /* @__PURE__ */ s($e, { present: r || i.open, children: /* @__PURE__ */ s(wa, { asChild: !0, container: n, children: a }) }) });
};
ti.displayName = zr;
var Me = "TooltipContent", ri = p.forwardRef(
  (e, t) => {
    const r = Bc(Me, e.__scopeTooltip), { forceMount: a = r.forceMount, side: n = "top", ...i } = e, o = rt(Me, e.__scopeTooltip);
    return /* @__PURE__ */ s($e, { present: a || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ s(ai, { side: n, ...i, ref: t }) : /* @__PURE__ */ s(Wc, { side: n, ...i, ref: t }) });
  }
), Wc = p.forwardRef((e, t) => {
  const r = rt(Me, e.__scopeTooltip), a = Rr(Me, e.__scopeTooltip), n = p.useRef(null), i = ae(t, n), [o, l] = p.useState(null), { trigger: c, onClose: d } = r, g = n.current, { onPointerInTransitChange: f } = a, u = p.useCallback(() => {
    l(null), f(!1);
  }, [f]), y = p.useCallback(
    (m, h) => {
      const v = m.currentTarget, b = { x: m.clientX, y: m.clientY }, C = Zc(b, v.getBoundingClientRect()), S = Gc(b, C), x = jc(h.getBoundingClientRect()), w = qc([...S, ...x]);
      l(w), f(!0);
    },
    [f]
  );
  return p.useEffect(() => () => u(), [u]), p.useEffect(() => {
    if (c && g) {
      const m = (v) => y(v, g), h = (v) => y(v, c);
      return c.addEventListener("pointerleave", m), g.addEventListener("pointerleave", h), () => {
        c.removeEventListener("pointerleave", m), g.removeEventListener("pointerleave", h);
      };
    }
  }, [c, g, y, u]), p.useEffect(() => {
    if (o) {
      const m = (h) => {
        const v = h.target, b = { x: h.clientX, y: h.clientY }, C = (c == null ? void 0 : c.contains(v)) || (g == null ? void 0 : g.contains(v)), S = !Yc(b, o);
        C ? u() : S && (u(), d());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [c, g, o, d, u]), /* @__PURE__ */ s(ai, { ...e, ref: i });
}), [Uc, Vc] = Tt(Pt, { isInside: !1 }), ai = p.forwardRef(
  (e, t) => {
    const {
      __scopeTooltip: r,
      children: a,
      "aria-label": n,
      onEscapeKeyDown: i,
      onPointerDownOutside: o,
      ...l
    } = e, c = rt(Me, r), d = At(r), { onClose: g } = c;
    return p.useEffect(() => (document.addEventListener(er, g), () => document.removeEventListener(er, g)), [g]), p.useEffect(() => {
      if (c.trigger) {
        const f = (u) => {
          const y = u.target;
          y != null && y.contains(c.trigger) && g();
        };
        return window.addEventListener("scroll", f, { capture: !0 }), () => window.removeEventListener("scroll", f, { capture: !0 });
      }
    }, [c.trigger, g]), /* @__PURE__ */ s(
      cr,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: i,
        onPointerDownOutside: o,
        onFocusOutside: (f) => f.preventDefault(),
        onDismiss: g,
        children: /* @__PURE__ */ L(
          Oc,
          {
            "data-state": c.stateAttribute,
            ...d,
            ...l,
            ref: t,
            style: {
              ...l.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ s(va, { children: a }),
              /* @__PURE__ */ s(Uc, { scope: r, isInside: !0, children: /* @__PURE__ */ s(Ic, { id: c.contentId, role: "tooltip", children: n || a }) })
            ]
          }
        )
      }
    );
  }
);
ri.displayName = Me;
var ni = "TooltipArrow", ii = p.forwardRef(
  (e, t) => {
    const { __scopeTooltip: r, ...a } = e, n = At(r);
    return Vc(
      ni,
      r
    ).isInside ? null : /* @__PURE__ */ s(Nc, { ...n, ...a, ref: t });
  }
);
ii.displayName = ni;
function Zc(e, t) {
  const r = Math.abs(t.top - e.y), a = Math.abs(t.bottom - e.y), n = Math.abs(t.right - e.x), i = Math.abs(t.left - e.x);
  switch (Math.min(r, a, n, i)) {
    case i:
      return "left";
    case n:
      return "right";
    case r:
      return "top";
    case a:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function Gc(e, t, r = 5) {
  const a = [];
  switch (t) {
    case "top":
      a.push(
        { x: e.x - r, y: e.y + r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "bottom":
      a.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x + r, y: e.y - r }
      );
      break;
    case "left":
      a.push(
        { x: e.x + r, y: e.y - r },
        { x: e.x + r, y: e.y + r }
      );
      break;
    case "right":
      a.push(
        { x: e.x - r, y: e.y - r },
        { x: e.x - r, y: e.y + r }
      );
      break;
  }
  return a;
}
function jc(e) {
  const { top: t, right: r, bottom: a, left: n } = e;
  return [
    { x: n, y: t },
    { x: r, y: t },
    { x: r, y: a },
    { x: n, y: a }
  ];
}
function Yc(e, t) {
  const { x: r, y: a } = e;
  let n = !1;
  for (let i = 0, o = t.length - 1; i < t.length; o = i++) {
    const l = t[i].x, c = t[i].y, d = t[o].x, g = t[o].y;
    c > a != g > a && r < (d - l) * (a - c) / (g - c) + l && (n = !n);
  }
  return n;
}
function qc(e) {
  const t = e.slice();
  return t.sort((r, a) => r.x < a.x ? -1 : r.x > a.x ? 1 : r.y < a.y ? -1 : r.y > a.y ? 1 : 0), Kc(t);
}
function Kc(e) {
  if (e.length <= 1) return e.slice();
  const t = [];
  for (let a = 0; a < e.length; a++) {
    const n = e[a];
    for (; t.length >= 2; ) {
      const i = t[t.length - 1], o = t[t.length - 2];
      if ((i.x - o.x) * (n.y - o.y) >= (i.y - o.y) * (n.x - o.x)) t.pop();
      else break;
    }
    t.push(n);
  }
  t.pop();
  const r = [];
  for (let a = e.length - 1; a >= 0; a--) {
    const n = e[a];
    for (; r.length >= 2; ) {
      const i = r[r.length - 1], o = r[r.length - 2];
      if ((i.x - o.x) * (n.y - o.y) >= (i.y - o.y) * (n.x - o.x)) r.pop();
      else break;
    }
    r.push(n);
  }
  return r.pop(), t.length === 1 && r.length === 1 && t[0].x === r[0].x && t[0].y === r[0].y ? t : t.concat(r);
}
var Xc = Qn, Qc = Jn, Jc = ei, ed = ti, td = ri, rd = ii, ad = "_54npjm0", nd = "_54npjm1", id = "_54npjm2", od = "_54npjm3";
function ld(e) {
  const [t, r] = pe.useState(!!e);
  return Re(() => {
    r(!!e);
  }, [e]), {
    open: t,
    triggerProps: e === void 0 ? {
      onMouseEnter: () => {
        r(!0);
      },
      onMouseLeave: () => {
        r(!1);
      },
      onFocus: () => {
        r(!0);
      },
      onBlur: (a) => {
        const n = a.currentTarget;
        requestAnimationFrame(() => {
          n.contains(document.activeElement) || r(!1);
        });
      }
    } : void 0
  };
}
const la = ({ children: e }) => L(td, { className: nd, children: [e, s(rd, { className: id })] }), sd = pe.forwardRef(function({ trigger: e, open: t, testId: r, className: a, portalElement: n, children: i, ...o }, l) {
  const c = ld(t);
  return s(Xc, { children: s("div", { ref: l, "data-testid": r, className: ad, ...c.triggerProps, children: L(Qc, { open: c.open, children: [s(Jc, { type: "button", className: Q(od, a), children: e }), i && (n ? s(ed, { container: n, children: s(la, { children: i }) }) : s(la, { children: i }))] }) }) });
}), oi = ({
  trigger: e,
  isVisible: t,
  onHoverOff: r,
  testId: a,
  children: n
}) => /* @__PURE__ */ s("div", { onMouseLeave: r, onBlur: r, children: /* @__PURE__ */ s(sd, { trigger: e, testId: a, children: t && n }) });
var cd = "_12afbes0", dd = "_12afbes1";
const pd = "Action could not be completed. Please try again later", li = ({ text: e, hasError: t, link: r }) => {
  const { locale: a } = J(), n = (i) => {
    i.preventDefault(), Ei.tooltipFavoritesDashboardLink({
      country: a.country,
      currency: a.currency,
      language: a.code.split("_")[0]
    }), window.location.href = i.currentTarget.href;
  };
  return /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s("span", { className: cd, children: t ? pd : e }),
    r && !t && /* @__PURE__ */ s("a", { href: r.href, className: dd, onClick: n, children: r.label })
  ] });
}, Ld = ({
  id: e,
  size: t,
  testId: r,
  className: a,
  onChange: n
}) => {
  const { itineraryService: i, dictionary: o, variation: l, locale: c } = J(), { isLoggedIn: d, authenticateUser: g } = Be(), [f, u] = A(!1), [y, m] = A(!1), [h, v] = A(!1);
  Re(() => {
    i.getFavorites().then((x) => u(!!x[e.toLowerCase()]));
  }, [e, i, d]);
  const b = _(async () => {
    try {
      if (f)
        await i.removeFavoriteItinerary(e);
      else {
        if (l === B.REDESIGN && !d && !await g())
          return;
        await i.addFavoriteItinerary(e);
      }
      u((x) => !x), n && n({ isSaved: !f });
    } catch (x) {
      if (x instanceof Ce && x.statusCode === 409) {
        v(!0), W.favoritesReachedLimit(c);
        return;
      }
      if (x instanceof Ce && x.statusCode === 428) {
        await g("limit-reached") && (await i.addFavoriteItinerary(e), u((k) => !k));
        return;
      }
      m(!0), console.error(`Error ${f ? "removing" : "adding"} sailing to user favorites`, {
        id: e,
        error: x
      });
    }
  }, [g, e, d, f, i, n, l, c]), C = _(() => {
    m(!1);
  }, []), S = _(() => {
    v(!1);
  }, []);
  return l === void 0 ? null : /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s(Fn, { open: h, onClose: S, testId: "limit-favorites-modal" }),
    /* @__PURE__ */ s(
      oi,
      {
        isVisible: !0,
        onHoverOff: C,
        trigger: /* @__PURE__ */ s(
          zn,
          {
            isSaved: f,
            onClick: b,
            variant: kt.Icon,
            size: t,
            className: a,
            testId: r,
            dataId: f ? "itinerary-save-cruise-button-selected" : "itinerary-save-cruise-button-unselected"
          }
        ),
        "test-id": "save-this-itinerary-tooltip",
        children: /* @__PURE__ */ s(
          li,
          {
            text: f ? o.labelSavedFavoritesTooltip : o.labelUnsavedItineraryTooltip,
            hasError: y,
            link: f ? {
              label: o.actionFavorites,
              href: "/favorites"
            } : void 0
          }
        )
      }
    )
  ] });
}, gd = 25, fd = ({ variation: e, isSaved: t, dictionary: r }) => t ? r.labelSavedFavoritesTooltip : e === B.LEGACY ? r.labelUnsavedStateroomTooltipLegacy : r.labelUnsavedStateroomTooltip, kd = ({
  itineraryId: e,
  sailingId: t,
  stateroom: r,
  testId: a,
  className: n,
  onChange: i
}) => {
  const { itineraryService: o, dictionary: l, variation: c, locale: d } = J(), { isLoggedIn: g, authenticateUser: f } = Be(), [u, y] = A(!1), [m, h] = A(!1), [v, b] = A(!1), C = o.getStateroomKey(t, r.type), S = r.price === null || r.price === void 0;
  Re(() => {
    o.getFavorites().then((E) => y(!!E[C]));
  }, [C, o, t, g]);
  const x = _(async () => {
    if (!S)
      try {
        if (u)
          await o.removeFavoriteStateroom(t, C);
        else {
          if (!g && !await f(void 0, c === B.LEGACY))
            return;
          await o.addFavoriteStateroom(e, t, r);
        }
        y((E) => !E), i && i({ isSaved: !u });
      } catch (E) {
        if (E instanceof Ce && E.statusCode === 409) {
          b(!0), W.favoritesReachedLimit(d);
          return;
        }
        h(!0), console.error(`Error ${u ? "removing" : "adding"} sailing to user favorites`, {
          itineraryId: e,
          sailingId: t,
          stateroom: r,
          error: E
        });
      }
  }, [
    u,
    d,
    i,
    o,
    t,
    C,
    g,
    e,
    r,
    f,
    S,
    c
  ]), w = _(() => {
    h(!1);
  }, []), k = _(() => {
    b(!1);
  }, []);
  return c === void 0 ? null : /* @__PURE__ */ L(K, { children: [
    /* @__PURE__ */ s(
      Fn,
      {
        open: v,
        onClose: k,
        testId: "limit-favorites-modal",
        isStateroom: !0
      }
    ),
    /* @__PURE__ */ s(
      oi,
      {
        isVisible: !S,
        onHoverOff: w,
        trigger: /* @__PURE__ */ s(
          zn,
          {
            isSaved: u,
            onClick: x,
            variant: kt.WithText,
            hideIcon: c === B.LEGACY,
            text: {
              saved: c === B.REDESIGN ? l.labelSavedStateroomText : l.labelSavedStateroomTextLegacy,
              unsaved: c === B.REDESIGN ? l.labelUnsavedStateroomText : l.labelUnsavedStateroomTextLegacy,
              hover: c === B.REDESIGN ? l.labelSavedStateroomHoverText : l.labelSavedStateroomHoverTextLegacy
            },
            size: gd,
            className: n,
            testId: a,
            dataId: u ? "sailing-save-cruise-button-selected" : "sailing-save-cruise-button-unselected",
            isDisabled: S
          }
        ),
        "test-id": "save-this-sailing-tooltip",
        children: /* @__PURE__ */ s(
          li,
          {
            text: fd({
              dictionary: {
                labelSavedFavoritesTooltip: l.labelSavedFavoritesTooltip,
                labelUnsavedStateroomTooltip: l.labelUnsavedStateroomTooltip,
                labelUnsavedStateroomTooltipLegacy: l.labelUnsavedStateroomTooltipLegacy
              },
              isSaved: u,
              variation: c
            }),
            hasError: m,
            link: u ? {
              label: c === B.REDESIGN ? l.actionFavorites : l.actionWatchlistLegacy,
              href: c === B.REDESIGN ? "/favorites" : "/watchlist"
            } : void 0
          }
        )
      }
    )
  ] });
};
export {
  us as AuthenticationModal,
  da as Environment,
  Ld as FavoriteItineraryButton,
  kd as FavoriteSailingButton,
  wd as FavoritesProvider,
  Ci as StateroomType,
  Be as useAuthenticationContext
};
//# sourceMappingURL=index.es.js.map
